{
  "level": "q314",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q314",
    "objects": "AREAS.E3:q314.e3",
    "mesh": "TREES.E3:q314.e3"
  },
  "spawn_point": {
    "position": [
      -24.691447124685332,
      1180.8403057223315,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -24.691447124685332,
      1280.8403057223315,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6860.8203125,
      -4547.06494140625,
      -300.0
    ],
    "bbox_max": [
      6697.86181640625,
      7450.0,
      2107.316162109375
    ],
    "vertex_count": 1939,
    "vertices": [
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839162826538086
      ],
      [
        -6860.8203125,
        2699.5234375,
        1640.001220703125
      ],
      [
        -6764.20263671875,
        2844.1220703125,
        1584.5428466796875
      ],
      [
        -6561.474609375,
        2100.0,
        1612.981689453125
      ],
      [
        -4904.1279296875,
        2100.0,
        1004.5435791015625
      ],
      [
        -3400.0,
        2790.776611328125,
        80.8882064819336
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -4110.0,
        2100.0,
        -300.0
      ],
      [
        -3400.0,
        2774.09521484375,
        -300.0
      ],
      [
        -3400.0,
        2568.059326171875,
        -300.0
      ],
      [
        -4002.859619140625,
        2100.0,
        -300.0
      ],
      [
        -3989.468505859375,
        2110.39697265625,
        -300.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83917236328125
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -4896.1435546875,
        2100.0,
        987.7515258789062
      ],
      [
        -4088.928466796875,
        2100.0,
        0.0
      ],
      [
        -4088.928466796875,
        2100.0,
        0.0
      ],
      [
        -3988.3173828125,
        2100.0,
        -300.0
      ],
      [
        -3988.3173828125,
        2100.0,
        -300.0
      ],
      [
        -3989.468505859375,
        2110.396728515625,
        -300.0
      ],
      [
        -3843.76123046875,
        2100.0,
        -300.0
      ],
      [
        -3856.354736328125,
        2213.74609375,
        -300.0
      ],
      [
        -3400.0,
        2100.0,
        -300.0
      ],
      [
        -4896.1435546875,
        2100.0,
        987.7515258789062
      ],
      [
        -4897.6552734375,
        2100.0,
        1002.1674194335938
      ],
      [
        -4897.80810546875,
        2100.0,
        1003.6253662109375
      ],
      [
        -3400.0,
        6409.3681640625,
        976.300048828125
      ],
      [
        -3400.0,
        6409.3681640625,
        -22.699951171875
      ],
      [
        -3400.0,
        2993.050048828125,
        426.8134765625
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -4897.6552734375,
        2100.0,
        1002.1674194335938
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -4205.00048828125,
        -2619.4462890625,
        1400.274658203125
      ],
      [
        -3461.156005859375,
        -4521.4228515625,
        1390.116943359375
      ],
      [
        -3400.0,
        -4452.255859375,
        1098.934814453125
      ],
      [
        -3400.0,
        -4540.619140625,
        1370.3192138671875
      ],
      [
        -3507.62353515625,
        -3010.139404296875,
        -300.0
      ],
      [
        -3510.67529296875,
        -3004.92626953125,
        -300.0
      ],
      [
        -3400.0,
        -3016.45166015625,
        -300.0
      ],
      [
        -3622.3681640625,
        -2165.83447265625,
        -300.0
      ],
      [
        -3581.70458984375,
        -2239.811279296875,
        -300.0
      ],
      [
        -3400.0,
        -2908.416015625,
        -300.0
      ],
      [
        -3412.67578125,
        -3448.20703125,
        1220.0
      ],
      [
        -3411.630126953125,
        -3453.730224609375,
        1224.3428955078125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3642.105224609375,
        -2017.5599365234375,
        -300.0
      ],
      [
        -3756.713134765625,
        8.120121955871582,
        -300.0
      ],
      [
        -3921.887939453125,
        1500.0,
        -300.0
      ],
      [
        -3921.887939453125,
        1500.0,
        -300.0
      ],
      [
        -3988.3173828125,
        2100.0,
        -300.0
      ],
      [
        -3756.713134765625,
        8.120128631591797,
        -300.0
      ],
      [
        -3457.047119140625,
        -2698.50390625,
        -300.0
      ],
      [
        -3613.51416015625,
        20.37681770324707,
        -300.0
      ],
      [
        -3777.331787109375,
        1500.0,
        -300.0
      ],
      [
        -3777.331787109375,
        1500.0,
        -300.0
      ],
      [
        -3843.76123046875,
        2100.0,
        -300.0
      ],
      [
        -3613.51416015625,
        20.376829147338867,
        -300.0
      ],
      [
        -3400.0,
        -1908.1121826171875,
        -300.0
      ],
      [
        -3400.0,
        -2350.41748046875,
        -300.0
      ],
      [
        -3400.0,
        -2382.8056640625,
        -235.68954467773438
      ],
      [
        -3400.0,
        38.65192794799805,
        -300.0
      ],
      [
        -3400.0,
        1500.0,
        -300.0
      ],
      [
        -3400.0,
        1500.0,
        -300.0
      ],
      [
        -3400.0,
        38.651947021484375,
        -300.0
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -3605.181640625,
        -2269.120849609375,
        0.0
      ],
      [
        -3605.1806640625,
        -2269.11083984375,
        -0.0221405029296875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3403.804931640625,
        -3443.09521484375,
        1220.0
      ],
      [
        -3400.0,
        -2501.514404296875,
        0.0
      ],
      [
        -3400.0,
        -2699.58935546875,
        585.6629638671875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3400.0,
        -2737.88818359375,
        716.9644165039062
      ],
      [
        -3400.0,
        -2730.576416015625,
        935.9595336914062
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3400.0,
        -2730.576416015625,
        935.9595336914062
      ],
      [
        -3400.0,
        -2736.080078125,
        1120.869140625
      ],
      [
        -3400.0,
        -2501.50439453125,
        0.0
      ],
      [
        -3400.0,
        -2737.88818359375,
        716.9644165039062
      ],
      [
        -3400.0,
        -2699.58935546875,
        585.6629638671875
      ],
      [
        -3400.0,
        -4547.06494140625,
        1390.1160888671875
      ],
      [
        -3400.0,
        -3594.320556640625,
        1328.766845703125
      ],
      [
        -3400.0,
        -3618.565185546875,
        1409.2655029296875
      ],
      [
        -3400.0,
        -3515.1591796875,
        1272.6448974609375
      ],
      [
        -3400.0,
        -3594.320556640625,
        1328.766845703125
      ],
      [
        -3411.630126953125,
        -3453.730224609375,
        1224.3428955078125
      ],
      [
        -3725.157958984375,
        -2329.201904296875,
        1299.860595703125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3697.797607421875,
        -2384.524658203125,
        1182.3106689453125
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3697.797607421875,
        -2384.524658203125,
        1182.3106689453125
      ],
      [
        -3702.4501953125,
        -2378.303466796875,
        1210.558349609375
      ],
      [
        -3702.4501953125,
        -2378.303466796875,
        1210.558349609375
      ],
      [
        -3703.80126953125,
        -2376.974365234375,
        1220.0
      ],
      [
        -3400.0,
        -2739.030517578125,
        1220.0
      ],
      [
        -3400.0,
        -3440.902587890625,
        1220.0
      ],
      [
        4150.62451171875,
        1343.3211669921875,
        834.5104370117188
      ],
      [
        4150.75,
        1339.7322998046875,
        833.3546142578125
      ],
      [
        5334.2890625,
        3003.082275390625,
        1538.259033203125
      ],
      [
        6697.86181640625,
        4175.6806640625,
        2107.316162109375
      ],
      [
        6202.4013671875,
        3724.434814453125,
        1892.318603515625
      ],
      [
        5574.01171875,
        5224.01171875,
        727.609130859375
      ],
      [
        5240.630859375,
        5446.76953125,
        -22.699951171875
      ],
      [
        4081.29052734375,
        4137.17724609375,
        -256.76629638671875
      ],
      [
        4120.587890625,
        4226.46826171875,
        -300.0
      ],
      [
        4081.29052734375,
        4137.17724609375,
        -256.76629638671875
      ],
      [
        4096.705078125,
        2887.37451171875,
        959.0196533203125
      ],
      [
        4089.31982421875,
        3098.861083984375,
        938.4326782226562
      ],
      [
        5334.2890625,
        3003.082275390625,
        1538.259033203125
      ],
      [
        6202.4013671875,
        3724.434814453125,
        1892.318603515625
      ],
      [
        4117.16162109375,
        2301.5830078125,
        1016.0430908203125
      ],
      [
        4119.01025390625,
        2248.64404296875,
        1015.1317138671875
      ],
      [
        4118.2841796875,
        2269.442626953125,
        1019.1718139648438
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4117.16162109375,
        2301.583251953125,
        1016.0430908203125
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.46170425415039
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990966796875
      ],
      [
        3956.501220703125,
        6902.2900390625,
        1318.467529296875
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.19913482666016
      ],
      [
        4128.3447265625,
        6189.9755859375,
        976.300048828125
      ],
      [
        3977.864501953125,
        6290.52294921875,
        -22.699951171875
      ],
      [
        3977.864501953125,
        6290.52294921875,
        919.1775512695312
      ],
      [
        4133.48828125,
        4368.36962890625,
        -300.0
      ],
      [
        4023.4130859375,
        4986.189453125,
        -69.49503326416016
      ],
      [
        4032.37158203125,
        4729.65087890625,
        -114.25382995605469
      ],
      [
        3977.864501953125,
        6290.52294921875,
        976.300048828125
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.461669921875
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4043.345947265625,
        4415.38427734375,
        -169.08460998535156
      ],
      [
        4043.345947265625,
        4415.38427734375,
        -169.08460998535156
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.04345703125,
        933.06103515625
      ],
      [
        4059.008056640625,
        3966.878662109375,
        0.0
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.043701171875,
        933.0609741210938
      ],
      [
        4137.6171875,
        1715.807373046875,
        911.6276245117188
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.83790969848633
      ],
      [
        228.268310546875,
        5028.201171875,
        -58.07283020019531
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        3977.864501953125,
        6290.52294921875,
        385.8159484863281
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      [
        231.0294647216797,
        7173.888671875,
        -300.0
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        100.0,
        7430.10888671875,
        -22.699951171875
      ],
      [
        100.0,
        7430.10888671875,
        673.5613403320312
      ],
      [
        100.0,
        7265.8046875,
        0.0
      ],
      [
        100.0,
        7165.60498046875,
        -300.0
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        3978.369140625,
        4957.15869140625,
        -10.697733879089355
      ],
      [
        3979.6884765625,
        4946.3798828125,
        -13.885726928710938
      ],
      [
        4025.732177734375,
        4919.77783203125,
        -81.08197021484375
      ],
      [
        4042.8125,
        4430.66259765625,
        -166.41896057128906
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.46458435058594
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1254272460938
      ],
      [
        3170.04638671875,
        6830.28955078125,
        612.5288696289062
      ],
      [
        3977.864501953125,
        6290.52294921875,
        474.2994384765625
      ],
      [
        3987.487060546875,
        4882.6669921875,
        -32.730072021484375
      ],
      [
        4000.447998046875,
        4954.3212890625,
        24.796052932739258
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464569091796875
      ],
      [
        4000.447998046875,
        4954.3212890625,
        24.79603385925293
      ],
      [
        3999.897216796875,
        4949.3115234375,
        23.076147079467773
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1254272460938
      ],
      [
        3052.0458984375,
        6882.69287109375,
        549.7059936523438
      ],
      [
        3956.67236328125,
        4948.55078125,
        -13.543863296508789
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        816.3768920898438,
        7327.39501953125,
        652.46484375
      ],
      [
        3018.31005859375,
        6889.4033203125,
        624.2333984375
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9073486328125
      ],
      [
        3163.70068359375,
        6834.52978515625,
        610.1199951171875
      ],
      [
        4019.882080078125,
        4618.00146484375,
        -111.00988006591797
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        4040.075439453125,
        4509.04150390625,
        -123.25544738769531
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784301757812
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        3963.516845703125,
        6701.3896484375,
        1187.3433837890625
      ],
      [
        3156.055419921875,
        6862.00390625,
        622.4673461914062
      ],
      [
        4020.44775390625,
        5071.1044921875,
        123.28406524658203
      ],
      [
        3956.206787109375,
        5048.34375,
        54.11053466796875
      ],
      [
        3977.864501953125,
        6290.52294921875,
        919.1775512695312
      ],
      [
        3170.04638671875,
        6830.28955078125,
        612.5288696289062
      ],
      [
        100.0,
        7430.10888671875,
        976.300048828125
      ],
      [
        3977.445068359375,
        5000.2041015625,
        39.02478790283203
      ],
      [
        3986.29150390625,
        5059.0029296875,
        86.50531005859375
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.73223876953125
      ],
      [
        -1165.5225830078125,
        7178.380859375,
        976.300048828125
      ],
      [
        -248.8677978515625,
        4693.4443359375,
        0.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.732234954833984
      ],
      [
        -2778.40673828125,
        6824.70361328125,
        -22.699951171875
      ],
      [
        -109.37823486328125,
        7252.56787109375,
        0.0
      ],
      [
        69.84530639648438,
        7163.69873046875,
        -300.0
      ],
      [
        -475.55438232421875,
        3864.445068359375,
        0.0
      ],
      [
        -619.7982788085938,
        3851.8251953125,
        150.0
      ],
      [
        4087.113037109375,
        3162.052001953125,
        924.3251953125
      ],
      [
        2923.153076171875,
        1830.0,
        239.58474731445312
      ],
      [
        2917.732666015625,
        1985.22265625,
        228.48062133789062
      ],
      [
        2878.090087890625,
        3120.435546875,
        137.21926879882812
      ],
      [
        2889.345947265625,
        2798.10986328125,
        170.32931518554688
      ],
      [
        2889.345947265625,
        2798.10986328125,
        170.32931518554688
      ],
      [
        2200.0,
        -2834.78271484375,
        1830.86083984375
      ],
      [
        2200.0,
        -2087.5,
        1121.050048828125
      ],
      [
        2200.0,
        -1998.5714111328125,
        1003.154296875
      ],
      [
        2200.0,
        -2087.5,
        1121.050048828125
      ],
      [
        -1739.068359375,
        -2556.84375,
        -300.0
      ],
      [
        -1791.9246826171875,
        -2599.128662109375,
        -300.0
      ],
      [
        -1502.348388671875,
        -2413.1201171875,
        0.0
      ],
      [
        -1074.7418212890625,
        -2798.138916015625,
        1382.2545166015625
      ],
      [
        -1502.348388671875,
        -2413.1201171875,
        0.0
      ],
      [
        -1576.8857421875,
        -2346.006103515625,
        -300.0
      ],
      [
        -1806.8818359375,
        -2604.802001953125,
        -300.0
      ],
      [
        -1850.090087890625,
        -2621.19140625,
        -300.0
      ],
      [
        -2870.09521484375,
        -2950.57421875,
        -300.0
      ],
      [
        -1074.7418212890625,
        -2798.138916015625,
        1382.2545166015625
      ],
      [
        -1016.7769165039062,
        -2850.33056640625,
        1659.98291015625
      ],
      [
        -1288.892333984375,
        -1953.526123046875,
        -300.0
      ],
      [
        477.5139465332031,
        -3695.77197265625,
        1852.5999755859375
      ],
      [
        -724.7740478515625,
        -1709.192626953125,
        200.32070922851562
      ],
      [
        -1147.1422119140625,
        -1769.62939453125,
        0.0
      ],
      [
        -1147.1422119140625,
        -1769.62939453125,
        0.0
      ],
      [
        -1181.6776123046875,
        -1476.3109130859375,
        -285.97052001953125
      ],
      [
        -1181.6776123046875,
        -1476.3109130859375,
        -285.97052001953125
      ],
      [
        -765.7088012695312,
        -1336.22705078125,
        -300.0
      ],
      [
        -970.3532104492188,
        -1441.2398681640625,
        -190.11154174804688
      ],
      [
        -1110.6920166015625,
        -1599.812744140625,
        0.0
      ],
      [
        -1055.3487548828125,
        -1661.628173828125,
        89.88299560546875
      ],
      [
        -1055.3487548828125,
        -1661.628173828125,
        89.88300323486328
      ],
      [
        -724.7740478515625,
        -1709.192626953125,
        200.3207244873047
      ],
      [
        -1110.6920166015625,
        -1599.812744140625,
        0.0
      ],
      [
        -1129.8388671875,
        -1523.07958984375,
        -104.47206115722656
      ],
      [
        -1129.8388671875,
        -1523.07958984375,
        -104.47206115722656
      ],
      [
        -279.618896484375,
        -1127.742431640625,
        -300.0
      ],
      [
        -970.3532104492188,
        -1441.2398681640625,
        -190.11154174804688
      ],
      [
        64.31683349609375,
        -1071.06201171875,
        0.0
      ],
      [
        571.793701171875,
        -1133.334716796875,
        96.11875915527344
      ],
      [
        64.31683349609375,
        -1071.06201171875,
        0.0
      ],
      [
        502.19775390625,
        -759.136474609375,
        -264.3855895996094
      ],
      [
        -200.0,
        480.0,
        80.0
      ],
      [
        -200.0,
        500.0,
        80.0
      ],
      [
        -200.0,
        500.0,
        80.0
      ],
      [
        -200.0,
        500.0,
        78.0
      ],
      [
        -200.0,
        470.0,
        120.0
      ],
      [
        -200.0,
        470.0,
        140.0
      ],
      [
        -200.0,
        455.0,
        140.0
      ],
      [
        -200.0,
        280.0,
        140.0
      ],
      [
        -200.0,
        470.0,
        140.0
      ],
      [
        -200.0,
        455.0,
        140.0
      ],
      [
        -200.0,
        470.0,
        120.0
      ],
      [
        -200.0,
        460.0,
        110.0
      ],
      [
        -155.0,
        470.0,
        300.0
      ],
      [
        -155.0,
        470.0,
        350.0
      ],
      [
        137.4235076904297,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        160.0
      ],
      [
        250.98464965820312,
        690.0,
        160.0
      ],
      [
        137.42349243164062,
        690.0,
        160.0
      ],
      [
        250.98464965820312,
        690.0,
        160.0
      ],
      [
        254.0325927734375,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.42349243164062,
        690.0,
        280.0
      ],
      [
        250.98464965820312,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.42349243164062,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.4235076904297,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        420.0
      ],
      [
        254.0325927734375,
        650.0,
        350.0
      ],
      [
        -100.0,
        650.0,
        350.0
      ],
      [
        -100.0,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        280.0
      ],
      [
        254.0325927734375,
        650.0,
        280.0
      ],
      [
        -100.0,
        650.0,
        280.0
      ],
      [
        -100.0,
        690.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        230.0
      ],
      [
        228.09024047851562,
        690.0,
        230.0
      ],
      [
        228.09024047851562,
        690.0,
        230.0
      ],
      [
        250.98464965820312,
        690.0,
        230.0
      ],
      [
        137.42349243164062,
        690.0,
        230.0
      ],
      [
        250.98464965820312,
        690.0,
        230.0
      ],
      [
        254.0325927734375,
        690.0,
        230.0
      ],
      [
        137.4235076904297,
        690.0,
        210.0
      ],
      [
        254.0325927734375,
        690.0,
        210.0
      ],
      [
        254.0325927734375,
        690.0,
        230.0
      ],
      [
        254.0325927734375,
        650.0,
        230.0
      ],
      [
        254.0325927734375,
        650.0,
        210.0
      ],
      [
        -100.0,
        650.0,
        210.0
      ],
      [
        -100.0,
        650.0,
        230.0
      ],
      [
        -100.0,
        690.0,
        230.0
      ],
      [
        -100.0,
        690.0,
        210.0
      ],
      [
        254.0325927734375,
        690.0,
        160.0
      ],
      [
        -492.2904357910156,
        555.0,
        0.0
      ],
      [
        -594.975830078125,
        555.0,
        -300.0
      ],
      [
        -451.9228820800781,
        470.0,
        60.0
      ],
      [
        -463.587890625,
        520.0,
        60.0
      ],
      [
        -451.9228820800781,
        470.0,
        60.0
      ],
      [
        -280.0,
        470.0,
        60.0
      ],
      [
        -280.0,
        249.4182586669922,
        60.0
      ],
      [
        -401.8686828613281,
        255.4513702392578,
        60.0
      ],
      [
        -280.0,
        520.0,
        60.0
      ],
      [
        -463.587890625,
        520.0,
        60.0
      ],
      [
        -471.75335693359375,
        555.0,
        60.0
      ],
      [
        -280.0,
        555.0,
        60.0
      ],
      [
        -280.0,
        520.0,
        60.0
      ],
      [
        -280.0,
        470.0,
        60.0
      ],
      [
        -406.1060485839844,
        435.0,
        170.0
      ],
      [
        -410.0,
        451.6907653808594,
        170.0
      ],
      [
        -410.0,
        440.0,
        162.03167724609375
      ],
      [
        -408.9840087890625,
        440.0,
        165.0
      ],
      [
        -408.9840087890625,
        440.0,
        165.0
      ],
      [
        -410.0,
        440.0,
        162.03167724609375
      ],
      [
        -355.0,
        440.0,
        106.0
      ],
      [
        -355.0,
        440.0,
        60.0
      ],
      [
        -280.0,
        480.0,
        116.0
      ],
      [
        -315.0,
        480.0,
        116.0
      ],
      [
        -345.0,
        555.0,
        63.33333206176758
      ],
      [
        -325.0,
        555.0,
        63.333335876464844
      ],
      [
        -355.0,
        555.0,
        60.0
      ],
      [
        -355.0,
        530.0,
        80.0
      ],
      [
        -355.0,
        555.0,
        63.33333206176758
      ],
      [
        -325.0,
        555.0,
        63.33333206176758
      ],
      [
        -325.0,
        555.0,
        61.333335876464844
      ],
      [
        -355.0,
        555.0,
        80.0
      ],
      [
        -355.0,
        555.0,
        116.0
      ],
      [
        -315.0,
        555.0,
        116.0
      ],
      [
        -355.0,
        555.0,
        106.0
      ],
      [
        -355.0,
        555.0,
        116.0
      ],
      [
        -355.0,
        555.0,
        140.0
      ],
      [
        -492.2904357910156,
        555.0,
        0.0
      ],
      [
        -479.96820068359375,
        555.0,
        60.0
      ],
      [
        -479.96820068359375,
        555.0,
        60.0
      ],
      [
        -512.0,
        690.0,
        0.0
      ],
      [
        -612.0,
        690.0,
        -300.0
      ],
      [
        -492.0,
        690.0,
        60.0
      ],
      [
        -280.0,
        690.0,
        60.0
      ],
      [
        -471.75335693359375,
        555.0,
        60.0
      ],
      [
        -492.0,
        641.7835083007812,
        60.0
      ],
      [
        -355.0,
        565.0,
        60.0
      ],
      [
        -512.0,
        690.0,
        0.0
      ],
      [
        -500.0,
        690.0,
        60.0
      ],
      [
        -500.0,
        676.0740966796875,
        60.0
      ],
      [
        -500.0,
        676.0740966796875,
        60.0
      ],
      [
        -210.0,
        480.0,
        80.0
      ],
      [
        -210.0,
        500.0,
        80.0
      ],
      [
        -210.0,
        500.0,
        80.0
      ],
      [
        -210.0,
        500.0,
        78.0
      ],
      [
        -850.0,
        3688.2353515625,
        0.0
      ],
      [
        -850.0,
        3743.4951171875,
        150.0
      ],
      [
        1645.0,
        1469.9998779296875,
        500.0
      ],
      [
        1645.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1975.489501953125,
        1830.0,
        1060.0
      ],
      [
        1917.370849609375,
        1888.118408203125,
        1060.0
      ],
      [
        1910.0,
        1895.4893798828125,
        1060.0
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1917.370849609375,
        1888.118408203125,
        1060.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1833.617919921875,
        1130.0
      ],
      [
        1913.617919921875,
        1830.0,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1760.0001220703125,
        1130.0
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1812.9427490234375,
        1106.0
      ],
      [
        1910.0,
        1704.3255615234375,
        1110.0
      ],
      [
        1910.0,
        1704.6409912109375,
        1110.0
      ],
      [
        1910.0,
        1768.03857421875,
        1110.0
      ],
      [
        1910.0,
        1789.4744873046875,
        1110.0
      ],
      [
        1910.0,
        1789.4744873046875,
        1110.0
      ],
      [
        1910.0,
        1789.4744873046875,
        1115.0
      ],
      [
        1645.0,
        1830.0,
        370.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        1180.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1831.2437744140625,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        -613.1430053710938,
        1113.014892578125,
        60.0
      ],
      [
        -638.3679809570312,
        1286.7740478515625,
        60.0
      ],
      [
        -592.125244140625,
        1492.0,
        60.0
      ],
      [
        190.0,
        1715.052978515625,
        0.0
      ],
      [
        190.0,
        1759.9998779296875,
        -74.91361236572266
      ],
      [
        190.0,
        1759.9998779296875,
        -74.91361999511719
      ],
      [
        190.0,
        1850.2362060546875,
        -300.0
      ],
      [
        190.0,
        1715.052978515625,
        0.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        156.73394775390625,
        1643.6673583984375,
        60.0
      ],
      [
        190.0,
        1830.0,
        -249.52261352539062
      ],
      [
        313.30950927734375,
        1830.0,
        -44.001121520996094
      ],
      [
        205.04037475585938,
        1715.963134765625,
        60.0
      ],
      [
        -500.0,
        820.0,
        60.0
      ],
      [
        -500.0,
        820.0,
        120.0
      ],
      [
        -485.0,
        820.0,
        60.0
      ],
      [
        -485.0,
        819.979248046875,
        120.0
      ],
      [
        -485.0,
        820.0,
        120.0
      ],
      [
        -485.0,
        819.979248046875,
        130.0
      ],
      [
        -485.0,
        820.0,
        130.0
      ],
      [
        -485.0,
        820.0,
        214.0
      ],
      [
        -485.0,
        820.0,
        214.0
      ],
      [
        -500.0,
        820.0,
        214.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        420.0
      ],
      [
        760.0,
        820.0,
        118.0
      ],
      [
        760.0,
        820.0,
        120.0
      ],
      [
        760.0,
        820.0,
        140.0
      ],
      [
        760.0,
        820.0,
        220.0
      ],
      [
        780.0,
        820.0,
        80.0
      ],
      [
        780.0,
        820.0,
        60.0
      ],
      [
        780.0,
        820.0,
        80.0
      ],
      [
        780.0,
        820.0,
        140.0
      ],
      [
        760.0,
        820.0,
        120.0
      ],
      [
        780.0,
        820.0,
        120.0
      ],
      [
        760.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        78.0
      ],
      [
        241.07882690429688,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        254.03260803222656,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        370.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        300.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        230.0
      ],
      [
        241.07882690429688,
        820.0,
        230.0
      ],
      [
        241.07882690429688,
        820.0,
        230.0
      ],
      [
        254.03260803222656,
        820.0,
        230.0
      ],
      [
        195.3977813720703,
        820.0,
        230.0
      ],
      [
        195.3977813720703,
        820.0,
        210.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        241.07882690429688,
        820.0,
        160.0
      ],
      [
        241.07882690429688,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        119.87761688232422,
        820.0,
        120.0
      ],
      [
        129.99996948242188,
        820.0,
        120.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        140.0
      ],
      [
        169.20310974121094,
        780.796875,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        120.0
      ],
      [
        183.3708953857422,
        820.0,
        130.0
      ],
      [
        161.99351501464844,
        788.0064697265625,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        120.0
      ],
      [
        195.3977813720703,
        820.0,
        130.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        1549.9998779296875,
        1400.0,
        728.3914184570312
      ],
      [
        1549.9998779296875,
        1400.0,
        490.0
      ],
      [
        1549.9998779296875,
        1270.0,
        490.0
      ],
      [
        1549.9998779296875,
        1270.0,
        636.467529296875
      ],
      [
        1549.9998779296875,
        1400.0,
        728.3914184570312
      ],
      [
        1549.9998779296875,
        1270.0,
        636.467529296875
      ],
      [
        1350.0,
        960.7692260742188,
        80.0
      ],
      [
        1350.0,
        910.7692260742188,
        80.0
      ],
      [
        1350.0,
        910.7692260742188,
        80.0
      ],
      [
        1350.0,
        910.7692260742188,
        100.0
      ],
      [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      [
        1174.9146728515625,
        1390.0,
        515.0
      ],
      [
        1174.9146728515625,
        1300.0,
        515.0
      ],
      [
        1030.0,
        1300.0,
        370.085205078125
      ],
      [
        1030.0,
        1300.0,
        370.0852355957031
      ],
      [
        1030.0,
        1390.0,
        370.085205078125
      ],
      [
        1174.9146728515625,
        1380.0,
        515.0
      ],
      [
        1175.0,
        1380.0,
        515.0852661132812
      ],
      [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      [
        1175.0,
        1310.0,
        515.0852661132812
      ],
      [
        1039.9146728515625,
        979.9147338867188,
        380.0
      ],
      [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      [
        1315.0,
        920.0,
        100.0
      ],
      [
        1174.9146728515625,
        1460.0,
        515.0
      ],
      [
        1030.0,
        1460.0,
        370.085205078125
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1030.0,
        1550.0,
        370.085205078125
      ],
      [
        1174.9146728515625,
        1470.0,
        515.0
      ],
      [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      [
        1090.0,
        1390.0,
        430.0852966308594
      ],
      [
        1090.0,
        1460.0,
        430.0852966308594
      ],
      [
        980.0,
        930.0,
        80.0
      ],
      [
        980.0,
        850.0,
        80.0
      ],
      [
        980.0,
        930.0,
        80.0
      ],
      [
        980.0,
        1120.0,
        80.0
      ],
      [
        739.914794921875,
        1420.0,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        960.0,
        80.0
      ],
      [
        739.914794921875,
        940.0,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        1550.085205078125,
        80.0
      ],
      [
        820.0,
        1540.0,
        64.44444274902344
      ],
      [
        820.0,
        1450.0,
        64.44444274902344
      ],
      [
        740.0,
        930.0,
        80.0
      ],
      [
        740.0,
        930.0,
        78.0
      ],
      [
        720.0,
        930.0,
        60.0
      ],
      [
        726.6382446289062,
        926.6382446289062,
        66.72349548339844
      ],
      [
        720.0,
        929.9573974609375,
        60.0851936340332
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        720.0,
        1450.0,
        60.0
      ],
      [
        720.0,
        1450.0426025390625,
        60.08519744873047
      ],
      [
        726.6382446289062,
        1453.3616943359375,
        66.72349548339844
      ],
      [
        737.914794921875,
        960.0,
        78.0
      ],
      [
        739.914794921875,
        960.0,
        80.0
      ],
      [
        737.914794921875,
        1420.0,
        78.0
      ],
      [
        739.914794921875,
        1420.0,
        80.0
      ],
      [
        960.0,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        780.0,
        820.0,
        110.0
      ],
      [
        820.0,
        1540.0,
        110.0
      ],
      [
        820.0,
        1450.0,
        110.0
      ],
      [
        836.0,
        930.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        779.914794921875,
        950.0,
        120.0
      ],
      [
        777.914794921875,
        950.0,
        118.0
      ],
      [
        799.914794921875,
        950.0,
        140.0
      ],
      [
        879.9147338867188,
        950.0,
        220.0
      ],
      [
        799.9147338867188,
        930.0,
        140.0
      ],
      [
        780.0,
        930.0,
        120.08523559570312
      ],
      [
        986.2361450195312,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        986.2120971679688,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        779.9147338867188,
        820.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0,
        120.0
      ],
      [
        780.0,
        820.0,
        120.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        780.0,
        930.0,
        120.08523559570312
      ],
      [
        780.0,
        820.0,
        120.08525085449219
      ],
      [
        1000.0,
        950.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0852661132812,
        120.0
      ],
      [
        779.914794921875,
        950.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0852661132812,
        120.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        162.6588134765625
      ],
      [
        829.914794921875,
        1003.3217163085938,
        170.0
      ],
      [
        829.914794921875,
        1108.071533203125,
        170.0
      ],
      [
        865.0,
        1121.3931884765625,
        205.085205078125
      ],
      [
        865.0,
        968.6068725585938,
        205.085205078125
      ],
      [
        829.914794921875,
        981.9285278320312,
        170.0
      ],
      [
        1037.0,
        977.0000610351562,
        380.0
      ],
      [
        1037.0,
        977.1166381835938,
        377.0852966308594
      ],
      [
        825.9805908203125,
        950.0,
        166.0657958984375
      ],
      [
        825.9805908203125,
        950.0,
        220.0
      ],
      [
        1030.0,
        1380.0,
        515.0
      ],
      [
        1030.0,
        1310.0,
        515.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1380.0,
        370.085205078125
      ],
      [
        725.3668823242188,
        1390.0,
        80.0
      ],
      [
        720.0,
        1378.4161376953125,
        80.0
      ],
      [
        720.0,
        1390.0,
        80.0
      ],
      [
        780.0,
        950.0,
        140.0
      ],
      [
        780.0,
        950.0,
        220.0
      ],
      [
        1030.0,
        1470.0,
        515.0
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        720.0,
        1470.0,
        80.0
      ],
      [
        720.0,
        1550.0,
        80.0
      ],
      [
        739.914794921875,
        1550.0,
        80.0
      ],
      [
        739.914794921875,
        1470.0,
        80.0
      ],
      [
        720.0,
        1460.0,
        80.0
      ],
      [
        739.914794921875,
        1460.0,
        80.0
      ],
      [
        720.0,
        1400.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        78.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        -592.6333618164062,
        1490.0,
        214.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        0.0,
        1500.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -608.4334106445312,
        1430.0,
        214.0
      ],
      [
        -600.015380859375,
        1410.0,
        60.0
      ],
      [
        -597.513427734375,
        1420.0,
        120.0
      ],
      [
        -595.0115356445312,
        1430.0,
        120.0
      ],
      [
        -550.0,
        1410.0,
        60.0
      ],
      [
        -550.0,
        1420.0,
        120.0
      ],
      [
        -625.0554809570312,
        1309.916748046875,
        119.99999237060547
      ],
      [
        -625.0554809570312,
        1309.916748046875,
        120.0
      ],
      [
        -618.1177368164062,
        1239.0,
        60.0
      ],
      [
        -618.1177368164062,
        1239.0,
        119.99999237060547
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -132.9655303955078,
        1239.0,
        60.02783966064453
      ],
      [
        -516.034423828125,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -340.0,
        1239.02783203125,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.02787780761719
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.02783203125,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.02787780761719
      ],
      [
        -299.5139465332031,
        1239.02783203125,
        60.0
      ],
      [
        -299.5,
        1239.0,
        60.0
      ],
      [
        -299.5,
        1239.0,
        60.02787780761719
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.02787780761719
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.02787780761719
      ],
      [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -132.9655303955078,
        1239.0,
        60.02783966064453
      ],
      [
        -132.94044494628906,
        1239.0,
        60.00611877441406
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9404602050781,
        1239.0,
        60.00611877441406
      ],
      [
        -516.0595703125,
        1239.0,
        60.00611877441406
      ],
      [
        -516.034423828125,
        1239.0,
        60.02784729003906
      ],
      [
        -350.5,
        1239.0,
        60.02787780761719
      ],
      [
        -350.5,
        1239.0,
        60.0
      ],
      [
        -350.4860534667969,
        1239.02783203125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -310.0,
        1239.0,
        120.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1240.0,
        120.0
      ],
      [
        -300.0,
        1240.0,
        120.0
      ],
      [
        -310.0,
        1240.0,
        120.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -300.0,
        1240.0,
        120.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -299.5,
        1239.0,
        120.0
      ],
      [
        -217.67767333984375,
        1362.6776123046875,
        62.0
      ],
      [
        -200.0,
        1370.0,
        62.0
      ],
      [
        -200.0,
        1370.0,
        62.0
      ],
      [
        -182.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -200.0,
        1320.0,
        62.0
      ],
      [
        -200.0,
        1320.0,
        62.0
      ],
      [
        -217.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -225.0,
        1345.0,
        62.0
      ],
      [
        -217.67767333984375,
        1362.6776123046875,
        62.0
      ],
      [
        -182.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -175.0,
        1345.0,
        62.0
      ],
      [
        -175.0,
        1345.0,
        62.0
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -217.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -225.0,
        1345.0,
        62.0
      ],
      [
        -216.14694213867188,
        1328.8531494140625,
        62.0
      ],
      [
        -200.0,
        1322.164794921875,
        62.0
      ],
      [
        -200.0,
        1322.164794921875,
        62.0
      ],
      [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      [
        -183.85305786132812,
        1361.1468505859375,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -222.835205078125,
        1345.0,
        62.0
      ],
      [
        -222.835205078125,
        1345.0,
        62.0
      ],
      [
        -216.14694213867188,
        1328.8531494140625,
        62.0
      ],
      [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      [
        -177.164794921875,
        1345.0,
        62.0
      ],
      [
        -177.164794921875,
        1345.0,
        62.0
      ],
      [
        -183.85305786132812,
        1361.1468505859375,
        62.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -340.0,
        1240.0,
        120.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        120.0
      ],
      [
        -340.0,
        1240.0,
        120.0
      ],
      [
        -350.0,
        1240.0,
        120.0
      ],
      [
        -350.5,
        1239.0,
        80.0
      ],
      [
        -350.5,
        1239.0,
        80.0
      ],
      [
        -350.0,
        1240.0,
        120.0
      ],
      [
        -350.5,
        1239.0,
        120.0
      ],
      [
        -450.0,
        1370.0,
        62.0
      ],
      [
        -432.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -467.67767333984375,
        1362.6776123046875,
        62.0
      ],
      [
        -450.0,
        1370.0,
        62.0
      ],
      [
        -450.0,
        1320.0,
        62.0
      ],
      [
        -467.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -432.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -450.0,
        1320.0,
        62.0
      ],
      [
        -432.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -425.0,
        1345.0,
        62.0
      ],
      [
        -475.0,
        1345.0,
        62.0
      ],
      [
        -467.67767333984375,
        1362.6776123046875,
        62.0
      ],
      [
        -467.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -475.0,
        1345.0,
        62.0
      ],
      [
        -425.0,
        1345.0,
        62.0
      ],
      [
        -432.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -450.0,
        1322.164794921875,
        62.0
      ],
      [
        -433.8530578613281,
        1328.8531494140625,
        62.0
      ],
      [
        -466.1469421386719,
        1328.8531494140625,
        62.0
      ],
      [
        -450.0,
        1322.164794921875,
        62.0
      ],
      [
        -450.0,
        1367.835205078125,
        62.0
      ],
      [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      [
        -433.8530578613281,
        1361.1468505859375,
        62.0
      ],
      [
        -450.0,
        1367.835205078125,
        62.0
      ],
      [
        -427.164794921875,
        1345.0,
        62.0
      ],
      [
        -433.8530578613281,
        1361.1468505859375,
        62.0
      ],
      [
        -433.8530578613281,
        1328.8531494140625,
        62.0
      ],
      [
        -427.164794921875,
        1345.0,
        62.0
      ],
      [
        -472.835205078125,
        1345.0,
        62.0
      ],
      [
        -466.1469421386719,
        1328.8531494140625,
        62.0
      ],
      [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      [
        -472.835205078125,
        1345.0,
        62.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -340.0,
        1270.0,
        62.0
      ],
      [
        -310.0,
        1270.0,
        62.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -335.0,
        1239.0,
        85.0
      ],
      [
        -315.0,
        1239.0,
        85.0
      ],
      [
        -310.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -340.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -635.9242553710938,
        1266.47509765625,
        214.0
      ],
      [
        -618.1177368164062,
        1239.0,
        214.0
      ],
      [
        -618.1177368164062,
        1239.0,
        214.0
      ],
      [
        -633.3114013671875,
        1239.0,
        214.0
      ],
      [
        -350.5,
        1239.0,
        125.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -350.5,
        1239.0,
        125.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -309.5,
        1101.0794677734375,
        250.0
      ],
      [
        -309.5,
        1101.0794677734375,
        75.0
      ],
      [
        -309.5,
        1101.0794677734375,
        60.0
      ],
      [
        -309.5,
        1101.0794677734375,
        225.0
      ],
      [
        -309.5,
        1101.0794677734375,
        205.0
      ],
      [
        -340.21795654296875,
        1101.0794677734375,
        250.0
      ],
      [
        -309.5,
        1101.0794677734375,
        120.0
      ],
      [
        -309.5,
        1101.0794677734375,
        250.00003051757812
      ],
      [
        -339.5,
        1051.800048828125,
        250.00003051757812
      ],
      [
        -339.5,
        971.800048828125,
        250.0
      ],
      [
        -309.5,
        850.556396484375,
        100.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        100.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        120.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        120.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        100.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        100.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        120.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        120.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -309.5,
        850.556396484375,
        250.0
      ],
      [
        -339.5,
        1101.0794677734375,
        205.0
      ],
      [
        -309.5,
        1101.0794677734375,
        205.0
      ],
      [
        -313.35302734375,
        1055.80712890625,
        76.0
      ],
      [
        -313.35302734375,
        1055.80712890625,
        85.0
      ],
      [
        -314.792236328125,
        1057.2464599609375,
        76.0
      ],
      [
        -314.42620849609375,
        1056.8804931640625,
        75.0
      ],
      [
        -314.4280700683594,
        1057.753662109375,
        75.87640380859375
      ],
      [
        -314.623046875,
        1057.53955078125,
        76.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        85.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        76.0
      ],
      [
        -309.5,
        1101.0794677734375,
        225.0
      ],
      [
        -339.5,
        1101.0794677734375,
        225.0
      ],
      [
        -339.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        60.0
      ],
      [
        -309.5,
        830.0,
        60.0
      ],
      [
        -309.5,
        830.0,
        120.0
      ],
      [
        -339.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        820.0,
        140.0
      ],
      [
        -339.5,
        820.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        140.0
      ],
      [
        -309.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      [
        -339.5,
        830.556396484375,
        60.00611877441406
      ],
      [
        -485.0,
        830.0,
        60.0
      ],
      [
        -485.0,
        820.0,
        140.0
      ],
      [
        -485.0,
        830.0,
        140.0
      ],
      [
        -485.0,
        830.0,
        214.0
      ],
      [
        -485.0,
        830.0,
        214.0
      ],
      [
        -500.0,
        830.0,
        214.0
      ],
      [
        -513.0787963867188,
        961.6765747070312,
        60.0
      ],
      [
        -513.0787963867188,
        961.6765747070312,
        214.0
      ],
      [
        -513.0787963867188,
        961.6765747070312,
        214.0
      ],
      [
        -522.655517578125,
        945.08935546875,
        214.0
      ],
      [
        -394.5,
        911.17822265625,
        249.99998474121094
      ],
      [
        -359.5,
        850.556396484375,
        250.0
      ],
      [
        -359.5,
        971.800048828125,
        249.99998474121094
      ],
      [
        -394.5,
        911.17822265625,
        250.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        250.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -339.5,
        971.800048828125,
        249.99998474121094
      ],
      [
        -359.5,
        971.800048828125,
        250.0
      ],
      [
        -359.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -347.9530029296875,
        830.556396484375,
        60.00611877441406
      ],
      [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -339.5,
        1006.441162109375,
        200.0
      ],
      [
        -339.5,
        1006.441162109375,
        80.00611877441406
      ],
      [
        -352.17950439453125,
        984.4795532226562,
        67.32661437988281
      ],
      [
        -352.17950439453125,
        984.4795532226562,
        67.32661437988281
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        100.00397491455078
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        120.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        80.00397491455078
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        100.00397491455078
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        95.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        75.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        95.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        120.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        120.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        250.00001525878906
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        250.0
      ],
      [
        -339.5,
        1066.02392578125,
        205.0
      ],
      [
        -339.5,
        1066.02392578125,
        225.0
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        250.00003051757812
      ],
      [
        -339.5,
        1051.800048828125,
        250.0
      ],
      [
        -432.5940246582031,
        1101.0794677734375,
        200.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        200.0
      ],
      [
        -406.0469970703125,
        931.17822265625,
        60.00611877441406
      ],
      [
        -359.5,
        1011.7999267578125,
        60.00611877441406
      ],
      [
        -420.74359130859375,
        1101.0794677734375,
        69.74334716796875
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        80.00397491455078
      ],
      [
        -446.0471496582031,
        1077.7781982421875,
        60.00611877441406
      ],
      [
        -432.593994140625,
        1101.0794677734375,
        80.00611877441406
      ],
      [
        -420.74359130859375,
        1101.0794677734375,
        69.74334716796875
      ],
      [
        -409.5,
        1141.0794677734375,
        250.0
      ],
      [
        -340.21795654296875,
        1101.0794677734375,
        250.00003051757812
      ],
      [
        -424.5,
        1115.0986328125,
        250.00003051757812
      ],
      [
        -420.7500305175781,
        1121.5938720703125,
        75.01204681396484
      ],
      [
        -420.7500305175781,
        1121.5938720703125,
        95.0
      ],
      [
        -320.5,
        1101.0794677734375,
        95.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -320.5,
        1123.205810546875,
        120.0
      ],
      [
        -320.5,
        1116.1951904296875,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -369.4998779296875,
        1210.361328125,
        120.0
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -320.5,
        1116.1951904296875,
        120.0
      ],
      [
        -320.5,
        1101.0794677734375,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -320.5,
        1123.205810546875,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -320.5,
        1210.361328125,
        118.0
      ],
      [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      [
        -365.0,
        1195.25,
        114.68749237060547
      ],
      [
        -365.0,
        1195.25,
        114.68749237060547
      ],
      [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      [
        -376.25,
        1185.25,
        118.0
      ],
      [
        -376.25,
        1195.25,
        118.0
      ],
      [
        -376.25,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1166.050048828125,
        118.0
      ],
      [
        -365.0,
        1123.2412109375,
        110.0
      ],
      [
        -365.0,
        1123.2412109375,
        95.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1185.25,
        118.0
      ],
      [
        -353.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -365.0,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1195.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -340.0,
        1126.019287109375,
        120.0
      ],
      [
        -340.0,
        1126.019287109375,
        118.0
      ],
      [
        -320.5,
        1123.205810546875,
        120.0
      ],
      [
        -320.5,
        1123.205810546875,
        118.0
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -387.80487060546875,
        1178.65625,
        120.0
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        120.0
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        125.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        120.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -340.0,
        1210.361328125,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1210.361328125,
        75.0
      ],
      [
        -340.0,
        1210.361328125,
        60.0
      ],
      [
        -340.0,
        1210.361328125,
        75.0
      ],
      [
        -320.5,
        1101.080078125,
        75.0
      ],
      [
        -320.5,
        1122.0,
        60.0
      ],
      [
        -329.5,
        1122.0,
        60.0
      ],
      [
        -329.5,
        1101.080078125,
        75.0
      ],
      [
        -353.9970397949219,
        1122.0001220703125,
        60.0
      ],
      [
        -354.17950439453125,
        1121.0,
        60.71708679199219
      ],
      [
        -336.5,
        1147.0,
        70.0
      ],
      [
        -336.5,
        1140.0,
        70.0
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -375.739990234375,
        1147.0,
        64.0
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -372.9237976074219,
        1147.0,
        64.0
      ],
      [
        -372.9237976074219,
        1147.0,
        60.0
      ],
      [
        -372.9237976074219,
        1147.0,
        64.0
      ],
      [
        -375.739990234375,
        1147.0,
        60.0
      ],
      [
        -375.739990234375,
        1147.0,
        64.0
      ],
      [
        -362.9999084472656,
        1141.3106689453125,
        64.7599868774414
      ],
      [
        -363.267578125,
        1141.0135498046875,
        64.68000030517578
      ],
      [
        -362.7027893066406,
        1141.0430908203125,
        64.75997924804688
      ],
      [
        -362.9999084472656,
        1141.3106689453125,
        64.7599868774414
      ],
      [
        -362.732421875,
        1141.06982421875,
        64.75997924804688
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -320.5,
        1149.0,
        65.0
      ],
      [
        -320.5,
        1177.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        65.0
      ],
      [
        -320.5,
        1181.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1149.0,
        62.0
      ],
      [
        -320.5,
        1175.5,
        62.0
      ],
      [
        -320.5,
        1181.5,
        61.5
      ],
      [
        -320.5,
        1177.5,
        61.5
      ],
      [
        -340.0,
        1177.5,
        62.0
      ],
      [
        -340.0,
        1177.5,
        61.5
      ],
      [
        -320.5,
        1177.5,
        61.5
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -356.0,
        1175.0,
        62.0
      ],
      [
        -356.0,
        1175.0,
        61.5
      ],
      [
        -360.5,
        1167.205810546875,
        61.5
      ],
      [
        -360.5,
        1167.205810546875,
        62.0
      ],
      [
        -357.4433898925781,
        1177.5,
        61.5
      ],
      [
        -356.0,
        1175.0,
        61.5
      ],
      [
        -356.0,
        1175.0,
        62.0
      ],
      [
        -357.4433898925781,
        1177.5,
        62.0
      ],
      [
        -373.6650695800781,
        1147.25,
        61.5
      ],
      [
        -373.6650695800781,
        1147.25,
        62.0
      ],
      [
        -375.739990234375,
        1147.0,
        62.0
      ],
      [
        -375.739990234375,
        1147.0,
        61.5
      ],
      [
        -373.6650695800781,
        1147.25,
        62.0
      ],
      [
        -373.6650695800781,
        1147.25,
        61.5
      ],
      [
        -372.9237976074219,
        1147.0,
        61.5
      ],
      [
        -372.9237976074219,
        1147.0,
        62.0
      ],
      [
        -320.5,
        1181.5,
        62.0
      ],
      [
        -320.5,
        1181.5,
        61.5
      ],
      [
        -359.7528076171875,
        1181.5,
        61.5
      ],
      [
        -359.7528076171875,
        1181.5,
        62.0
      ],
      [
        -369.5,
        1182.794189453125,
        62.0
      ],
      [
        -369.5,
        1182.794189453125,
        61.5
      ],
      [
        -360.5,
        1182.794189453125,
        61.5
      ],
      [
        -360.5,
        1182.794189453125,
        62.0
      ],
      [
        -360.5,
        1182.794189453125,
        62.0
      ],
      [
        -360.5,
        1182.794189453125,
        61.5
      ],
      [
        -320.5,
        1177.5,
        60.0
      ],
      [
        -357.4433898925781,
        1177.5,
        60.0
      ],
      [
        -357.4433898925781,
        1177.5,
        61.5
      ],
      [
        -372.964111328125,
        1182.794189453125,
        62.5
      ],
      [
        -354.2679443359375,
        1172.0,
        62.5
      ],
      [
        -356.0,
        1175.0,
        62.5
      ],
      [
        -360.5,
        1167.205810546875,
        62.5
      ],
      [
        -357.035888671875,
        1182.794189453125,
        62.5
      ],
      [
        -338.0,
        1177.5,
        65.0
      ],
      [
        -338.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1149.0,
        65.0
      ],
      [
        -320.5,
        1149.0,
        62.0
      ],
      [
        -320.5,
        1177.5,
        65.0
      ],
      [
        -364.75,
        1175.0,
        90.75
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1162.2249755859375,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1164.780029296875,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1166.823974609375,
        91.68366241455078
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1187.7750244140625,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1185.219970703125,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      [
        -309.5,
        1179.7305908203125,
        118.0
      ],
      [
        -309.5,
        1126.1533203125,
        118.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -309.5,
        1101.0794677734375,
        95.0
      ],
      [
        -309.5,
        1103.464111328125,
        95.0
      ],
      [
        -309.5,
        1103.464111328125,
        95.0
      ],
      [
        -309.5,
        1146.071044921875,
        95.0
      ],
      [
        -309.5,
        1161.4931640625,
        95.0
      ],
      [
        -309.5,
        1146.071044921875,
        95.0
      ],
      [
        -309.5,
        1200.361328125,
        95.0
      ],
      [
        -309.5,
        1161.4931640625,
        95.0
      ],
      [
        -309.5,
        1177.5,
        62.0
      ],
      [
        -309.5,
        1181.0,
        62.0
      ],
      [
        -309.5,
        1147.0,
        62.0
      ],
      [
        -309.5,
        1177.5,
        62.0
      ],
      [
        -309.5,
        1177.5,
        61.5
      ],
      [
        -309.5,
        1147.0,
        61.5
      ],
      [
        -320.5,
        1147.0,
        62.0
      ],
      [
        -320.5,
        1147.0,
        61.5
      ],
      [
        -309.5,
        1147.0,
        61.5
      ],
      [
        -309.5,
        1147.0,
        62.0
      ],
      [
        -314.5,
        1119.210693359375,
        62.0
      ],
      [
        -314.5,
        1119.907958984375,
        61.5
      ],
      [
        -314.5,
        1122.0,
        61.5
      ],
      [
        -314.5,
        1122.0,
        62.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        61.5
      ],
      [
        -310.0,
        1177.5,
        61.5
      ],
      [
        -310.0,
        1177.5,
        62.0
      ],
      [
        -309.5,
        1181.0,
        61.5
      ],
      [
        -309.5,
        1181.0,
        62.0
      ],
      [
        -310.0,
        1200.361328125,
        62.0
      ],
      [
        -310.0,
        1200.361328125,
        61.5
      ],
      [
        -310.0,
        1210.361328125,
        61.5
      ],
      [
        -310.0,
        1210.361328125,
        62.0
      ],
      [
        -310.0,
        1200.361328125,
        61.5
      ],
      [
        -310.0,
        1200.361328125,
        62.0
      ],
      [
        -309.5,
        1200.361328125,
        62.0
      ],
      [
        -309.5,
        1200.361328125,
        61.5
      ],
      [
        -309.5,
        1147.0,
        60.0
      ],
      [
        -310.0,
        1210.361328125,
        60.0
      ],
      [
        -309.5,
        1200.361328125,
        60.0
      ],
      [
        -310.0,
        1200.361328125,
        65.0
      ],
      [
        -310.0,
        1210.361328125,
        65.0
      ],
      [
        -310.0,
        1147.0,
        62.0
      ],
      [
        -309.5,
        1147.0,
        65.0
      ],
      [
        -310.0,
        1147.0,
        65.0
      ],
      [
        -310.0,
        1200.361328125,
        65.0
      ],
      [
        -309.5,
        1200.361328125,
        65.0
      ],
      [
        -312.0,
        1147.0,
        62.0
      ],
      [
        -312.0,
        1147.0,
        65.0
      ],
      [
        -312.0,
        1177.5,
        65.0
      ],
      [
        -312.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -309.5,
        1200.361328125,
        75.0
      ],
      [
        -309.5,
        1200.361328125,
        75.0
      ],
      [
        -309.5,
        1200.361328125,
        95.0
      ],
      [
        -310.0,
        1210.361328125,
        75.0
      ],
      [
        -310.0,
        1210.361328125,
        75.0
      ],
      [
        -309.5,
        1140.0,
        70.0
      ],
      [
        -309.5,
        1147.0,
        70.0
      ],
      [
        -309.5,
        1147.0,
        70.0
      ],
      [
        -309.5,
        1126.1533203125,
        120.0
      ],
      [
        -309.5,
        1102.005615234375,
        120.0
      ],
      [
        -309.5,
        1102.005615234375,
        120.0
      ],
      [
        -309.5,
        1101.0794677734375,
        120.0
      ],
      [
        -309.5,
        1179.7305908203125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -309.5,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -309.5,
        1179.7305908203125,
        120.0
      ],
      [
        -309.5,
        1179.7305908203125,
        118.0
      ],
      [
        -309.5,
        1126.1533203125,
        120.0
      ],
      [
        -310.0,
        1126.019287109375,
        120.0
      ],
      [
        -310.0,
        1126.019287109375,
        118.0
      ],
      [
        -309.5,
        1126.1533203125,
        118.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -309.5,
        1200.4000244140625,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -309.5,
        1210.361328125,
        125.0
      ],
      [
        -309.5,
        1200.4000244140625,
        120.0
      ],
      [
        -309.5,
        1200.4000244140625,
        125.0
      ],
      [
        -309.5,
        1101.0794677734375,
        270.0
      ],
      [
        -309.5,
        1101.0794677734375,
        250.0
      ],
      [
        -309.5,
        1101.0794677734375,
        500.0
      ],
      [
        -339.5,
        850.556396484375,
        500.0
      ],
      [
        -309.5,
        850.556396484375,
        500.0
      ],
      [
        -339.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -359.5000305175781,
        971.800048828125,
        350.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        -339.5,
        1006.441162109375,
        300.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        500.0
      ],
      [
        -400.2204284667969,
        1101.0794677734375,
        514.0184936523438
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        500.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        250.00001525878906
      ],
      [
        -432.5940246582031,
        1101.0794677734375,
        300.0
      ],
      [
        -400.21807861328125,
        1101.0794677734375,
        300.0
      ],
      [
        -309.5,
        1130.4095458984375,
        402.0
      ],
      [
        -309.5,
        1130.4095458984375,
        432.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        400.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -309.5,
        1101.0794677734375,
        400.0
      ],
      [
        -309.5,
        1130.4095458984375,
        400.0
      ],
      [
        -309.5,
        1210.361328125,
        400.0
      ],
      [
        -309.5,
        1130.4095458984375,
        432.0
      ],
      [
        -309.5,
        1190.0,
        432.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        250.0
      ],
      [
        -224.4998779296875,
        1115.0986328125,
        250.0
      ],
      [
        -309.5,
        1101.0794677734375,
        250.0
      ],
      [
        -308.78204345703125,
        1101.0794677734375,
        250.00003051757812
      ],
      [
        -59.8972282409668,
        830.0,
        124.0
      ],
      [
        -59.8972282409668,
        830.0,
        104.0
      ],
      [
        -59.8972282409668,
        830.0,
        124.0
      ],
      [
        -59.8972282409668,
        830.0,
        144.0
      ],
      [
        -59.8972282409668,
        830.0,
        104.0
      ],
      [
        -59.8972282409668,
        830.0,
        82.0
      ],
      [
        -59.897216796875,
        830.0,
        120.0
      ],
      [
        -59.897216796875,
        830.0,
        140.0
      ],
      [
        -59.897216796875,
        830.0,
        60.0
      ],
      [
        -59.897216796875,
        830.0,
        120.0
      ],
      [
        -54.123687744140625,
        820.0,
        140.0
      ],
      [
        -59.897216796875,
        830.0,
        140.0
      ],
      [
        -160.0,
        942.0,
        250.00001525878906
      ],
      [
        -160.0,
        830.0,
        250.00001525878906
      ],
      [
        -160.0,
        1003.3821411132812,
        60.0
      ],
      [
        -160.0,
        1003.3821411132812,
        144.0
      ],
      [
        -160.0,
        1003.3821411132812,
        144.0
      ],
      [
        -160.0,
        1003.3821411132812,
        230.0
      ],
      [
        -100.0,
        899.4596557617188,
        230.0
      ],
      [
        -160.0,
        1003.3821411132812,
        230.0
      ],
      [
        -100.0,
        899.4596557617188,
        155.0
      ],
      [
        -100.0,
        899.4596557617188,
        230.0
      ],
      [
        -59.897216796875,
        830.0,
        155.0
      ],
      [
        -94.53842163085938,
        890.0,
        155.0
      ],
      [
        -59.897216796875,
        830.0,
        155.0
      ],
      [
        -100.0,
        899.4596557617188,
        155.0
      ],
      [
        -94.53842163085938,
        890.0,
        144.0
      ],
      [
        -59.897216796875,
        830.0,
        144.0
      ],
      [
        -94.53842163085938,
        890.0,
        82.0
      ],
      [
        -59.897216796875,
        830.0,
        82.0
      ],
      [
        -94.53842163085938,
        890.0,
        124.0
      ],
      [
        -94.53842163085938,
        890.0,
        144.0
      ],
      [
        -94.53842163085938,
        890.0,
        104.0
      ],
      [
        -94.53842163085938,
        890.0,
        124.0
      ],
      [
        -94.53842163085938,
        890.0,
        82.0
      ],
      [
        -94.53842163085938,
        890.0,
        104.0
      ],
      [
        -65.55984497070312,
        839.8079223632812,
        155.0
      ],
      [
        -65.55984497070312,
        839.8079223632812,
        175.0
      ],
      [
        -65.55984497070312,
        839.8079223632812,
        175.0
      ],
      [
        -59.897216796875,
        830.0,
        175.0
      ],
      [
        -150.0,
        840.0,
        250.00001525878906
      ],
      [
        -150.0,
        942.0,
        250.00001525878906
      ],
      [
        -150.0,
        942.0,
        250.00001525878906
      ],
      [
        -160.0,
        942.0,
        250.00001525878906
      ],
      [
        -110.0,
        916.7801513671875,
        230.0
      ],
      [
        -110.0,
        916.7801513671875,
        250.00001525878906
      ],
      [
        -110.0,
        840.0,
        250.00001525878906
      ],
      [
        -100.0,
        899.4596557617188,
        230.0
      ],
      [
        -100.0,
        830.0,
        250.00001525878906
      ],
      [
        -100.0,
        899.459716796875,
        250.00001525878906
      ],
      [
        -110.0,
        840.0,
        240.0
      ],
      [
        -150.0,
        840.0,
        240.0
      ],
      [
        -110.0,
        840.0,
        250.00001525878906
      ],
      [
        -150.0,
        840.0,
        250.00001525878906
      ],
      [
        -289.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -254.5,
        911.17822265625,
        250.0
      ],
      [
        -254.5,
        911.17822265625,
        249.99998474121094
      ],
      [
        -289.5,
        971.800048828125,
        250.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        250.0
      ],
      [
        -289.5,
        971.800048828125,
        249.99998474121094
      ],
      [
        -309.5,
        971.800048828125,
        250.0
      ],
      [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -289.5,
        850.556396484375,
        250.0
      ],
      [
        -301.04693603515625,
        830.556396484375,
        60.00611877441406
      ],
      [
        -309.5,
        1006.4411010742188,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      [
        -309.5,
        1006.4411010742188,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        205.0
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        205.0
      ],
      [
        -309.5,
        1006.4411010742188,
        205.0
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        205.0
      ],
      [
        -290.7701416015625,
        974.0,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -290.7701416015625,
        974.0,
        210.0
      ],
      [
        -290.7701416015625,
        974.0,
        205.0
      ],
      [
        -309.5,
        1006.4411010742188,
        80.00611877441406
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        67.32662200927734
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        67.32662200927734
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        100.00397491455078
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        120.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        95.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        75.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        225.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        205.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        80.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        100.00397491455078
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        120.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        95.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        120.0
      ],
      [
        -293.78204345703125,
        1075.0986328125,
        250.00003051757812
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        250.00001525878906
      ],
      [
        -309.5,
        1066.02392578125,
        205.0
      ],
      [
        -309.5,
        1066.02392578125,
        225.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        225.0
      ],
      [
        -216.40597534179688,
        1101.0794677734375,
        225.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        200.0
      ],
      [
        -216.40597534179688,
        1101.0794677734375,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        202.5
      ],
      [
        -229.5,
        971.800048828125,
        202.5
      ],
      [
        -309.5,
        1051.800048828125,
        200.0
      ],
      [
        -309.5,
        1051.800048828125,
        202.5
      ],
      [
        -293.78204345703125,
        1075.0986328125,
        202.5
      ],
      [
        -293.78204345703125,
        1075.0986328125,
        200.0
      ],
      [
        -218.6538543701172,
        1101.0794677734375,
        210.0
      ],
      [
        -216.40597534179688,
        1101.0794677734375,
        210.0
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        205.0
      ],
      [
        -186.49981689453125,
        1045.8394775390625,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -230.61416625976562,
        973.7813720703125,
        205.0
      ],
      [
        -230.61416625976562,
        973.7813720703125,
        205.0
      ],
      [
        -186.49981689453125,
        1045.8394775390625,
        205.0
      ],
      [
        -229.5,
        971.800048828125,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        210.0
      ],
      [
        -216.40597534179688,
        1101.0794677734375,
        205.0
      ],
      [
        -228.25640869140625,
        1101.0794677734375,
        205.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        205.0
      ],
      [
        -228.25640869140625,
        1101.0794677734375,
        205.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -218.6538543701172,
        1101.0794677734375,
        210.0
      ],
      [
        -218.6538543701172,
        1101.0794677734375,
        205.0
      ],
      [
        -242.9530029296875,
        931.17822265625,
        60.00611877441406
      ],
      [
        -289.5,
        1011.7999877929688,
        60.00611877441406
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        80.0
      ],
      [
        -228.2564239501953,
        1101.0794677734375,
        69.74037170410156
      ],
      [
        -202.9528045654297,
        1077.7781982421875,
        60.00611877441406
      ],
      [
        -216.40599060058594,
        1101.0794677734375,
        80.0
      ],
      [
        -228.2564239501953,
        1101.0794677734375,
        69.74037170410156
      ],
      [
        -239.5,
        1141.0794677734375,
        250.0
      ],
      [
        -308.78204345703125,
        1101.0794677734375,
        250.0
      ],
      [
        -224.5,
        1115.0986328125,
        250.0
      ],
      [
        -228.2552490234375,
        1121.6031494140625,
        95.0
      ],
      [
        -228.2552490234375,
        1121.6031494140625,
        75.26748657226562
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -279.5001220703125,
        1210.361328125,
        120.0
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        120.0
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -295.0,
        1210.361328125,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -286.0,
        1143.9903564453125,
        62.0
      ],
      [
        -286.0,
        1143.9903564453125,
        61.5
      ],
      [
        -276.3349304199219,
        1147.25,
        61.5
      ],
      [
        -276.3349304199219,
        1147.25,
        62.0
      ],
      [
        -293.6554260253906,
        1137.25,
        62.0
      ],
      [
        -293.6554260253906,
        1137.25,
        61.5
      ],
      [
        -286.0,
        1143.9903564453125,
        61.5
      ],
      [
        -286.0,
        1143.9903564453125,
        62.0
      ],
      [
        -276.3349304199219,
        1147.25,
        62.0
      ],
      [
        -276.3349304199219,
        1147.25,
        61.5
      ],
      [
        -267.25,
        1146.1553955078125,
        61.5
      ],
      [
        -267.25,
        1146.1553955078125,
        62.0
      ],
      [
        -297.25,
        1128.8349609375,
        62.0
      ],
      [
        -297.25,
        1128.8349609375,
        61.5
      ],
      [
        -293.6554260253906,
        1137.25,
        61.5
      ],
      [
        -293.6554260253906,
        1137.25,
        62.0
      ],
      [
        -295.82049560546875,
        1121.0,
        62.0
      ],
      [
        -295.82049560546875,
        1121.0,
        61.5
      ],
      [
        -297.25,
        1128.8349609375,
        61.5
      ],
      [
        -297.25,
        1128.8349609375,
        62.0
      ],
      [
        -267.25,
        1146.1553955078125,
        62.0
      ],
      [
        -267.25,
        1146.1553955078125,
        61.5
      ],
      [
        -261.17950439453125,
        1141.0,
        61.5
      ],
      [
        -261.17950439453125,
        1141.0,
        62.0
      ],
      [
        -289.5,
        1167.205810546875,
        62.0
      ],
      [
        -289.5,
        1167.205810546875,
        61.5
      ],
      [
        -294.0,
        1175.0,
        61.5
      ],
      [
        -294.0,
        1175.0,
        62.0
      ],
      [
        -289.5,
        1182.794189453125,
        62.0
      ],
      [
        -289.5,
        1182.794189453125,
        61.5
      ],
      [
        -280.5,
        1182.794189453125,
        61.5
      ],
      [
        -280.5,
        1182.794189453125,
        62.0
      ],
      [
        -294.0,
        1175.0,
        62.0
      ],
      [
        -294.0,
        1175.0,
        61.5
      ],
      [
        -289.5,
        1182.794189453125,
        61.5
      ],
      [
        -289.5,
        1182.794189453125,
        62.0
      ],
      [
        -309.5,
        1147.0,
        62.0
      ],
      [
        -309.5,
        1147.0,
        61.5
      ],
      [
        -306.0,
        1147.0,
        61.5
      ],
      [
        -306.0,
        1147.0,
        62.0
      ],
      [
        -285.25,
        1175.0,
        85.93565368652344
      ],
      [
        -285.25,
        1175.0,
        88.75
      ],
      [
        -285.25,
        1172.5,
        86.92878723144531
      ],
      [
        -285.25,
        1175.0,
        80.98438262939453
      ],
      [
        -285.25,
        1172.5,
        81.9775390625
      ],
      [
        -285.25,
        1175.0,
        74.83157348632812
      ],
      [
        -285.25,
        1172.5,
        75.82475280761719
      ],
      [
        -285.2054443359375,
        1141.0015869140625,
        65.0
      ],
      [
        -285.5990905761719,
        1141.4544677734375,
        65.0
      ],
      [
        -285.5990905761719,
        1141.4544677734375,
        65.0
      ],
      [
        -286.4653015136719,
        1141.2315673828125,
        64.68001556396484
      ],
      [
        -286.7277526855469,
        1141.5333251953125,
        64.76000213623047
      ],
      [
        -286.7277526855469,
        1141.5333251953125,
        64.76000213623047
      ],
      [
        -287.029541015625,
        1141.27099609375,
        64.760009765625
      ],
      [
        -286.9994201660156,
        1141.2972412109375,
        64.760009765625
      ],
      [
        -289.5,
        1167.205810546875,
        62.5
      ],
      [
        -294.0,
        1175.0,
        62.5
      ],
      [
        -309.5,
        1147.0,
        65.0
      ],
      [
        -306.0,
        1147.0,
        65.0
      ],
      [
        -285.25,
        1175.0,
        65.0
      ],
      [
        -287.7679443359375,
        1185.794189453125,
        62.5
      ],
      [
        -289.5,
        1182.794189453125,
        62.5
      ],
      [
        -280.5,
        1182.794189453125,
        62.5
      ],
      [
        -285.25,
        1187.7750244140625,
        79.90657806396484
      ],
      [
        -285.25,
        1175.0,
        74.83158111572266
      ],
      [
        -285.25,
        1185.219970703125,
        85.04440307617188
      ],
      [
        -285.25,
        1175.0,
        80.9843978881836
      ],
      [
        -285.25,
        1183.176025390625,
        89.18366241455078
      ],
      [
        -285.25,
        1175.0,
        85.93566131591797
      ],
      [
        -289.4999694824219,
        971.800048828125,
        350.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        500.0
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        250.00001525878906
      ],
      [
        -248.7819061279297,
        1101.0794677734375,
        300.0
      ],
      [
        -216.40597534179688,
        1101.0794677734375,
        300.0
      ],
      [
        -110.0,
        916.7801513671875,
        260.0
      ],
      [
        -100.0,
        899.4596557617188,
        260.0
      ],
      [
        -110.0,
        916.7801513671875,
        260.0
      ],
      [
        -100.0,
        899.459716796875,
        260.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        270.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        250.0
      ],
      [
        -309.5,
        1130.4095458984375,
        400.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.477783203125,
        1210.361328125,
        60.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -249.42201232910156,
        1158.2647705078125,
        120.0
      ],
      [
        -261.042724609375,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -139.4999237060547,
        1210.361328125,
        100.00611877441406
      ],
      [
        -139.4999237060547,
        1210.361328125,
        120.00611877441406
      ],
      [
        -139.4999237060547,
        1210.361328125,
        80.0
      ],
      [
        -139.4999237060547,
        1210.361328125,
        100.00611877441406
      ],
      [
        -139.4999237060547,
        1210.361328125,
        120.00611877441406
      ],
      [
        -139.4999237060547,
        1210.361328125,
        500.0
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        500.0
      ],
      [
        -249.49725341796875,
        1158.40478515625,
        120.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        120.0
      ],
      [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -261.1859130859375,
        1178.661376953125,
        120.0
      ],
      [
        -261.18621826171875,
        1178.6611328125,
        120.0
      ],
      [
        -139.4999237060547,
        1210.361328125,
        80.0
      ],
      [
        -116.40591430664062,
        1210.361328125,
        60.00611877441406
      ],
      [
        -97.95298767089844,
        1178.39990234375,
        60.00611877441406
      ],
      [
        -121.4059829711914,
        1097.7781982421875,
        60.00611877441406
      ],
      [
        -160.0,
        1050.0,
        155.0
      ],
      [
        -100.0,
        1050.0,
        155.0
      ],
      [
        -160.0,
        1050.0,
        155.0
      ],
      [
        -160.0,
        1003.3821411132812,
        155.0
      ],
      [
        -50.0,
        830.0,
        82.0
      ],
      [
        -59.897216796875,
        830.0,
        82.0
      ],
      [
        0.0,
        839.9456176757812,
        144.0
      ],
      [
        0.0,
        839.9456176757812,
        155.0
      ],
      [
        0.0,
        849.4273681640625,
        155.0
      ],
      [
        0.0,
        849.4273681640625,
        175.0
      ],
      [
        0.0,
        849.4273681640625,
        175.0
      ],
      [
        0.0,
        839.9456176757812,
        175.0
      ],
      [
        0.0,
        1027.272705078125,
        104.0
      ],
      [
        0.0,
        903.6550903320312,
        104.0
      ],
      [
        0.0,
        1027.272705078125,
        104.0
      ],
      [
        0.0,
        1027.272705078125,
        102.0
      ],
      [
        0.0,
        903.6550903320312,
        102.0
      ],
      [
        0.0,
        1027.272705078125,
        102.0
      ],
      [
        -50.0,
        830.0,
        104.0
      ],
      [
        -50.0,
        830.0,
        102.0
      ],
      [
        0.0,
        839.9456176757812,
        102.0
      ],
      [
        0.0,
        839.9456176757812,
        104.0
      ],
      [
        0.0,
        903.6550903320312,
        104.0
      ],
      [
        0.0,
        903.6550903320312,
        102.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        82.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        80.0
      ],
      [
        0.0,
        1000.0,
        80.0
      ],
      [
        0.0,
        1000.0,
        80.0
      ],
      [
        -28.569734573364258,
        864.2627563476562,
        80.0
      ],
      [
        1.9584635424507724e-07,
        869.9456176757812,
        80.0
      ],
      [
        1.639127589214695e-07,
        869.9456176757812,
        82.0
      ],
      [
        -50.0,
        890.0,
        80.0
      ],
      [
        -33.16192626953125,
        893.3493041992188,
        80.0
      ],
      [
        0.0,
        903.6550903320312,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        80.0
      ],
      [
        -33.161930084228516,
        893.3493041992188,
        80.0
      ],
      [
        -33.16192626953125,
        875.3493041992188,
        80.0
      ],
      [
        -33.161930084228516,
        875.3493041992188,
        80.0
      ],
      [
        -28.56973648071289,
        864.2627563476562,
        80.0
      ],
      [
        0.0,
        879.289306640625,
        77.0
      ],
      [
        0.0,
        869.9456176757812,
        77.33370208740234
      ],
      [
        0.0,
        879.289306640625,
        77.0
      ],
      [
        0.0,
        898.7388305664062,
        76.30537414550781
      ],
      [
        0.0,
        899.9456176757812,
        76.20401763916016
      ],
      [
        0.0,
        898.7388305664062,
        76.30537414550781
      ],
      [
        2.384185791015625e-07,
        869.9456176757812,
        77.33370208740234
      ],
      [
        0.0,
        903.6550903320312,
        60.0
      ],
      [
        0.0,
        903.6550903320312,
        75.89246368408203
      ],
      [
        0.0,
        903.6550903320312,
        75.89246368408203
      ],
      [
        2.384185791015625e-07,
        869.9456176757812,
        92.26585388183594
      ],
      [
        0.0,
        867.943359375,
        92.26585388183594
      ],
      [
        2.384185791015625e-07,
        867.9434204101562,
        92.26585388183594
      ],
      [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      [
        0.0,
        869.9456176757812,
        92.26585388183594
      ],
      [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      [
        0.0,
        839.9456176757812,
        92.26585388183594
      ],
      [
        0.0,
        1000.0,
        126.0
      ],
      [
        0.0,
        903.6550903320312,
        126.0
      ],
      [
        0.0,
        1000.0,
        126.0
      ],
      [
        0.0,
        903.6550903320312,
        124.0
      ],
      [
        0.0,
        1000.0,
        124.0
      ],
      [
        0.0,
        1000.0,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        126.0
      ],
      [
        -50.0,
        830.0,
        126.0
      ],
      [
        -50.0,
        830.0,
        124.0
      ],
      [
        -50.0,
        830.0,
        126.0
      ],
      [
        -50.0,
        830.0,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        126.0
      ],
      [
        0.0,
        903.6550903320312,
        126.0
      ],
      [
        0.0,
        903.6550903320312,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        120.0
      ],
      [
        0.0,
        839.9456176757812,
        140.0
      ],
      [
        0.0,
        839.9456176757812,
        144.0
      ],
      [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      [
        -355.0,
        1210.361328125,
        120.0
      ],
      [
        -355.0,
        1210.4000244140625,
        60.0
      ],
      [
        -369.4775085449219,
        1210.4000244140625,
        60.0
      ],
      [
        -369.4775085449219,
        1210.4000244140625,
        80.0
      ],
      [
        -369.4775085449219,
        1210.4000244140625,
        80.0
      ],
      [
        -369.4775390625,
        1210.4000244140625,
        120.0
      ],
      [
        -369.4775390625,
        1210.4000244140625,
        120.0
      ],
      [
        -295.0,
        1210.4000244140625,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        120.0
      ],
      [
        -295.0,
        1210.4000244140625,
        60.0
      ],
      [
        -315.0,
        1230.0,
        95.0
      ],
      [
        -335.0,
        1230.0,
        95.0
      ],
      [
        -335.0,
        1230.0,
        95.0
      ],
      [
        -315.0,
        1230.0,
        95.0
      ],
      [
        -121.40599822998047,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -237.59400939941406,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -399.4999694824219,
        1158.39990234375,
        120.0
      ],
      [
        -399.5028076171875,
        1158.4046630859375,
        120.0
      ],
      [
        -425.51434326171875,
        1115.6875,
        95.0
      ],
      [
        -425.51434326171875,
        1115.6875,
        103.15575408935547
      ],
      [
        -387.95721435546875,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -411.4059753417969,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -492.9654846191406,
        1239.0,
        60.02784729003906
      ],
      [
        -551.0469970703125,
        1178.39990234375,
        60.00611877441406
      ],
      [
        -604.3262329101562,
        1098.025634765625,
        214.0
      ],
      [
        -586.2904663085938,
        1097.7781982421875,
        60.0
      ],
      [
        -586.2904663085938,
        1097.7781982421875,
        214.0
      ],
      [
        -586.2904663085938,
        1097.7781982421875,
        214.0
      ],
      [
        -604.1851806640625,
        1097.7781982421875,
        214.0
      ],
      [
        -527.593994140625,
        1097.7781982421875,
        60.00611877441406
      ],
      [
        680.0,
        1372.96533203125,
        80.0
      ],
      [
        664.30078125,
        1384.3714599609375,
        80.0
      ],
      [
        680.0,
        1384.3714599609375,
        80.0
      ],
      [
        565.69921875,
        1384.3714599609375,
        80.0
      ],
      [
        535.7269287109375,
        1362.5953369140625,
        80.0
      ],
      [
        542.8024291992188,
        1384.3714599609375,
        80.0
      ],
      [
        680.0,
        1460.0,
        80.0
      ],
      [
        680.0,
        1460.0,
        190.0
      ],
      [
        680.0,
        1450.0,
        60.0
      ],
      [
        564.12646484375,
        1450.0,
        60.0
      ],
      [
        567.3756713867188,
        1460.0,
        80.0
      ],
      [
        680.0,
        1460.0,
        80.0
      ],
      [
        680.0,
        1420.0,
        78.0
      ],
      [
        554.3788452148438,
        1420.0,
        78.0
      ],
      [
        554.3788452148438,
        1420.0,
        80.0
      ],
      [
        680.0,
        1420.0,
        80.0
      ],
      [
        680.0,
        1420.0,
        80.0
      ],
      [
        680.0,
        1440.0,
        80.0
      ],
      [
        547.8804931640625,
        1400.0,
        80.0
      ],
      [
        680.0,
        1400.0,
        80.0
      ],
      [
        505.25732421875,
        1301.1802978515625,
        80.0
      ],
      [
        500.0,
        1317.360595703125,
        80.0
      ],
      [
        480.0,
        1378.914306640625,
        80.0
      ],
      [
        500.0,
        1317.3607177734375,
        80.0
      ],
      [
        500.0,
        1317.360595703125,
        60.0
      ],
      [
        500.0,
        1317.360595703125,
        80.0
      ],
      [
        480.0,
        1378.914306640625,
        78.0
      ],
      [
        480.0,
        1378.914306640625,
        80.0
      ],
      [
        505.25732421875,
        1301.1802978515625,
        80.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1130.0,
        100.0
      ],
      [
        450.0,
        1300.0,
        80.0
      ],
      [
        450.0,
        1280.0,
        80.0
      ],
      [
        450.0,
        1280.0,
        78.0
      ],
      [
        450.0,
        1280.0,
        80.0
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        91.5
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        330.0
      ],
      [
        450.0,
        920.0,
        140.0
      ],
      [
        450.0,
        920.0,
        460.0
      ],
      [
        450.0,
        980.0,
        330.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        680.0,
        980.0,
        160.0
      ],
      [
        450.0,
        980.0,
        160.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        680.0,
        980.0,
        190.0
      ],
      [
        680.0,
        980.0,
        80.0
      ],
      [
        450.0,
        980.0,
        80.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        680.0,
        980.0,
        120.0
      ],
      [
        680.0,
        980.0,
        120.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        120.0
      ],
      [
        680.0,
        1000.0,
        120.0
      ],
      [
        680.0,
        940.0,
        80.0
      ],
      [
        450.0,
        940.0,
        80.0
      ],
      [
        450.0,
        980.0,
        80.0
      ],
      [
        680.0,
        980.0,
        80.0
      ],
      [
        450.0,
        930.0,
        60.0
      ],
      [
        680.0,
        930.0,
        60.0
      ],
      [
        680.0,
        920.0,
        80.0
      ],
      [
        450.0,
        920.0,
        80.0
      ],
      [
        700.0,
        1040.0,
        120.0
      ],
      [
        720.0,
        1040.0,
        120.0
      ],
      [
        190.0,
        1547.5423583984375,
        130.0
      ],
      [
        190.0,
        1500.0,
        130.0
      ],
      [
        190.0,
        1000.0,
        130.0
      ],
      [
        190.0,
        1500.0,
        130.0
      ],
      [
        180.0,
        1678.487548828125,
        120.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        190.0,
        1693.45361328125,
        130.0
      ],
      [
        180.0,
        1678.487548828125,
        130.0
      ],
      [
        180.0,
        1678.487548828125,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        180.0,
        1678.487548828125,
        120.0
      ],
      [
        180.0,
        1316.438720703125,
        75.0
      ],
      [
        180.0,
        1342.320556640625,
        75.0
      ],
      [
        190.0,
        829.921142578125,
        120.0
      ],
      [
        190.0,
        829.921142578125,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        130.0
      ],
      [
        190.0,
        1693.45361328125,
        140.0
      ],
      [
        180.0,
        1678.487548828125,
        140.0
      ],
      [
        190.0,
        829.921142578125,
        140.0
      ],
      [
        190.0,
        820.0,
        140.0
      ],
      [
        190.0,
        829.921142578125,
        140.0
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        120.0,
        1500.0,
        214.0
      ],
      [
        120.0,
        820.081787109375,
        120.0
      ],
      [
        120.0,
        820.0,
        120.0
      ],
      [
        260.0,
        1460.0,
        140.0
      ],
      [
        252.04348754882812,
        1460.0,
        140.0
      ],
      [
        252.0435028076172,
        1460.0,
        240.0
      ],
      [
        231.15760803222656,
        1507.89892578125,
        240.0
      ],
      [
        260.0379333496094,
        1551.121337890625,
        140.0
      ],
      [
        250.0,
        1460.0,
        140.0
      ],
      [
        260.0379333496094,
        1551.121337890625,
        120.0
      ],
      [
        260.0379333496094,
        1551.121337890625,
        140.0
      ],
      [
        250.0,
        1460.0,
        120.0
      ],
      [
        250.0,
        1460.0,
        140.0
      ],
      [
        250.0,
        1460.0,
        120.0
      ],
      [
        242.1457977294922,
        1460.0,
        120.0
      ],
      [
        260.0379333496094,
        1551.121337890625,
        120.0
      ],
      [
        230.1345672607422,
        1500.0,
        120.0
      ],
      [
        230.14447021484375,
        1502.9405517578125,
        120.0
      ],
      [
        231.15762329101562,
        1507.89892578125,
        120.0
      ],
      [
        230.1345672607422,
        1500.0,
        120.0
      ],
      [
        230.0,
        1460.0,
        120.0
      ],
      [
        251.720458984375,
        1591.6343994140625,
        240.0
      ],
      [
        246.7465362548828,
        1584.1904296875,
        120.0
      ],
      [
        293.9225769042969,
        1619.8328857421875,
        120.0
      ],
      [
        246.7465362548828,
        1584.1904296875,
        120.0
      ],
      [
        251.72032165527344,
        1591.63427734375,
        120.0
      ],
      [
        293.9225769042969,
        1619.8328857421875,
        140.0
      ],
      [
        301.8798522949219,
        1660.537109375,
        240.0
      ],
      [
        351.6609802246094,
        1670.439208984375,
        120.0
      ],
      [
        294.4365234375,
        1655.5635986328125,
        120.0
      ],
      [
        301.8798522949219,
        1660.537109375,
        120.0
      ],
      [
        294.4364929199219,
        1655.5635986328125,
        120.0
      ],
      [
        351.6609802246094,
        1670.439208984375,
        140.0
      ],
      [
        365.8096923828125,
        1703.2535400390625,
        120.0
      ],
      [
        450.0,
        1759.507568359375,
        130.0
      ],
      [
        430.2540283203125,
        1746.313720703125,
        130.0
      ],
      [
        430.2540283203125,
        1746.313720703125,
        120.0
      ],
      [
        430.2540588378906,
        1746.313720703125,
        130.0
      ],
      [
        229.54360961914062,
        1500.0,
        120.0
      ],
      [
        229.54360961914062,
        1500.0,
        120.0
      ],
      [
        221.37026977539062,
        1460.0,
        120.0
      ],
      [
        203.68621826171875,
        1519.745849609375,
        120.0
      ],
      [
        200.0,
        1460.0,
        120.0
      ],
      [
        203.68621826171875,
        1519.745849609375,
        130.0
      ],
      [
        190.4924774169922,
        1500.0,
        130.0
      ],
      [
        190.0,
        1460.0,
        130.0
      ],
      [
        190.0,
        1499.262939453125,
        130.0
      ],
      [
        190.4924774169922,
        1500.0,
        130.0
      ],
      [
        200.0,
        1460.0,
        130.0
      ],
      [
        228.0021514892578,
        1611.173583984375,
        120.0
      ],
      [
        228.0021514892578,
        1611.173583984375,
        130.0
      ],
      [
        210.2459716796875,
        1599.309326171875,
        130.0
      ],
      [
        199.35842895507812,
        1592.0345458984375,
        130.0
      ],
      [
        210.24598693847656,
        1599.309326171875,
        130.0
      ],
      [
        228.0021514892578,
        1611.173583984375,
        120.0
      ],
      [
        228.0021514892578,
        1611.173583984375,
        130.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        120.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        140.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        130.0
      ],
      [
        190.0,
        1693.45361328125,
        130.0
      ],
      [
        250.0,
        1310.0,
        120.0
      ],
      [
        200.0,
        1310.0,
        120.0
      ],
      [
        270.0,
        1310.0,
        120.0
      ],
      [
        270.0,
        1415.0,
        120.0
      ],
      [
        215.2666778564453,
        1310.0,
        75.0
      ],
      [
        250.0,
        1310.0,
        120.0
      ],
      [
        250.0,
        1310.0,
        140.0
      ],
      [
        250.0,
        1310.0,
        140.0
      ],
      [
        260.0,
        1310.0,
        140.0
      ],
      [
        190.0,
        1310.0,
        130.0
      ],
      [
        200.0,
        1310.0,
        130.0
      ],
      [
        254.03262329101562,
        920.0,
        160.0
      ],
      [
        254.03262329101562,
        920.0,
        420.0
      ],
      [
        244.08700561523438,
        920.0,
        230.0
      ],
      [
        254.03262329101562,
        920.0,
        230.0
      ],
      [
        244.08700561523438,
        920.0,
        160.0
      ],
      [
        254.03262329101562,
        920.0,
        160.0
      ],
      [
        244.08700561523438,
        920.0,
        140.0
      ],
      [
        233.9503936767578,
        920.0,
        140.0
      ],
      [
        241.5006103515625,
        906.997314453125,
        120.0
      ],
      [
        241.5006103515625,
        906.997314453125,
        140.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      [
        233.9503936767578,
        920.0,
        120.0
      ],
      [
        233.9503936767578,
        920.0,
        140.0
      ],
      [
        244.08700561523438,
        920.0,
        120.0
      ],
      [
        244.08700561523438,
        920.0,
        140.0
      ],
      [
        244.08700561523438,
        920.0,
        160.0
      ],
      [
        244.08700561523438,
        920.0,
        230.0
      ],
      [
        244.08700561523438,
        920.0,
        210.0
      ],
      [
        254.03262329101562,
        920.0,
        350.0
      ],
      [
        244.08700561523438,
        920.0,
        350.0
      ],
      [
        244.08700561523438,
        920.0,
        370.0
      ],
      [
        244.08700561523438,
        920.0,
        350.0
      ],
      [
        244.08700561523438,
        920.0,
        300.0
      ],
      [
        244.08700561523438,
        920.0,
        280.0
      ],
      [
        250.0,
        1309.64111328125,
        75.0
      ],
      [
        250.0,
        1310.0,
        75.0
      ],
      [
        440.0,
        980.0,
        100.0
      ],
      [
        450.0,
        980.0,
        100.0
      ],
      [
        260.0,
        1000.0,
        135.0
      ],
      [
        310.0,
        970.0,
        140.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        250.0,
        949.7266235351562,
        120.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        250.0,
        949.7266235351562,
        140.0
      ],
      [
        250.0,
        1000.0,
        130.0
      ],
      [
        233.9503936767578,
        920.0,
        130.0
      ],
      [
        250.0,
        949.7266235351562,
        130.0
      ],
      [
        244.08700561523438,
        920.0,
        130.0
      ],
      [
        244.08700561523438,
        920.0,
        140.0
      ],
      [
        385.0,
        1240.0,
        140.0
      ],
      [
        310.0,
        980.0,
        170.00001525878906
      ],
      [
        385.0,
        980.0,
        140.0
      ],
      [
        310.0,
        980.0,
        170.00001525878906
      ],
      [
        92.0,
        1509.4034423828125,
        214.0
      ],
      [
        90.0,
        1509.4034423828125,
        214.0
      ],
      [
        37.0,
        1509.403564453125,
        214.0
      ],
      [
        35.0,
        1509.403564453125,
        214.0
      ],
      [
        90.0,
        1509.4034423828125,
        214.0
      ],
      [
        90.0,
        1511.5379638671875,
        214.0
      ],
      [
        35.0,
        1509.403564453125,
        214.0
      ],
      [
        35.0,
        1511.5380859375,
        214.0
      ],
      [
        90.0,
        1506.634521484375,
        217.0
      ],
      [
        35.0,
        1506.634521484375,
        217.0
      ],
      [
        110.0,
        949.7265625,
        175.0
      ],
      [
        0.0,
        844.9071655273438,
        175.0
      ],
      [
        84.7259750366211,
        901.519287109375,
        175.0
      ],
      [
        110.0,
        957.7964477539062,
        175.0
      ],
      [
        120.0,
        1000.0,
        80.0
      ],
      [
        120.0,
        1000.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        80.0
      ],
      [
        0.0,
        1040.0,
        80.0
      ],
      [
        0.0,
        1040.0,
        82.0
      ],
      [
        10.0,
        1040.0,
        82.0
      ],
      [
        10.0,
        1040.0,
        80.0
      ],
      [
        0.0,
        1050.0,
        82.0
      ],
      [
        0.0,
        1050.0,
        80.0
      ],
      [
        10.0,
        1050.0,
        80.0
      ],
      [
        10.0,
        1050.0,
        82.0
      ],
      [
        10.0,
        1040.0,
        80.0
      ],
      [
        10.0,
        1040.0,
        82.0
      ],
      [
        10.0,
        1050.0,
        82.0
      ],
      [
        10.0,
        1050.0,
        80.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        80.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        82.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      [
        90.0,
        1000.0,
        80.0
      ],
      [
        90.0,
        1000.0,
        82.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        82.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        80.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        80.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        82.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        82.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        80.0
      ],
      [
        1.6391277313232422e-07,
        869.9456176757812,
        82.0
      ],
      [
        1.9584635424507724e-07,
        869.9456176757812,
        80.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        75.05838012695312
      ],
      [
        48.99494934082031,
        901.0050659179688,
        73.9999771118164
      ],
      [
        48.99494934082031,
        901.0050659179688,
        73.99998474121094
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        79.9343032836914
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        79.9343032836914
      ],
      [
        2.6880502700805664,
        870.4802856445312,
        80.0
      ],
      [
        120.0,
        1000.0,
        124.0
      ],
      [
        120.0,
        1000.0,
        126.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        126.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        124.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        126.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        124.0
      ],
      [
        117.84325408935547,
        989.1572875976562,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        126.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        126.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        124.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        126.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        126.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        126.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        124.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        126.0
      ],
      [
        120.0,
        1000.0,
        124.0
      ],
      [
        90.0,
        1000.0,
        124.0
      ],
      [
        0.0,
        1040.0,
        124.0
      ],
      [
        0.0,
        1040.0,
        126.0
      ],
      [
        10.0,
        1040.0,
        126.0
      ],
      [
        10.0,
        1040.0,
        124.0
      ],
      [
        0.0,
        1050.0,
        126.0
      ],
      [
        0.0,
        1050.0,
        124.0
      ],
      [
        10.0,
        1050.0,
        124.0
      ],
      [
        10.0,
        1050.0,
        126.0
      ],
      [
        10.0,
        1040.0,
        124.0
      ],
      [
        10.0,
        1040.0,
        126.0
      ],
      [
        10.0,
        1050.0,
        126.0
      ],
      [
        10.0,
        1050.0,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        0.0,
        839.9456176757812,
        126.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        0.0,
        839.9456176757812,
        126.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      [
        113.2238540649414,
        991.0707397460938,
        124.0
      ],
      [
        90.0,
        1000.0,
        124.0
      ],
      [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      [
        117.84325408935547,
        989.1572875976562,
        124.0
      ],
      [
        113.2238540649414,
        991.0707397460938,
        124.0
      ],
      [
        84.09091186523438,
        1210.0,
        102.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      [
        60.18052291870117,
        873.0916137695312,
        102.0
      ],
      [
        120.0,
        1000.0,
        102.0
      ],
      [
        120.0,
        1000.0,
        104.0
      ],
      [
        90.0,
        1000.0,
        104.0
      ],
      [
        90.0,
        1000.0,
        102.0
      ],
      [
        0.0,
        1040.0,
        102.0
      ],
      [
        0.0,
        1040.0,
        104.0
      ],
      [
        10.0,
        1040.0,
        104.0
      ],
      [
        10.0,
        1040.0,
        102.0
      ],
      [
        0.0,
        1050.0,
        104.0
      ],
      [
        0.0,
        1050.0,
        102.0
      ],
      [
        10.0,
        1050.0,
        102.0
      ],
      [
        10.0,
        1050.0,
        104.0
      ],
      [
        10.0,
        1040.0,
        102.0
      ],
      [
        10.0,
        1040.0,
        104.0
      ],
      [
        10.0,
        1050.0,
        104.0
      ],
      [
        10.0,
        1050.0,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        104.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        102.0
      ],
      [
        58.09315490722656,
        878.1309814453125,
        102.0
      ],
      [
        43.47709274291992,
        892.7470092773438,
        102.0
      ],
      [
        60.18052291870117,
        873.0916137695312,
        102.0
      ],
      [
        58.09315872192383,
        878.1309814453125,
        102.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      [
        9.452666282653809,
        841.8258666992188,
        104.0
      ],
      [
        9.452665328979492,
        841.8258666992188,
        102.0
      ],
      [
        90.0,
        1000.0,
        102.0
      ],
      [
        90.0,
        1000.0,
        104.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        104.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        102.0
      ],
      [
        40.736900329589844,
        895.4871826171875,
        102.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        102.0
      ],
      [
        40.736900329589844,
        895.4871826171875,
        102.0
      ],
      [
        0.0,
        839.9456176757812,
        104.0
      ],
      [
        0.0,
        839.9456176757812,
        102.0
      ],
      [
        84.09091186523438,
        1240.0,
        102.0
      ],
      [
        84.09091186523438,
        1210.0,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        98.39308166503906
      ],
      [
        79.34313201904297,
        946.42431640625,
        100.39305114746094
      ],
      [
        48.99494934082031,
        901.0050659179688,
        90.1213607788086
      ],
      [
        48.99494934082031,
        901.0050659179688,
        88.12139892578125
      ],
      [
        84.09092712402344,
        970.2930908203125,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        100.39305114746094
      ],
      [
        79.34313201904297,
        946.42431640625,
        98.39308166503906
      ],
      [
        48.99494934082031,
        901.0050659179688,
        88.12139892578125
      ],
      [
        48.99494934082031,
        901.0050659179688,
        90.1213607788086
      ],
      [
        25.000017166137695,
        884.97216796875,
        82.0
      ],
      [
        30.90899085998535,
        888.92041015625,
        82.0
      ],
      [
        48.70002746582031,
        900.8079833984375,
        102.0
      ],
      [
        3.8616164488303184e-08,
        868.2676391601562,
        92.26585388183594
      ],
      [
        90.0,
        1000.0,
        119.21685028076172
      ],
      [
        79.34313201904297,
        946.42431640625,
        112.23529815673828
      ],
      [
        120.0,
        1000.0,
        122.47760772705078
      ],
      [
        90.0,
        1000.0,
        119.21685028076172
      ],
      [
        116.21810150146484,
        980.9871215820312,
        120.0
      ],
      [
        120.0,
        1000.0,
        122.47760772705078
      ],
      [
        79.34313201904297,
        946.42431640625,
        112.23529815673828
      ],
      [
        0.0,
        1050.0,
        114.86918640136719
      ],
      [
        10.0,
        1050.0,
        115.95610809326172
      ],
      [
        10.0,
        1040.0,
        114.86918640136719
      ],
      [
        10.0,
        1050.0,
        115.95610809326172
      ],
      [
        0.0,
        1040.0,
        113.78226470947266
      ],
      [
        10.0,
        1040.0,
        114.86918640136719
      ],
      [
        90.0,
        1000.0,
        123.8823471069336
      ],
      [
        91.6667251586914,
        1000.0,
        124.0
      ],
      [
        90.0,
        1000.0,
        123.8823471069336
      ],
      [
        113.52976989746094,
        967.471923828125,
        120.0
      ],
      [
        117.84325408935547,
        989.1572875976562,
        124.0
      ],
      [
        111.55712890625,
        991.0707397460938,
        124.0
      ],
      [
        113.4536361694336,
        967.0891723632812,
        120.0
      ],
      [
        117.71638488769531,
        988.5194702148438,
        124.0
      ],
      [
        117.71638488769531,
        988.5194702148438,
        124.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6971.595703125,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6971.595703125,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        5234.39599609375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        2699.5234375,
        1584.5428466796875
      ],
      "bbox_max": [
        -6764.20263671875,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6860.8203125,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        5234.39599609375,
        1640.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -5174.01171875,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        5234.39599609375,
        1002.1674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -5174.01171875,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        5234.39599609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5174.01171875,
        2110.39697265625,
        -300.0
      ],
      "bbox_max": [
        -3989.468505859375,
        5234.39599609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        -11.83917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4912.15185546875,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2568.059326171875,
        1002.1674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4100.0,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3843.76123046875,
        2213.74609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4002.859619140625,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3988.3173828125,
        2110.396728515625,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3989.468505859375,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3843.76123046875,
        2213.74609375,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4912.15185546875,
        2100.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2568.059326171875,
        1002.1674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        2100.0,
        987.7515258789062
      ],
      "bbox_max": [
        -4896.1435546875,
        2154.178466796875,
        1002.1674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        2100.0,
        1000.0
      ],
      "bbox_max": [
        -4897.6552734375,
        2154.178466796875,
        1003.6253662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -6158.31884765625,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        2154.178466796875,
        -11.839162826538086
      ],
      "bbox_max": [
        -3400.0,
        5224.01171875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        80.8882064819336
      ],
      "bbox_max": [
        -3400.0,
        2993.050048828125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6561.474609375,
        -4547.06494140625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        1612.981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4897.6552734375,
        -4540.619140625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4205.1796875,
        -4540.619140625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        -2619.13720703125,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4540.619140625,
        1040.098388671875
      ],
      "bbox_max": [
        -3400.0,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3510.67529296875,
        -3010.139404296875,
        -300.0
      ],
      "bbox_max": [
        -3507.62353515625,
        -3004.92626953125,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3622.3681640625,
        -3588.4169921875,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        -2165.83447265625,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3411.630126953125,
        -3448.20703125,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3502.183349609375,
        -3559.13720703125,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.01416015625,
        -2363.246337890625,
        -300.0
      ],
      "bbox_max": [
        -3581.70458984375,
        -2017.5599365234375,
        1182.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4896.1435546875,
        -3453.730224609375,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4110.0,
        -2908.416015625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4110.0,
        -2698.50390625,
        -300.0
      ],
      "bbox_max": [
        -3457.047119140625,
        2100.0,
        -300.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3988.3173828125,
        -2908.416015625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3605.199951171875,
        -2382.8056640625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        -2226.63818359375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3843.76123046875,
        -3453.730224609375,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        1224.3428955078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.02197265625,
        -3453.730224609375,
        -235.68954467773438
      ],
      "bbox_max": [
        -3400.0,
        -2269.10009765625,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3605.199951171875,
        -2269.120849609375,
        -0.0221405029296875
      ],
      "bbox_max": [
        -3605.1806640625,
        -2269.10009765625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3412.67578125,
        -3453.730224609375,
        1220.0
      ],
      "bbox_max": [
        -3403.804931640625,
        -3443.09521484375,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3662.39306640625,
        -2736.080078125,
        935.9595336914062
      ],
      "bbox_max": [
        -3400.0,
        -2424.958984375,
        1174.1900634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3605.181640625,
        -2737.88818359375,
        -235.68954467773438
      ],
      "bbox_max": [
        -3400.0,
        -2269.11083984375,
        716.9644165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3505.179443359375,
        -2737.88818359375,
        585.6629638671875
      ],
      "bbox_max": [
        -3400.0,
        -2619.13720703125,
        716.9644165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4897.80810546875,
        -4547.06494140625,
        1002.1674194335938
      ],
      "bbox_max": [
        -3400.0,
        2100.0,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3461.156005859375,
        -4547.06494140625,
        1370.3192138671875
      ],
      "bbox_max": [
        -3400.0,
        -4521.4228515625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.157958984375,
        -2384.524658203125,
        1179.1334228515625
      ],
      "bbox_max": [
        -3697.7392578125,
        -2323.6279296875,
        1299.860595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.303466796875,
        1210.558349609375
      ],
      "bbox_max": [
        -3702.4501953125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3725.179443359375,
        -3515.1591796875,
        1120.869140625
      ],
      "bbox_max": [
        -3400.0,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3702.4501953125,
        -2424.958984375,
        1174.1900634765625
      ],
      "bbox_max": [
        -3662.39306640625,
        -2378.303466796875,
        1210.558349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3697.797607421875,
        -2384.901123046875,
        1181.5367431640625
      ],
      "bbox_max": [
        -3697.488525390625,
        -2384.4521484375,
        1182.3106689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.179443359375,
        -2329.201904296875,
        1179.126708984375
      ],
      "bbox_max": [
        -3714.01416015625,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3400.0,
        -5240.431640625,
        -500.0
      ],
      "bbox_max": [
        7986.5068359375,
        7700.0,
        2700.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.1284712553024292,
        -0.3080694079399109,
        0.9426496624946594
      ],
      "plane_d": 160.421142578125,
      "bbox_min": [
        3956.501220703125,
        1225.50634765625,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5120849609375,
      "bbox_min": [
        3956.501220703125,
        1715.807373046875,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        6902.2900390625,
        2107.316162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        4081.29052734375,
        2248.64404296875,
        -300.0
      ],
      "bbox_max": [
        6697.86181640625,
        5446.76953125,
        2107.316162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        4081.29052734375,
        2887.37451171875,
        -300.0
      ],
      "bbox_max": [
        5574.01171875,
        5446.76953125,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        4081.29052734375,
        2887.37451171875,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4226.46826171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        4081.29052734375,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4120.587890625,
        4226.46826171875,
        -256.76629638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4089.31982421875,
        2887.37451171875,
        938.4326782226562
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        4096.705078125,
        2248.64404296875,
        959.0196533203125
      ],
      "bbox_max": [
        6202.4013671875,
        3724.434814453125,
        1892.318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4096.705078125,
        2248.64404296875,
        959.0196533203125
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4118.2841796875,
        2248.64404296875,
        1015.1317138671875
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8271484375,
      "bbox_min": [
        4117.16162109375,
        2269.442626953125,
        1016.0430908203125
      ],
      "bbox_max": [
        4137.6171875,
        2301.583251953125,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4118.24951171875,
        2269.442626953125,
        1019.1718139648438
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3956.501220703125,
        3098.861083984375,
        -300.0
      ],
      "bbox_max": [
        6306.5068359375,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.501220703125,
        4368.36962890625,
        -300.0
      ],
      "bbox_max": [
        5574.01171875,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        4368.36962890625,
        -300.0
      ],
      "bbox_max": [
        5574.01171875,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        4023.4130859375,
        4368.36962890625,
        -300.0
      ],
      "bbox_max": [
        4200.0,
        5100.0,
        -69.49503326416016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        6189.9755859375,
        919.1775512695312
      ],
      "bbox_max": [
        4128.3447265625,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        4024.458251953125,
        3098.861083984375,
        -300.0
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        4031.279296875,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4760.92822265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        4032.37158203125,
        4137.17724609375,
        -300.0
      ],
      "bbox_max": [
        4133.48828125,
        4729.65087890625,
        -114.25382995605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        4059.008056640625,
        3098.861083984375,
        0.0
      ],
      "bbox_max": [
        4237.6171875,
        4116.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        4059.008056640625,
        3098.861083984375,
        0.0
      ],
      "bbox_max": [
        4237.6171875,
        4116.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4087.392822265625,
        3098.861083984375,
        933.0609741210938
      ],
      "bbox_max": [
        4157.6171875,
        3154.043701171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4119.01025390625,
        1715.807373046875,
        911.6276245117188
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5120849609375,
      "bbox_min": [
        5334.2890625,
        2280.50634765625,
        1538.259033203125
      ],
      "bbox_max": [
        7986.5068359375,
        4175.6806640625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        6202.4013671875,
        3724.434814453125,
        1892.318603515625
      ],
      "bbox_max": [
        6811.5068359375,
        4175.6806640625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        100.0,
        4415.38427734375,
        -300.0
      ],
      "bbox_max": [
        4043.345947265625,
        7450.0,
        1318.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        100.0,
        4430.66259765625,
        -300.0
      ],
      "bbox_max": [
        4042.8125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        100.0,
        4430.66259765625,
        -300.0
      ],
      "bbox_max": [
        4042.8125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        140.185791015625,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        3977.864501953125,
        7267.0830078125,
        547.1160278320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6290.52294921875,
        -22.699951171875
      ],
      "bbox_max": [
        3977.864501953125,
        6871.484375,
        547.1160278320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        231.0294647216797,
        7173.888671875,
        -300.0
      ],
      "bbox_max": [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        100.0,
        5028.201171875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3040.46826171875,
        4430.66259765625,
        -300.0
      ],
      "bbox_max": [
        4042.8125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3978.369140625,
        4919.77783203125,
        -81.08197021484375
      ],
      "bbox_max": [
        4025.732177734375,
        4986.189453125,
        -10.697733879089355
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3979.6884765625,
        4430.66259765625,
        -166.41896057128906
      ],
      "bbox_max": [
        4042.8125,
        4946.3798828125,
        -13.885726928710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        100.0,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        7450.0,
        1318.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        816.3768920898438,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        7327.39501953125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3970.173828125,
        4949.3115234375,
        0.0
      ],
      "bbox_max": [
        4000.447998046875,
        4979.27001953125,
        32.464569091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4949.3115234375,
        0.0
      ],
      "bbox_max": [
        4000.447998046875,
        4954.3212890625,
        24.79603385925293
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        3052.0458984375,
        4947.60009765625,
        -13.693603515625
      ],
      "bbox_max": [
        3970.173828125,
        6882.69287109375,
        589.1254272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3956.67236328125,
        4947.60009765625,
        -13.693603515625
      ],
      "bbox_max": [
        3970.173828125,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        816.3768920898438,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        7327.39501953125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4618.00146484375,
        -111.00988006591797
      ],
      "bbox_max": [
        4019.882080078125,
        6871.484375,
        620.9073486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        3018.31005859375,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        6889.4033203125,
        624.2333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3970.173828125,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        4951.876953125,
        23.076147079467773
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4882.0908203125,
        0.0
      ],
      "bbox_max": [
        3999.897216796875,
        4951.876953125,
        23.076147079467773
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        3018.31005859375,
        6830.28955078125,
        610.1199951171875
      ],
      "bbox_max": [
        3170.04638671875,
        6889.4033203125,
        624.2333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6830.28955078125,
        610.1199951171875
      ],
      "bbox_max": [
        3170.04638671875,
        6871.484375,
        623.0784912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        4020.44775390625,
        7450.0,
        1187.3433837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3170.04638671875,
        6290.52294921875,
        474.2994384765625
      ],
      "bbox_max": [
        3977.864501953125,
        6830.28955078125,
        919.1775512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        3977.864501953125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        3956.206787109375,
        4509.04150390625,
        -123.25544738769531
      ],
      "bbox_max": [
        4040.075439453125,
        5071.1044921875,
        123.28406524658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3977.445068359375,
        4954.3212890625,
        24.796052932739258
      ],
      "bbox_max": [
        4024.458251953125,
        5071.1044921875,
        123.28406524658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3977.445068359375,
        4979.27001953125,
        32.46458435058594
      ],
      "bbox_max": [
        4021.62939453125,
        5071.1044921875,
        123.28406524658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.206787109375,
        5000.2041015625,
        39.02478790283203
      ],
      "bbox_max": [
        3986.29150390625,
        5059.0029296875,
        86.50531005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2778.40673828125,
        4693.4443359375,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.558349609375,
      "bbox_min": [
        -2778.40673828125,
        4693.4443359375,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -2778.40673828125,
        4693.4443359375,
        -300.0
      ],
      "bbox_max": [
        69.84530639648438,
        7252.56787109375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -2778.40673828125,
        4693.4443359375,
        -22.699951171875
      ],
      "bbox_max": [
        -200.0,
        6871.484375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -2778.40673828125,
        6824.70361328125,
        -22.699951171875
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        38.732234954833984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        69.84530639648438,
        7252.56787109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -109.37823486328125,
        7163.69873046875,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -22.699951171875
      ],
      "bbox_max": [
        -248.8677978515625,
        7178.380859375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -22.699951171875
      ],
      "bbox_max": [
        -248.8677978515625,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        0.0
      ],
      "bbox_max": [
        -248.8677978515625,
        4955.25732421875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        0.0
      ],
      "bbox_max": [
        -400.0,
        3934.389892578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8271484375,
      "bbox_min": [
        2878.090087890625,
        1339.7322998046875,
        0.0
      ],
      "bbox_max": [
        4150.75,
        3966.878662109375,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        0.0
      ],
      "bbox_max": [
        4150.75,
        3966.878662109375,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        0.0
      ],
      "bbox_max": [
        4150.75,
        3966.878662109375,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        0.0
      ],
      "bbox_max": [
        4150.75,
        3966.878662109375,
        834.5104370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        228.48062133789062
      ],
      "bbox_max": [
        4150.75,
        1985.22265625,
        834.5104370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1284712553024292,
        -0.3080694079399109,
        0.9426496624946594
      ],
      "plane_d": 160.421142578125,
      "bbox_min": [
        4137.6171875,
        1339.7322998046875,
        831.6990966796875
      ],
      "bbox_max": [
        4150.75,
        1343.3211669921875,
        834.5104370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        4117.16162109375,
        3200.0,
        1016.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        3260.0,
        3154.04345703125,
        360.0
      ],
      "bbox_max": [
        4087.392822265625,
        3200.0,
        933.06103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        3260.0,
        3200.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2889.345947265625,
        1830.0,
        170.32931518554688
      ],
      "bbox_max": [
        3240.0,
        2798.10986328125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        2200.0,
        -2850.0,
        1003.154296875
      ],
      "bbox_max": [
        2400.0,
        -1998.5714111328125,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        2200.0,
        -2087.5,
        1003.154296875
      ],
      "bbox_max": [
        2400.0,
        -1998.5714111328125,
        1121.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        1830.0,
        80.0
      ],
      "bbox_max": [
        2923.153076171875,
        3120.435546875,
        239.58474731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2780.0,
        2798.10986328125,
        80.0
      ],
      "bbox_max": [
        2889.345947265625,
        3120.435546875,
        170.32931518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3400.0,
        -5072.0185546875,
        1098.934814453125
      ],
      "bbox_max": [
        -2147.99658203125,
        -4452.255859375,
        1390.1160888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -3400.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2346.006103515625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1791.9246826171875,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2556.84375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -1791.9246826171875,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2588.24072265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -3400.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2346.006103515625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1806.8818359375,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1502.348388671875,
        -2346.006103515625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -1806.8818359375,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2599.128662109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -3400.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2350.41748046875,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1550.0,
        -2604.802001953125,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -1850.090087890625,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2604.802001953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2350.41748046875,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -2870.09521484375,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2621.19140625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -2870.09521484375,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -2832.052734375,
        -2950.57421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2350.41748046875,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2350.41748046875,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        -300.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2350.41748046875,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        1220.0
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        1328.766845703125
      ],
      "bbox_max": [
        -3260.67529296875,
        -3594.320556640625,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        -300.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2350.41748046875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        -300.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2350.41748046875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        -300.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2350.41748046875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3400.0,
        -2969.13720703125,
        716.9644165039062
      ],
      "bbox_max": [
        -3195.179443359375,
        -2730.576416015625,
        935.9595336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1074.7418212890625,
        -2950.0,
        1382.2545166015625
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2798.138916015625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -3400.0,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        3864.445068359375,
        2700.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1576.8857421875,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        -747.3431396484375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1576.8857421875,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        477.5139465332031,
        -1953.526123046875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1576.8857421875,
        -2850.33056640625,
        -300.0
      ],
      "bbox_max": [
        -825.0,
        -1953.526123046875,
        1702.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1576.8857421875,
        -2798.138916015625,
        -300.0
      ],
      "bbox_max": [
        -1074.7418212890625,
        -1953.526123046875,
        1382.2545166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1576.8857421875,
        -2413.1201171875,
        -300.0
      ],
      "bbox_max": [
        -1201.24462890625,
        -1953.526123046875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -1294.2777099609375,
        -2021.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1201.24462890625,
        -1953.526123046875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054435841739177704,
        0.9979904890060425,
        0.032430119812488556
      ],
      "plane_d": 3654.259033203125,
      "bbox_min": [
        273.75537109375,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        477.5139465332031,
        -3646.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        -1288.892333984375,
        -3695.77197265625,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        -747.3431396484375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -1288.892333984375,
        -3695.77197265625,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        -747.3431396484375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1288.892333984375,
        -2050.0,
        -300.0
      ],
      "bbox_max": [
        -765.7088012695312,
        -1336.22705078125,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1181.6776123046875,
        -2050.0,
        -285.97052001953125
      ],
      "bbox_max": [
        -724.7740478515625,
        -1441.2398681640625,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -1181.6776123046875,
        -1769.62939453125,
        -285.97052001953125
      ],
      "bbox_max": [
        -970.3532104492188,
        -1441.2398681640625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1181.6776123046875,
        -1523.07958984375,
        -285.97052001953125
      ],
      "bbox_max": [
        -970.3532104492188,
        -1441.2398681640625,
        -104.47206115722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -1129.8388671875,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1129.8388671875,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        0.0,
        -1127.742431640625,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -970.3532104492188,
        -1441.2398681640625,
        -300.0
      ],
      "bbox_max": [
        -279.618896484375,
        -1127.742431640625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -970.3532104492188,
        -1441.2398681640625,
        -300.0
      ],
      "bbox_max": [
        -551.24462890625,
        -1278.748779296875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1129.8388671875,
        -1709.192626953125,
        -190.11154174804688
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        200.3207244873047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1129.8388671875,
        -1661.628173828125,
        -190.11154174804688
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        89.88299560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1129.8388671875,
        -1661.628173828125,
        -104.47206115722656
      ],
      "bbox_max": [
        -1055.3487548828125,
        -1523.07958984375,
        89.88299560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -1129.8388671875,
        -1599.812744140625,
        -104.47206115722656
      ],
      "bbox_max": [
        -1100.0,
        -1523.07958984375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -551.24462890625,
        -1371.68505859375,
        -300.0
      ],
      "bbox_max": [
        502.19775390625,
        -747.3431396484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        64.31683349609375,
        -1133.334716796875,
        -264.3855895996094
      ],
      "bbox_max": [
        571.793701171875,
        -759.136474609375,
        96.11875915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        64.31683349609375,
        -1133.334716796875,
        0.0
      ],
      "bbox_max": [
        571.793701171875,
        -846.68505859375,
        96.11875915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -612.0,
        148.1753387451172,
        -300.0
      ],
      "bbox_max": [
        350.0,
        690.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -200.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        350.0,
        690.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -200.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        350.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -438.2693176269531,
      "bbox_min": [
        -200.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        300.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -205.71824645996094,
      "bbox_min": [
        -200.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        -190.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -200.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        40.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        -200.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -200.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        470.0,
        381.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -247.48736572265625,
      "bbox_min": [
        -200.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        -190.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        -70.0,
        470.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -190.0,
        440.0,
        140.0
      ],
      "bbox_max": [
        -70.0,
        470.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        -155.0,
        470.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -155.0,
        470.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        470.0,
        300.0
      ],
      "bbox_max": [
        -155.0,
        520.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -100.0,
        650.0,
        350.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        350.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -100.0,
        650.0,
        210.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        210.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -100.0,
        650.0,
        230.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 279.9999694824219,
      "bbox_min": [
        -612.0,
        148.1753387451172,
        -300.0
      ],
      "bbox_max": [
        -200.0,
        690.0,
        170.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -555.0,
      "bbox_min": [
        -612.0,
        148.1753387451172,
        -300.0
      ],
      "bbox_max": [
        -280.0,
        690.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238737225532532,
        -0.21553979814052582,
        0.3162277340888977
      ],
      "plane_d": -335.18963623046875,
      "bbox_min": [
        -594.975830078125,
        148.1753387451172,
        -300.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -471.75335693359375,
        249.4182586669922,
        60.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -410.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -410.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -410.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -355.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -355.0,
        440.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -390.0,
        440.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        165.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -385.0,
        440.0,
        60.0
      ],
      "bbox_max": [
        -305.0,
        460.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        -385.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -360.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -385.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -380.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -365.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -360.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -365.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -360.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -310.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -116.0,
      "bbox_min": [
        -315.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        -300.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -462.0,
      "bbox_min": [
        -290.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 285.0,
      "bbox_min": [
        -285.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -410.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -355.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        555.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        555.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        -355.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        -345.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        63.33333206176758
      ],
      "bbox_max": [
        -355.0,
        555.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -116.0,
      "bbox_min": [
        -410.0,
        480.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        555.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -355.0,
        555.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9549369215965271,
        -0.22278685867786407,
        0.19611604511737823
      ],
      "plane_d": -346.4595947265625,
      "bbox_min": [
        -492.2904357910156,
        244.32484436035156,
        0.0
      ],
      "bbox_max": [
        -401.8686828613281,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -479.96820068359375,
        255.4513702392578,
        60.0
      ],
      "bbox_max": [
        -401.8686828613281,
        555.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -410.0,
        440.0,
        162.03167724609375
      ],
      "bbox_max": [
        -408.9840087890625,
        440.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238737225532532,
        -0.21553979814052582,
        0.3162277340888977
      ],
      "plane_d": -335.18963623046875,
      "bbox_min": [
        -612.0,
        555.0,
        -300.0
      ],
      "bbox_max": [
        -280.0,
        690.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -485.7258605957031,
      "bbox_min": [
        -612.0,
        555.0,
        -300.0
      ],
      "bbox_max": [
        -280.0,
        690.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -492.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        690.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        -390.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -390.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9284767508506775,
        0.371390700340271
      ],
      "plane_d": -576.5840454101562,
      "bbox_min": [
        -390.0,
        555.0,
        140.0
      ],
      "bbox_max": [
        -355.0,
        565.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284767508506775,
        0.371390700340271
      ],
      "plane_d": -576.5840454101562,
      "bbox_min": [
        -355.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -116.0,
      "bbox_min": [
        -355.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        565.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -345.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        560.0,
        63.333335876464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        555.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        560.0,
        63.33333206176758
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -390.0,
        565.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        565.0,
        60.0
      ],
      "bbox_max": [
        -355.0,
        575.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161494255066
      ],
      "plane_d": -502.05731201171875,
      "bbox_min": [
        -512.0,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -492.0,
        690.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -512.0,
        555.0,
        0.0
      ],
      "bbox_max": [
        -471.75335693359375,
        676.0740966796875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161494255066
      ],
      "plane_d": -502.05731201171875,
      "bbox_min": [
        -512.0,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -500.0,
        676.0740966796875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -280.0,
        245.45787048339844,
        60.0
      ],
      "bbox_max": [
        -200.0,
        690.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -280.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        -200.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -210.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        -200.0,
        500.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        -210.0,
        460.0,
        78.0
      ],
      "bbox_max": [
        -200.0,
        500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -247.48736572265625,
      "bbox_min": [
        -210.0,
        460.0,
        110.0
      ],
      "bbox_max": [
        -200.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        -210.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        -200.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -210.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        -200.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        -280.0,
        435.0,
        78.0
      ],
      "bbox_max": [
        -210.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -280.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        -210.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7893522381782532,
        0.6139406561851501,
        0.0
      ],
      "plane_d": -119.71844482421875,
      "bbox_min": [
        -280.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -280.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        555.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 245.0,
      "bbox_min": [
        -245.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -3400.0,
        2786.4052734375,
        0.0
      ],
      "bbox_max": [
        -850.0,
        3743.4951171875,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -1263.684326171875,
        3500.0,
        0.0
      ],
      "bbox_max": [
        -850.0,
        3743.4951171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -850.0,
        3688.2353515625,
        0.0
      ],
      "bbox_max": [
        -475.55438232421875,
        3864.445068359375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1645.0,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1645.0,
        1470.0,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1910.0,
        1654.800048828125,
        500.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1910.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1973.3603515625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1975.489501953125,
        1895.4893798828125,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1913.617919921875,
        1833.617919921875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1654.800048828125,
        1059.6484375
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1683.941650390625,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1812.9427490234375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1923.157958984375,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1812.9427490234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1910.0,
        1704.3255615234375,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1910.0,
        1789.4744873046875,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1645.0,
        1654.800048828125,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.1865234375,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1831.2437744140625,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1837.9423828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1892.9425048828125,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1689.84228515625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1800.0,
        1689.84228515625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1115.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1874.6409912109375,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1789.4744873046875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1892.9425048828125,
        1812.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": -1434.4090576171875,
      "bbox_min": [
        -754.0657958984375,
        690.0,
        -300.0
      ],
      "bbox_max": [
        190.0,
        1850.2362060546875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9168806076049805,
        0.24357743561267853,
        0.3162277340888977
      ],
      "plane_d": -917.7099609375,
      "bbox_min": [
        -754.0657958984375,
        690.0,
        -300.0
      ],
      "bbox_max": [
        -500.0,
        1612.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -485.7258605957031,
      "bbox_min": [
        -754.0657958984375,
        690.0,
        -300.0
      ],
      "bbox_max": [
        -500.0,
        1318.6358642578125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9440768361091614,
        -0.09337516874074936,
        0.3162277936935425
      ],
      "plane_d": -493.8998718261719,
      "bbox_min": [
        -754.0657958984375,
        690.0,
        -300.0
      ],
      "bbox_max": [
        -500.0,
        1318.6358642578125,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8234102129936218,
        -0.4711642265319824,
        0.3162277936935425
      ],
      "plane_d": 8.160400390625,
      "bbox_min": [
        -731.9619750976562,
        690.0,
        -300.0
      ],
      "bbox_max": [
        -500.0,
        1126.266357421875,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8723526000976562,
        -0.37282851338386536,
        0.3162277936935425
      ],
      "plane_d": -114.96792602539062,
      "bbox_min": [
        -639.621337890625,
        690.0,
        -300.0
      ],
      "bbox_max": [
        -500.0,
        1126.266357421875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161494255066
      ],
      "plane_d": -502.05731201171875,
      "bbox_min": [
        -634.5513305664062,
        690.0,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1126.266357421875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016833901405334,
        -0.38536393642425537,
        0.19611597061157227
      ],
      "plane_d": -118.83352661132812,
      "bbox_min": [
        -634.5513305664062,
        889.6224365234375,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1126.266357421875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8510953783988953,
        -0.4870060086250305,
        0.19611652195453644
      ],
      "plane_d": 8.434783935546875,
      "bbox_min": [
        -634.5513305664062,
        978.4100341796875,
        0.0
      ],
      "bbox_max": [
        -539.185302734375,
        1126.266357421875,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.97581946849823,
        -0.09651471674442291,
        0.1961158812046051
      ],
      "plane_d": -510.5062255859375,
      "bbox_min": [
        -652.7692260742188,
        1113.014892578125,
        0.0
      ],
      "bbox_max": [
        -613.1430053710938,
        1310.4599609375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8510953783988953,
        -0.4870060086250305,
        0.19611652195453644
      ],
      "plane_d": 8.434783935546875,
      "bbox_min": [
        -634.5513305664062,
        1113.014892578125,
        0.0
      ],
      "bbox_max": [
        -613.1430053710938,
        1130.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9477086663246155,
        0.25176718831062317,
        0.19611628353595734
      ],
      "plane_d": -948.56591796875,
      "bbox_min": [
        -652.7692260742188,
        1286.7740478515625,
        0.0
      ],
      "bbox_max": [
        -592.125244140625,
        1512.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.980580747127533,
        0.1961161494255066
      ],
      "plane_d": -1482.6380615234375,
      "bbox_min": [
        -599.2283325195312,
        1492.0,
        -300.0
      ],
      "bbox_max": [
        190.0,
        1850.2362060546875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9477086663246155,
        0.25176718831062317,
        0.19611628353595734
      ],
      "plane_d": -948.56591796875,
      "bbox_min": [
        -599.2283325195312,
        1492.0,
        0.0
      ],
      "bbox_max": [
        -590.0,
        1512.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5270602107048035,
        0.7888013124465942,
        0.31622767448425293
      ],
      "plane_d": -1264.458984375,
      "bbox_min": [
        135.90725708007812,
        1759.9998779296875,
        -300.0
      ],
      "bbox_max": [
        190.0,
        1850.2362060546875,
        -74.91361999511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        133.8159942626953,
        1630.9676513671875,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9617391228675842,
        0.19130180776119232,
        0.1961161196231842
      ],
      "plane_d": -183.31097412109375,
      "bbox_min": [
        110.15185546875,
        1500.0,
        0.0
      ],
      "bbox_max": [
        156.73394775390625,
        1643.6673583984375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        133.8159942626953,
        1626.2855224609375,
        0.0
      ],
      "bbox_max": [
        156.73394775390625,
        1643.6673583984375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5270602107048035,
        0.7888013124465942,
        0.31622767448425293
      ],
      "plane_d": -1264.458984375,
      "bbox_min": [
        190.0,
        1693.45361328125,
        -249.52261352539062
      ],
      "bbox_max": [
        323.7144775390625,
        1830.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        190.0,
        1693.45361328125,
        0.0
      ],
      "bbox_max": [
        208.00323486328125,
        1741.9967041015625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5447814464569092,
        0.8153231143951416,
        0.19611552357673645
      ],
      "plane_d": -1306.973876953125,
      "bbox_min": [
        205.04037475585938,
        1715.963134765625,
        0.0
      ],
      "bbox_max": [
        323.7144775390625,
        1816.1839599609375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        205.04037475585938,
        1715.963134765625,
        0.0
      ],
      "bbox_max": [
        216.65475463867188,
        1741.9967041015625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5270602107048035,
        0.7888013124465942,
        0.31622767448425293
      ],
      "plane_d": -1264.458984375,
      "bbox_min": [
        190.0,
        1830.0,
        -300.0
      ],
      "bbox_max": [
        313.30950927734375,
        1910.3818359375,
        -44.001121520996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -500.0,
        690.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        820.0,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -500.0,
        690.0,
        60.0
      ],
      "bbox_max": [
        -485.0,
        820.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -485.0,
        819.979248046875,
        60.0
      ],
      "bbox_max": [
        -485.0,
        820.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        820.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        700.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -500.0,
        700.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -500.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        820.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -485.0,
        770.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -485.0,
        819.979248046875,
        120.0
      ],
      "bbox_max": [
        -485.0,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -500.0,
        819.979248046875,
        130.0
      ],
      "bbox_max": [
        -485.0,
        820.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -500.0,
        819.979248046875,
        214.0
      ],
      "bbox_max": [
        -485.0,
        820.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -50.0,
        690.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        820.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        740.0,
        701.7157592773438,
        60.0
      ],
      "bbox_max": [
        780.0,
        820.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        820.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        820.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        740.0,
        726.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -50.0,
        690.0,
        210.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -50.0,
        690.0,
        280.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -686.4964599609375,
      "bbox_min": [
        -50.0,
        690.0,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -50.0,
        690.0,
        210.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -50.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19670066237449646,
        0.9804636240005493,
        0.0
      ],
      "plane_d": -696.1595458984375,
      "bbox_min": [
        -50.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        -50.0,
        723.0171508789062,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -50.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        161.99351501464844,
        788.0064697265625,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        161.99351501464844,
        788.0064697265625,
        130.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        183.72076416015625,
        802.5241088867188,
        130.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        140.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        -640.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2305.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2050.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1549.9998779296875,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1645.0,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        140.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1645.0,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414002837147564e-06,
        1.0,
        0.0
      ],
      "plane_d": -1399.9959716796875,
      "bbox_min": [
        1549.9998779296875,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1549.9998779296875,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1549.9998779296875,
        1270.0,
        636.467529296875
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.5000001788139343,
        0.7071067094802856
      ],
      "plane_d": 959.94970703125,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1400.0,
        728.3914184570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414002837147564e-06,
        1.0,
        0.0
      ],
      "plane_d": -1399.9959716796875,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1400.0,
        728.3914184570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1270.0,
        636.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1380.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1380.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1350.0,
        1910.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1350.0,
        1910.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1390.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1310.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1090.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        969.5689086914062,
        369.22308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        960.7692260742188,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1140.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        944.6153564453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1140.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        920.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1140.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1330.0,
        944.6153564453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1175.0,
        1550.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1174.9146728515625,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1090.0,
        1390.0,
        125.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        430.0852966308594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 543.9276733398438,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1198.2298583984375,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1570.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1570.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        850.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        110.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        64.44444274902344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        720.0,
        926.6382446289062,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        66.72349548339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.44444274902344
      ],
      "bbox_max": [
        820.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        960.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1453.3616943359375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        737.914794921875,
        1420.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        1540.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        777.914794921875,
        820.0,
        110.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1540.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        779.9147338867188,
        820.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        930.0,
        120.08525085449219
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        820.0,
        110.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        886.0660400390625,
        856.0660400390625,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        120.08525085449219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        779.9147338867188,
        930.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        836.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        820.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1540.0,
        205.085205078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        950.0,
        120.0
      ],
      "bbox_max": [
        1000.0,
        1140.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        829.914794921875,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1121.3931884765625,
        205.085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        829.914794921875,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        865.0,
        981.9285278320312,
        205.085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0851936340332
      ],
      "bbox_max": [
        1175.0,
        1550.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        720.0,
        820.0,
        60.0851936340332
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        720.0,
        949.1378173828125,
        80.0
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        807.7501220703125,
        949.1378173828125,
        162.6588134765625
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        807.7501220703125,
        949.1378173828125,
        162.6588134765625
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        822.5736083984375,
        949.1378173828125,
        162.6588134765625
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        822.5736083984375,
        949.1378173828125,
        162.6588134765625
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        377.0852966308594
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        377.0852966308594
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1037.0,
        977.0000610351562,
        377.0852966308594
      ],
      "bbox_max": [
        1039.9146728515625,
        979.9147338867188,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        822.5736083984375,
        949.1378173828125,
        162.6588134765625
      ],
      "bbox_max": [
        1037.0,
        1006.109130859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      "bbox_max": [
        1037.0,
        977.1166381835938,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        822.5736083984375,
        1003.3217163085938,
        162.6588134765625
      ],
      "bbox_max": [
        829.914794921875,
        1006.109130859375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        825.9805908203125,
        950.0,
        166.0657958984375
      ],
      "bbox_max": [
        879.9147338867188,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1300.0,
        370.085205078125
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1030.0,
        1310.0,
        370.085205078125
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1310.0,
        370.085205078125
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1310.0,
        370.085205078125
      ],
      "bbox_max": [
        1030.0,
        1380.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1380.0,
        370.085205078125
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1300.0,
        370.085205078125
      ],
      "bbox_max": [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1300.0,
        370.0852355957031
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1378.4161376953125,
        80.0
      ],
      "bbox_max": [
        725.3668823242188,
        1390.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0851936340332
      ],
      "bbox_max": [
        825.9805908203125,
        960.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        820.0,
        118.0
      ],
      "bbox_max": [
        825.9805908203125,
        950.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        779.914794921875,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        820.0,
        120.08523559570312
      ],
      "bbox_max": [
        825.9805908203125,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        780.0,
        930.0,
        120.08523559570312
      ],
      "bbox_max": [
        825.9805908203125,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.9147338867188,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        920.0,
        60.0851936340332
      ],
      "bbox_max": [
        739.914794921875,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        720.0,
        920.0,
        60.0851936340332
      ],
      "bbox_max": [
        739.914794921875,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        739.914794921875,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        720.0,
        1390.0,
        60.08519744873047
      ],
      "bbox_max": [
        1175.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        720.0,
        1470.0,
        80.0
      ],
      "bbox_max": [
        1075.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        720.0,
        1470.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1470.0,
        80.0
      ],
      "bbox_max": [
        739.914794921875,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        720.0,
        1390.0,
        60.08519744873047
      ],
      "bbox_max": [
        1174.9146728515625,
        1470.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        720.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1470.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        739.914794921875,
        1470.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        720.0,
        1390.0,
        60.08519744873047
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1390.0,
        60.08519744873047
      ],
      "bbox_max": [
        739.914794921875,
        1460.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1420.0,
        60.08519744873047
      ],
      "bbox_max": [
        739.914794921875,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        720.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        739.914794921875,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        739.914794921875,
        1560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -640.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        2305.0,
        640.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        -640.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1500.0,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1500.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        -592.6333618164062,
        1490.0,
        214.0
      ],
      "bbox_max": [
        0.0,
        1500.0,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        214.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -640.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -640.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        214.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -600.015380859375,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -550.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        -550.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -550.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -597.513427734375,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863938689231873,
        0.0,
        0.16439898312091827
      ],
      "plane_d": -78.91150665283203,
      "bbox_min": [
        -516.0595703125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -70.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -516.0595703125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -132.94044494628906,
        1370.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        60.02787780761719
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -516.0595703125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -350.4860534667969,
        1239.02783203125,
        60.02787780761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -516.0595703125,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -516.034423828125,
        1239.021728515625,
        60.02784729003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5943603515625,
      "bbox_min": [
        -350.5,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -350.4860534667969,
        1239.02783203125,
        60.02787780761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -61.999996185302734,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1342.2509765625,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1189.176513671875,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1142.9825439453125,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -722.5831909179688,
      "bbox_min": [
        -225.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        -0.0
      ],
      "plane_d": -353.03155517578125,
      "bbox_min": [
        -225.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -225.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 306.83758544921875,
      "bbox_min": [
        -225.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -1144.981689453125,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1298.056396484375,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        -0.0
      ],
      "plane_d": -308.837646484375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -678.3893432617188,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 351.0315856933594,
      "bbox_min": [
        -183.85305786132812,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1342.2509765625,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1189.176513671875,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1142.9825439453125,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -722.5831909179688,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        -0.0
      ],
      "plane_d": -353.03155517578125,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 306.83758544921875,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -1144.981689453125,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1298.056396484375,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        -0.0
      ],
      "plane_d": -308.837646484375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -678.3893432617188,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 351.0315856933594,
      "bbox_min": [
        -183.85305786132812,
        1345.0,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -475.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1370.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -61.999996185302734,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1093.5050048828125,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1437.92236328125,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 1047.3111572265625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -953.552978515625,
      "bbox_min": [
        -475.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        -0.0
      ],
      "plane_d": 75.8677978515625,
      "bbox_min": [
        -475.0,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1393.7281494140625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1049.3099365234375,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 1091.50390625,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        -0.0
      ],
      "plane_d": 120.061767578125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -909.359130859375,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1093.5050048828125,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1437.92236328125,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 1047.3111572265625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -953.552978515625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        -0.0
      ],
      "plane_d": 75.8677978515625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1393.7281494140625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1049.3099365234375,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 1091.50390625,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        -0.0
      ],
      "plane_d": 120.061767578125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -909.359130859375,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        62.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        85.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -340.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        -340.0,
        1270.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        -340.0,
        1240.0,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -335.0,
        1240.0,
        62.0
      ],
      "bbox_max": [
        -315.0,
        1265.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1240.0,
        62.0
      ],
      "bbox_max": [
        -315.0,
        1265.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -335.0,
        1240.0,
        62.0
      ],
      "bbox_max": [
        -315.0,
        1265.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        -335.0,
        1265.0,
        62.0
      ],
      "bbox_max": [
        -315.0,
        1265.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1239.0,
        80.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -84.99999237060547,
      "bbox_min": [
        -340.0,
        1239.0,
        85.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -640.0554809570312,
        1239.0,
        119.99999237060547
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -640.0554809570312,
        1266.47509765625,
        214.0
      ],
      "bbox_max": [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        -635.9242553710938,
        1239.0,
        214.0
      ],
      "bbox_max": [
        -618.1177368164062,
        1309.916748046875,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -350.5,
        1239.0,
        120.0
      ],
      "bbox_max": [
        -299.5,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -350.5,
        1239.0,
        120.0
      ],
      "bbox_max": [
        -299.5,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1239.0,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -925.1790161132812,
      "bbox_min": [
        -633.3114013671875,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1239.0,
        540.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1239.0,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1210.361328125,
        540.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        -54.123687744140625,
        1210.361328125,
        540.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        250.00003051757812
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -339.5,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1101.080078125,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -339.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1101.080078125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -339.5,
        1040.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1101.080078125,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -339.5,
        1050.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1101.080078125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1050.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1101.080078125,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 85.0,
      "bbox_min": [
        -330.0,
        1050.0,
        85.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -338.37939453125,
        1051.800048828125,
        65.0
      ],
      "bbox_max": [
        -311.62060546875,
        1101.080078125,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -311.62060546875,
        1101.080078125,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575022220611572,
        0.5144804120063782
      ],
      "plane_d": -946.6806640625,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -968.1425170898438,
      "bbox_min": [
        -315.62744140625,
        1054.145263671875,
        75.0
      ],
      "bbox_max": [
        -311.62060546875,
        1101.080078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -313.35302734375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.691162109375,
        1055.80712890625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -311.62060546875,
        1101.080078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -314.42620849609375,
        1057.2464599609375,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        75.0
      ],
      "bbox_max": [
        -311.62060546875,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660718202590942
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        75.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.8154296875,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -314.792236328125,
        1056.8804931640625,
        75.0
      ],
      "bbox_max": [
        -314.175048828125,
        1057.753662109375,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -314.623046875,
        1057.53955078125,
        75.87640380859375
      ],
      "bbox_max": [
        -314.4280700683594,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -314.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -338.37939453125,
        1051.800048828125,
        65.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        65.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575022220611572,
        0.5144804120063782
      ],
      "plane_d": -946.6806640625,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -326.0,
      "bbox_min": [
        -328.5,
        1096.74951171875,
        65.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -321.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -328.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        0.7070940732955933,
        0.0
      ],
      "plane_d": -984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        75.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1101.080078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -508.5230712890625,
      "bbox_min": [
        -336.6470031738281,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -334.9853515625,
        1055.80712890625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -508.5230712890625,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1098.6800537109375,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        225.0
      ],
      "bbox_max": [
        -309.5,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -339.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        850.556396484375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -339.5,
        820.0,
        140.0
      ],
      "bbox_max": [
        -309.5,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": 544.8612670898438,
      "bbox_min": [
        -339.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -309.5,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -522.655517578125,
        820.0,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -339.5,
        830.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -485.0,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -500.0,
        830.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -500.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        -485.0,
        830.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -500.0,
        820.0,
        214.0
      ],
      "bbox_max": [
        -485.0,
        830.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9273704886436462,
        0.374144583940506,
        -0.0
      ],
      "plane_d": 116.008056640625,
      "bbox_min": [
        -522.655517578125,
        830.0,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 485.0,
      "bbox_min": [
        -522.655517578125,
        830.0,
        60.0
      ],
      "bbox_max": [
        -485.0,
        961.6765747070312,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -522.655517578125,
        830.0,
        214.0
      ],
      "bbox_max": [
        -485.0,
        961.6765747070312,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 113.9417724609375,
      "bbox_min": [
        -464.5001220703125,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -797.2359619140625,
      "bbox_min": [
        -464.5001220703125,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -359.5000305175781,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -359.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -339.5,
        850.556396484375,
        249.99998474121094
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": 544.8612670898438,
      "bbox_min": [
        -359.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -339.5,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -359.5000305175781,
        971.800048828125,
        67.32661437988281
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -296.6356201171875,
      "bbox_min": [
        -359.5,
        971.800048828125,
        67.32661437988281
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -743.7391967773438,
      "bbox_min": [
        -359.5,
        971.800048828125,
        67.32661437988281
      ],
      "bbox_max": [
        -339.5,
        984.4795532226562,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 753.4539184570312,
      "bbox_min": [
        -464.5001220703125,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -355.21795654296875,
        1066.02392578125,
        205.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -355.21795654296875,
        1066.02392578125,
        205.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -355.21795654296875,
        1066.02392578125,
        225.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 306.7905578613281,
      "bbox_min": [
        -464.5001220703125,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -355.21795654296875,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -355.21795654296875,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -464.5001220703125,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8544729351997375,
        -0.5194959044456482,
        -0.0
      ],
      "plane_d": 146.394775390625,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1045.8167724609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -419.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -359.5000305175781,
        971.800048828125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -620.3038940429688,
      "bbox_min": [
        -446.0471496582031,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -296.6356201171875,
      "bbox_min": [
        -371.0469970703125,
        971.800048828125,
        60.00611877441406
      ],
      "bbox_max": [
        -339.5,
        1011.7999267578125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -743.7391967773438,
      "bbox_min": [
        -371.0469970703125,
        971.800048828125,
        60.00611877441406
      ],
      "bbox_max": [
        -352.17950439453125,
        991.800048828125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3534907102584839,
        -0.6124178171157837,
        0.7070988416671753
      ],
      "plane_d": 476.2753601074219,
      "bbox_min": [
        -446.0471496582031,
        1006.441162109375,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -296.6356201171875,
      "bbox_min": [
        -446.0471496582031,
        1006.441162109375,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 160.18850708007812,
      "bbox_min": [
        -446.0471496582031,
        1045.6845703125,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 719.6735229492188,
      "bbox_min": [
        -446.0471496582031,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -417.1795349121094,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123723983764648,
        -0.3535548448562622,
        0.7071061134338379
      ],
      "plane_d": 597.6278076171875,
      "bbox_min": [
        -434.5,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -417.1795349121094,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123727560043335,
        -0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": 23.99615478515625,
      "bbox_min": [
        -417.593994140625,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -347.9530029296875,
        931.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -620.3038940429688,
      "bbox_min": [
        -417.593994140625,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -347.9530029296875,
        931.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": 544.8612670898438,
      "bbox_min": [
        -371.0469970703125,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -347.9530029296875,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -432.5940246582031,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        250.00003051757812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 753.4539184570312,
      "bbox_min": [
        -432.5940246582031,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -400.0,
        1141.04345703125,
        250.00003051757812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -424.5,
        1113.944091796875,
        60.0
      ],
      "bbox_max": [
        -400.0,
        1141.04345703125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8648231625556946,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.9825439453125,
      "bbox_min": [
        -424.5,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648216128349304,
        -0.0
      ],
      "plane_d": -758.728759765625,
      "bbox_min": [
        -420.7500305175781,
        1121.5848388671875,
        75.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1121.5938720703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660266995429993,
        -0.4999978244304657,
        0.0
      ],
      "plane_d": 925.1030883789062,
      "bbox_min": [
        -421.9375,
        1113.944091796875,
        60.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999794363975525,
        0.8660266995429993,
        0.0
      ],
      "plane_d": -758.4561767578125,
      "bbox_min": [
        -421.9375,
        1113.944091796875,
        60.0
      ],
      "bbox_max": [
        -412.4999694824219,
        1119.392822265625,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -432.5940246582031,
        1101.0794677734375,
        69.74334716796875
      ],
      "bbox_max": [
        -400.21807861328125,
        1115.0986328125,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3534933626651764,
        -0.6123767495155334,
        0.7071331739425659
      ],
      "plane_d": 476.2275390625,
      "bbox_min": [
        -432.593994140625,
        1101.0794677734375,
        69.74334716796875
      ],
      "bbox_max": [
        -400.21807861328125,
        1115.0986328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123723983764648,
        -0.3535548448562622,
        0.7071061134338379
      ],
      "plane_d": 597.6278076171875,
      "bbox_min": [
        -432.593994140625,
        1101.0794677734375,
        69.74334716796875
      ],
      "bbox_max": [
        -420.74359130859375,
        1115.0986328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 320.5,
      "bbox_min": [
        -409.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -409.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -409.5,
        1101.0794677734375,
        95.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        -376.25,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -376.25,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1108.8662109375,
        95.0
      ],
      "bbox_max": [
        -350.625,
        1195.25,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -536.1575317382812,
      "bbox_min": [
        -365.0,
        1108.8662109375,
        95.0
      ],
      "bbox_max": [
        -350.625,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -365.0,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -353.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -365.0,
        1195.25,
        114.68749237060547
      ],
      "bbox_max": [
        -353.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -376.25,
        1123.2412109375,
        95.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5299989581108093,
        -0.847998321056366
      ],
      "plane_d": -517.9415283203125,
      "bbox_min": [
        -376.25,
        1123.2412109375,
        95.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -536.1575317382812,
      "bbox_min": [
        -369.3837890625,
        1123.2412109375,
        95.0
      ],
      "bbox_max": [
        -365.0,
        1127.625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -376.25,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -376.25,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 1093.154541015625,
      "bbox_min": [
        -365.0,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1185.25,
      "bbox_min": [
        -365.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -365.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -353.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        0.2588190734386444,
        0.0
      ],
      "plane_d": 45.62799072265625,
      "bbox_min": [
        -356.25,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 642.5941772460938,
      "bbox_min": [
        -356.25,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -352.06329345703125,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1137.625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -999.6504516601562,
      "bbox_min": [
        -340.625,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1126.186767578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1166.050048828125,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5299989581108093,
        -0.847998321056366
      ],
      "plane_d": -517.9415283203125,
      "bbox_min": [
        -376.25,
        1166.050048828125,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -999.6504516601562,
      "bbox_min": [
        -340.0,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -320.5,
        1126.019287109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -1167.8851318359375,
      "bbox_min": [
        -325.0,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -320.5,
        1123.205810546875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661441206932068,
        -0.4997943937778473,
        0.0
      ],
      "plane_d": 914.9912109375,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -365.83636474609375,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        -0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -374.483154296875,
        1196.7406005859375,
        120.0
      ],
      "bbox_max": [
        -365.83636474609375,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -355.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -355.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648214936256409,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849853515625,
      "bbox_min": [
        -409.4375,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -388.82049560546875,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -388.82049560546875,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -329.5,
      "bbox_min": [
        -388.82049560546875,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -328.5,
        1101.080078125,
        63.5
      ],
      "bbox_max": [
        -321.5,
        1122.0,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -321.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1122.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -328.5,
        1122.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -388.82049560546875,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837600588798523,
        -0.17948900163173676,
        0.0
      ],
      "plane_d": 549.6348266601562,
      "bbox_min": [
        -354.17950439453125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -353.9970397949219,
        1122.0001220703125,
        60.71708679199219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -388.82049560546875,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -335.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -336.5,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6608257293701172,
        0.7505393624305725,
        -0.0
      ],
      "plane_d": -618.0692138671875,
      "bbox_min": [
        -388.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -336.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -388.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        66.5999984741211
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.6755981445312,
      "bbox_min": [
        -388.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196141362190247,
        0.3928230106830597,
        -0.0
      ],
      "plane_d": -119.03848266601562,
      "bbox_min": [
        -388.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -1121.38330078125,
      "bbox_min": [
        -388.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837600588798523,
        -0.17948900163173676,
        0.0
      ],
      "plane_d": 549.6348266601562,
      "bbox_min": [
        -382.75,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1183.71044921875,
      "bbox_min": [
        -382.75,
        1146.1553955078125,
        60.0
      ],
      "bbox_max": [
        -375.739990234375,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1312400996685028,
        0.1457478404045105,
        0.9805782437324524
      ],
      "plane_d": -183.85305786132812,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7431347966194153,
        0.6691417098045349,
        0.0
      ],
      "plane_d": -1034.256591796875,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6691535711288452,
        0.7431241869926453,
        -0.0
      ],
      "plane_d": -606.432861328125,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -66.5999984741211,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13124099373817444,
        0.14574885368347168,
        -0.9805779457092285
      ],
      "plane_d": -55.20204162597656,
      "bbox_min": [
        -364.1297912597656,
        1139.913330078125,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7429677248001099,
        0.6693271994590759,
        0.0
      ],
      "plane_d": -1033.607421875,
      "bbox_min": [
        -363.267578125,
        1141.0135498046875,
        64.68000030517578
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.3106689453125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6692008376121521,
        0.7430815696716309,
        0.0
      ],
      "plane_d": -605.1670532226562,
      "bbox_min": [
        -362.9999084472656,
        1141.0430908203125,
        64.75997924804688
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.3106689453125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5253788232803345,
        0.47315743565559387,
        0.7071768641471863
      ],
      "plane_d": -776.2742919921875,
      "bbox_min": [
        -363.83251953125,
        1140.9840087890625,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.8756103515625,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4731338322162628,
        0.525486409664154,
        0.7071126699447632
      ],
      "plane_d": -473.53369140625,
      "bbox_min": [
        -363.029541015625,
        1141.0430908203125,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.8756103515625,
        64.75997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6692008376121521,
        0.7430815696716309,
        0.0
      ],
      "plane_d": -605.1670532226562,
      "bbox_min": [
        -362.9999084472656,
        1141.0430908203125,
        64.4000015258789
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.3106689453125,
        64.75997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7429677248001099,
        0.6693271994590759,
        0.0
      ],
      "plane_d": -1033.607421875,
      "bbox_min": [
        -363.267578125,
        1141.0135498046875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.732421875,
        1141.3106689453125,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6692008376121521,
        0.7430815696716309,
        0.0
      ],
      "plane_d": -605.1670532226562,
      "bbox_min": [
        -362.9999084472656,
        1141.06982421875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.732421875,
        1141.3106689453125,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -344.0,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -336.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1185.794189453125,
        65.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -320.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 895.8069458007812,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -356.0,
        1177.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -356.0,
        1177.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1183.71044921875,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.6755981445312,
      "bbox_min": [
        -373.6650695800781,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.5,
      "bbox_min": [
        -369.5,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -320.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1075.863037109375,
      "bbox_min": [
        -359.7528076171875,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -359.7528076171875,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -357.4433898925781,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -369.5,
        1181.5,
        61.5
      ],
      "bbox_max": [
        -359.7528076171875,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -360.5,
        1181.5,
        61.5
      ],
      "bbox_max": [
        -359.7528076171875,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -356.0,
        1177.5,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1183.71044921875,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.6755981445312,
      "bbox_min": [
        -373.6650695800781,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -369.5,
        1177.5,
        60.0
      ],
      "bbox_max": [
        -357.4433898925781,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -360.5,
        1177.5,
        60.0
      ],
      "bbox_max": [
        -357.4433898925781,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244941711426,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 892.806640625,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -338.0,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1185.794189453125,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244941711426,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -282.1972351074219,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1183.71044921875,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        64.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.6755981445312,
      "bbox_min": [
        -373.6650695800781,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -354.2679443359375,
        1182.794189453125,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.866024374961853,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 895.8069458007812,
      "bbox_min": [
        -360.5,
        1167.205810546875,
        62.0
      ],
      "bbox_max": [
        -356.0,
        1175.0,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 895.8069458007812,
      "bbox_min": [
        -360.5,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -356.0,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -360.5,
        1172.0,
        62.5
      ],
      "bbox_max": [
        -352.535888671875,
        1182.794189453125,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -372.964111328125,
        1182.794189453125,
        62.5
      ],
      "bbox_max": [
        -357.035888671875,
        1185.794189453125,
        62.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -340.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -338.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1149.0,
      "bbox_min": [
        -338.0,
        1149.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -338.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -377.73565673828125,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 364.75,
      "bbox_min": [
        -364.8154296875,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680888056755066,
        -0.8730039000511169
      ],
      "plane_d": 600.0879516601562,
      "bbox_min": [
        -364.8154296875,
        1162.2249755859375,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.873003363609314
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -364.8154296875,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680864214897156,
        -0.8730035424232483
      ],
      "plane_d": 609.7818603515625,
      "bbox_min": [
        -364.8154296875,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680888056755066,
        -0.8730039000511169
      ],
      "plane_d": 600.0879516601562,
      "bbox_min": [
        -364.75,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.873003363609314
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -364.75,
        1164.780029296875,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680864214897156,
        -0.8730035424232483
      ],
      "plane_d": 609.7818603515625,
      "bbox_min": [
        -364.75,
        1166.823974609375,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6092076897621155,
        -0.6092076897621155,
        0.5076730251312256
      ],
      "plane_d": 903.5057983398438,
      "bbox_min": [
        -364.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -362.25,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 364.75,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680888056755066,
        -0.8730039000511169
      ],
      "plane_d": -465.11126708984375,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429105877876282,
        0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": -214.91270446777344,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291139245033264,
        0.34681081771850586,
        -0.8730028867721558
      ],
      "plane_d": -459.7424011230469,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429116904735565,
        0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": -209.5424041748047,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429136276245117,
        0.34680843353271484,
        -0.8730029463768005
      ],
      "plane_d": -455.4179382324219,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        0.3468044102191925,
        -0.8730056881904602
      ],
      "plane_d": -205.213623046875,
      "bbox_min": [
        -364.8154296875,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429105877876282,
        0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": -214.91270446777344,
      "bbox_min": [
        -364.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429116904735565,
        0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": -209.5424041748047,
      "bbox_min": [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        0.3468044102191925,
        -0.8730056881904602
      ],
      "plane_d": -205.213623046875,
      "bbox_min": [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6092076897621155,
        0.6092076897621155,
        0.5076730251312256
      ],
      "plane_d": -528.1322631835938,
      "bbox_min": [
        -364.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -362.25,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -320.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -320.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -320.5,
        1119.210693359375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1119.210693359375,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1119.210693359375,
        61.5
      ],
      "bbox_max": [
        -314.5,
        1122.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.5,
      "bbox_min": [
        -320.5,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -320.5,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -616.2435913085938,
      "bbox_min": [
        -310.0,
        1181.0,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.361328125,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -310.0,
        1200.361328125,
        61.5
      ],
      "bbox_max": [
        -309.5,
        1200.361328125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1119.907958984375,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1119.907958984375,
        60.0
      ],
      "bbox_max": [
        -314.5,
        1122.0,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -320.5,
        1177.5,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -310.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1200.361328125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -320.5,
        1101.080078125,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1101.080078125,
        62.0
      ],
      "bbox_max": [
        -314.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -320.5,
        1140.0,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -320.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -312.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -310.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1200.361328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -310.0,
        1200.361328125,
        62.0
      ],
      "bbox_max": [
        -309.5,
        1200.361328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -312.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -312.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1149.0,
      "bbox_min": [
        -320.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1147.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -320.5,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -320.5,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        -320.5,
        1200.361328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.361328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -320.5,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1147.0,
        65.0
      ],
      "bbox_max": [
        -309.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -320.5,
        1101.0794677734375,
        118.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        -0.0
      ],
      "plane_d": 648.2665405273438,
      "bbox_min": [
        -310.0,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -309.5,
        1180.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -1167.8851318359375,
      "bbox_min": [
        -310.0,
        1126.019287109375,
        118.0
      ],
      "bbox_max": [
        -309.5,
        1126.1533203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -1167.8851318359375,
      "bbox_min": [
        -320.5,
        1123.205810546875,
        118.0
      ],
      "bbox_max": [
        -310.0,
        1126.019287109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -309.5,
        1200.4000244140625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -464.5001220703125,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -339.5,
      "bbox_min": [
        -464.5001220703125,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -309.5,
        1101.0794677734375,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -339.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -309.5,
        850.556396484375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 113.9417724609375,
      "bbox_min": [
        -464.5001220703125,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -797.2359619140625,
      "bbox_min": [
        -464.5001220703125,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -359.5000305175781,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -359.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -339.5,
        850.556396484375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -359.5000305175781,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 753.4539184570312,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -355.21795654296875,
        1075.0986328125,
        250.0
      ],
      "bbox_max": [
        -340.21795654296875,
        1101.0794677734375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 306.7905578613281,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -339.5,
        1101.0794677734375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8544729351997375,
        -0.5194959044456482,
        -0.0
      ],
      "plane_d": 146.394775390625,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -419.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -359.5000305175781,
        971.800048828125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -432.5940246582031,
        1101.0775146484375,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 753.4539184570312,
      "bbox_min": [
        -432.5940246582031,
        1101.0794677734375,
        250.00001525878906
      ],
      "bbox_max": [
        -400.21807861328125,
        1115.0986328125,
        514.0184936523438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -432.5940246582031,
        1101.0794677734375,
        300.0
      ],
      "bbox_max": [
        -400.21807861328125,
        1115.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1130.4095458984375,
      "bbox_min": [
        -409.5,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1130.4095458984375,
        400.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.5,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.5,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -309.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -54.123687744140625,
        1210.361328125,
        540.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -309.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -54.123687744140625,
        1210.361328125,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -309.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -54.123687744140625,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -309.5,
        820.0,
        140.0
      ],
      "bbox_max": [
        -54.123687744140625,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -309.5,
        830.0,
        60.0
      ],
      "bbox_max": [
        -59.897216796875,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -160.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -59.897216796875,
        1003.3821411132812,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -59.897216796875,
        899.4596557617188,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -59.897216796875,
        899.4596557617188,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -59.897216796875,
        890.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -59.897216796875,
        890.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        -100.0,
        890.0,
        82.0
      ],
      "bbox_max": [
        -94.53842163085938,
        890.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.220703097715159e-06,
        1.0,
        -0.0
      ],
      "plane_d": -839.807861328125,
      "bbox_min": [
        -100.0,
        830.0,
        155.0
      ],
      "bbox_max": [
        -59.897216796875,
        839.8079833984375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        -100.0,
        830.0,
        175.0
      ],
      "bbox_max": [
        -59.897216796875,
        839.8079833984375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        -160.0,
        830.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        942.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        -160.0,
        942.0,
        230.0
      ],
      "bbox_max": [
        -150.0,
        942.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        830.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        899.459716796875,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        -150.0,
        880.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        880.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -150.0,
        840.0,
        240.0
      ],
      "bbox_max": [
        -110.0,
        840.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        250.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.5,
        850.556396484375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": 544.8612670898438,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.5,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        67.32662200927734
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.4999694824219,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        -309.5,
        974.0,
        205.0
      ],
      "bbox_max": [
        -290.7701416015625,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        67.32662200927734
      ],
      "bbox_max": [
        -289.5,
        1006.4411010742188,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -743.7392578125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        67.32662200927734
      ],
      "bbox_max": [
        -289.5,
        984.4795532226562,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        250.00003051757812
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        1066.02392578125,
        225.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -202.5,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -229.5,
        1075.0986328125,
        202.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        200.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        202.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.852865993976593,
        0.5221298933029175,
        0.0
      ],
      "plane_d": -705.1233520507812,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1047.5096435546875,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -185.47727966308594,
        1101.0794677734375,
        210.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.5000013709068298,
        -0.8660246133804321,
        0.0
      ],
      "plane_d": 1057.9532470703125,
      "bbox_min": [
        -309.5,
        991.800048828125,
        202.5
      ],
      "bbox_max": [
        -207.7459716796875,
        1087.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        202.5
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 289.5,
      "bbox_min": [
        -289.5,
        991.800048828125,
        202.5
      ],
      "bbox_max": [
        -207.7459716796875,
        1087.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -991.800048828125,
      "bbox_min": [
        -289.5,
        991.800048828125,
        202.5
      ],
      "bbox_max": [
        -207.7459716796875,
        1087.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660241365432739,
        -0.5000022053718567,
        -0.0
      ],
      "plane_d": 343.12939453125,
      "bbox_min": [
        -289.5,
        1045.6845703125,
        202.5
      ],
      "bbox_max": [
        -207.7459716796875,
        1087.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289881944656372,
        -0.5592660903930664,
        0.0
      ],
      "plane_d": 824.8079833984375,
      "bbox_min": [
        -289.5,
        1045.6845703125,
        202.5
      ],
      "bbox_max": [
        -279.7840576171875,
        1060.0863037109375,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642498254776001,
        -0.5030628442764282,
        -0.0
      ],
      "plane_d": 364.94061279296875,
      "bbox_min": [
        -290.7701416015625,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -186.49974060058594,
        1101.0794677734375,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        -290.7701416015625,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -230.48031616210938,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -231.8271484375,
        971.800048828125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        200.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        60.00611877441406
      ],
      "bbox_max": [
        -277.9530029296875,
        1011.7999877929688,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -743.7392578125,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        60.00611877441406
      ],
      "bbox_max": [
        -277.9530029296875,
        991.800048828125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35349076986312866,
        -0.6124177575111389,
        0.7070987820625305
      ],
      "plane_d": 705.6907958984375,
      "bbox_min": [
        -309.5,
        1006.4411010742188,
        60.0
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.5,
        1006.4411010742188,
        60.0
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 540.6658935546875,
      "bbox_min": [
        -309.5,
        1045.6845703125,
        60.0
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        80.00611877441406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": 719.5504150390625,
      "bbox_min": [
        -231.8204803466797,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -202.9528045654297,
        1101.0794677734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122781038284302,
        -0.3535004258155823,
        0.7072150111198425
      ],
      "plane_d": 200.15419006347656,
      "bbox_min": [
        -231.8204803466797,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -214.5,
        1101.0794677734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -301.04693603515625,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -231.40599060058594,
        931.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -301.04693603515625,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -231.40599060058594,
        931.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": 544.8612670898438,
      "bbox_min": [
        -301.04693603515625,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -277.9530029296875,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1107.953857421875,
      "bbox_min": [
        -309.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1210.361328125,
        250.00001525878906
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -250.0,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1140.2772216796875,
        250.00001525878906
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -250.0,
        1113.3665771484375,
        60.0
      ],
      "bbox_max": [
        -224.5,
        1140.2772216796875,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.177001953125,
      "bbox_min": [
        -240.8894805908203,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -224.5,
        1140.2772216796875,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5455362200737,
        0.8380873203277588,
        0.0
      ],
      "plane_d": -1064.52294921875,
      "bbox_min": [
        -228.59152221679688,
        1121.38427734375,
        75.0
      ],
      "bbox_max": [
        -228.2552490234375,
        1121.6031494140625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660280704498291,
        -0.49999555945396423,
        -0.0
      ],
      "plane_d": 361.51641845703125,
      "bbox_min": [
        -240.88949584960938,
        1113.3665771484375,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1140.2772216796875,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999954402446747,
        0.8660280704498291,
        0.0
      ],
      "plane_d": -1082.9556884765625,
      "bbox_min": [
        -237.5001220703125,
        1113.3665771484375,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1118.62646484375,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        69.74037170410156
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        205.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        205.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8642498254776001,
        -0.5030628442764282,
        -0.0
      ],
      "plane_d": 364.94061279296875,
      "bbox_min": [
        -226.2320556640625,
        1101.0794677734375,
        205.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -226.2320556640625,
        1101.0794677734375,
        210.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3534996509552002,
        -0.61227947473526,
        0.7072140574455261
      ],
      "plane_d": 705.5355224609375,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        69.74037170410156
      ],
      "bbox_max": [
        -216.40599060058594,
        1115.0986328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122781038284302,
        -0.3535004258155823,
        0.7072150111198425
      ],
      "plane_d": 200.15419006347656,
      "bbox_min": [
        -228.2564239501953,
        1101.0794677734375,
        69.74037170410156
      ],
      "bbox_max": [
        -216.40599060058594,
        1115.0986328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -309.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -309.5,
        1101.0794677734375,
        118.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        0.2588190734386444,
        0.0
      ],
      "plane_d": -582.2238159179688,
      "bbox_min": [
        -309.5,
        1126.1533203125,
        118.0
      ],
      "bbox_max": [
        -293.75,
        1179.7305908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588190734386444,
        -0.0
      ],
      "plane_d": 14.74237060546875,
      "bbox_min": [
        -309.5,
        1126.1533203125,
        118.0
      ],
      "bbox_max": [
        -293.75,
        1179.7305908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -309.5,
        1126.1533203125,
        118.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1179.7305908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        -0.0
      ],
      "plane_d": 648.2665405273438,
      "bbox_min": [
        -309.5,
        1126.1533203125,
        118.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1179.7305908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -1167.8851318359375,
      "bbox_min": [
        -309.5,
        1126.1533203125,
        118.0
      ],
      "bbox_max": [
        -309.375,
        1126.186767578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -309.5,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661441206932068,
        -0.4997943937778473,
        0.0
      ],
      "plane_d": 352.86370849609375,
      "bbox_min": [
        -309.5,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -283.16363525390625,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.0738525390625,
      "bbox_min": [
        -283.16363525390625,
        1196.7406005859375,
        120.0
      ],
      "bbox_max": [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -309.5,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380874991416931,
        -0.5455358624458313,
        0.0
      ],
      "plane_d": 420.1756591796875,
      "bbox_min": [
        -309.5,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -240.8894805908203,
        1200.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -309.5,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1200.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -309.5,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -309.5,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3195746839046478,
        0.9475610852241516,
        0.0
      ],
      "plane_d": -1175.399169921875,
      "bbox_min": [
        -309.5,
        1121.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6608257293701172,
        0.7505393624305725,
        0.0
      ],
      "plane_d": -1047.60595703125,
      "bbox_min": [
        -297.25,
        1121.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1105.95703125,
      "bbox_min": [
        -297.25,
        1121.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196141362190247,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -297.25,
        1121.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837600588798523,
        -0.17948900163173676,
        -0.0
      ],
      "plane_d": -89.8092041015625,
      "bbox_min": [
        -297.25,
        1121.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -700.6263427734375,
      "bbox_min": [
        -267.25,
        1141.0,
        61.5
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.89111328125,
      "bbox_min": [
        -309.5,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -294.0,
        1175.0,
        61.5
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -294.0,
        1175.0,
        61.5
      ],
      "bbox_max": [
        -289.5,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -616.2435913085938,
      "bbox_min": [
        -309.5,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -306.0,
        1181.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -309.5,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3195746839046478,
        0.9475610852241516,
        0.0
      ],
      "plane_d": -1175.399169921875,
      "bbox_min": [
        -309.5,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6608257293701172,
        0.7505393624305725,
        0.0
      ],
      "plane_d": -1047.60595703125,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1105.95703125,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196141362190247,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837600588798523,
        -0.17948900163173676,
        -0.0
      ],
      "plane_d": -89.8092041015625,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -700.6263427734375,
      "bbox_min": [
        -267.25,
        1141.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.89111328125,
      "bbox_min": [
        -309.5,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -294.0,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -294.0,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -289.5,
        1182.794189453125,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -309.5,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        -309.5,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        -0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": 375.0131530761719,
      "bbox_min": [
        -309.5,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429116904735565,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 380.3856506347656,
      "bbox_min": [
        -295.520751953125,
        1164.780029296875,
        74.83157348632812
      ],
      "bbox_max": [
        -285.1845703125,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056881904602
      ],
      "plane_d": 384.7021789550781,
      "bbox_min": [
        -293.45355224609375,
        1166.823974609375,
        80.98438262939453
      ],
      "bbox_max": [
        -285.1845703125,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        85.93565368652344
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        88.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        80.98438262939453
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        86.92878723144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        74.83157348632812
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        81.9775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -309.5,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1175.0,
        75.82475280761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3195746839046478,
        0.9475610852241516,
        0.0
      ],
      "plane_d": -1175.399169921875,
      "bbox_min": [
        -309.5,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -297.25,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        65.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.6608257293701172,
        0.7505393624305725,
        0.0
      ],
      "plane_d": -1047.60595703125,
      "bbox_min": [
        -297.25,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11962061375379562,
        0.9928197264671326,
        0.0
      ],
      "plane_d": -1105.95703125,
      "bbox_min": [
        -297.25,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196141362190247,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -297.25,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837600588798523,
        -0.17948900163173676,
        -0.0
      ],
      "plane_d": -89.8092041015625,
      "bbox_min": [
        -297.25,
        1121.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -700.6263427734375,
      "bbox_min": [
        -267.25,
        1141.0,
        62.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547165751457214,
        0.6560510396957397,
        0.0
      ],
      "plane_d": -533.3060302734375,
      "bbox_min": [
        -288.42059326171875,
        1140.142333984375,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7545397877693176,
        0.6562542915344238,
        0.0
      ],
      "plane_d": -532.7886352539062,
      "bbox_min": [
        -287.029541015625,
        1141.2315673828125,
        64.68001556396484
      ],
      "bbox_max": [
        -286.4653015136719,
        1141.5333251953125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6560426950454712,
        0.7547239065170288,
        0.0
      ],
      "plane_d": -1049.648193359375,
      "bbox_min": [
        -287.029541015625,
        1141.27099609375,
        64.76000213623047
      ],
      "bbox_max": [
        -286.7277526855469,
        1141.5333251953125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5336251854896545,
        0.46411576867103577,
        0.7069941163063049
      ],
      "plane_d": -422.328857421875,
      "bbox_min": [
        -287.5938720703125,
        1140.40478515625,
        63.999996185302734
      ],
      "bbox_max": [
        -285.90093994140625,
        1142.09765625,
        64.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46391117572784424,
        0.5336705446243286,
        0.7070942521095276
      ],
      "plane_d": -787.7557983398438,
      "bbox_min": [
        -287.5938720703125,
        1140.40478515625,
        63.999996185302734
      ],
      "bbox_max": [
        -286.6882629394531,
        1142.09765625,
        64.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5336341857910156,
        -0.4638999402523041,
        0.7071290612220764
      ],
      "plane_d": 330.7276611328125,
      "bbox_min": [
        -287.5938720703125,
        1140.40478515625,
        63.999996185302734
      ],
      "bbox_max": [
        -286.7671203613281,
        1141.3104248046875,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6560426950454712,
        0.7547239065170288,
        0.0
      ],
      "plane_d": -1049.648193359375,
      "bbox_min": [
        -287.029541015625,
        1141.27099609375,
        64.4000015258789
      ],
      "bbox_max": [
        -286.7277526855469,
        1141.5333251953125,
        64.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7545397877693176,
        0.6562542915344238,
        0.0
      ],
      "plane_d": -532.7886352539062,
      "bbox_min": [
        -286.9994201660156,
        1141.2315673828125,
        64.4000015258789
      ],
      "bbox_max": [
        -286.4653015136719,
        1141.5333251953125,
        64.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6560426950454712,
        0.7547239065170288,
        0.0
      ],
      "plane_d": -1049.648193359375,
      "bbox_min": [
        -286.9994201660156,
        1141.2972412109375,
        64.4000015258789
      ],
      "bbox_max": [
        -286.7277526855469,
        1141.5333251953125,
        64.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244941711426,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 329.8907470703125,
      "bbox_min": [
        -309.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -278.7679443359375,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -278.7679443359375,
        1175.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866024374961853,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.89111328125,
      "bbox_min": [
        -294.0,
        1167.205810546875,
        62.0
      ],
      "bbox_max": [
        -289.5,
        1175.0,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.89111328125,
      "bbox_min": [
        -294.0,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -289.5,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -309.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -309.5,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.2054443359375,
        1175.0,
        75.82475280761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12866723537445068,
        0.14801400899887085,
        0.9805797338485718
      ],
      "plane_d": -271.0050964355469,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547165751457214,
        0.6560510396957397,
        0.0
      ],
      "plane_d": -533.3060302734375,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -66.5999984741211,
      "bbox_min": [
        -287.10845947265625,
        1139.689453125,
        66.5999984741211
      ],
      "bbox_max": [
        -285.2054443359375,
        1141.4544677734375,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -287.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        75.82475280761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        -0.6092076897621155,
        0.5076730251312256
      ],
      "plane_d": 507.52081298828125,
      "bbox_min": [
        -287.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1185.794189453125,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244941711426,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -845.1131591796875,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -62.499996185302734,
      "bbox_min": [
        -289.5,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -289.5,
        1182.794189453125,
        62.0
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.794189453125,
      "bbox_min": [
        -289.5,
        1182.794189453125,
        62.5
      ],
      "bbox_max": [
        -280.5,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -287.7679443359375,
        1185.794189453125,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429112732410431,
        0.346808522939682,
        -0.8730038404464722
      ],
      "plane_d": -244.40118408203125,
      "bbox_min": [
        -285.25,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680888056755066,
        -0.8730039000511169
      ],
      "plane_d": -439.98748779296875,
      "bbox_min": [
        -285.25,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -274.848388671875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429116904735565,
        0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": -239.03128051757812,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -274.848388671875,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        0.3468110263347626,
        -0.873003363609314
      ],
      "plane_d": -434.61834716796875,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -276.91558837890625,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        0.3468044102191925,
        -0.8730056881904602
      ],
      "plane_d": -234.70242309570312,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -276.91558837890625,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        0.34680864214897156,
        -0.8730035424232483
      ],
      "plane_d": -430.2935791015625,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -285.1845703125,
        1183.176025390625,
        89.18366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680888056755066,
        -0.8730039000511169
      ],
      "plane_d": -439.98748779296875,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        0.3468110263347626,
        -0.873003363609314
      ],
      "plane_d": -434.61834716796875,
      "bbox_min": [
        -295.520751953125,
        1175.0,
        80.9843978881836
      ],
      "bbox_max": [
        -285.25,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        0.34680864214897156,
        -0.8730035424232483
      ],
      "plane_d": -430.2935791015625,
      "bbox_min": [
        -293.45355224609375,
        1175.0,
        85.93566131591797
      ],
      "bbox_max": [
        -285.25,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.6092076897621155,
        0.5076730251312256
      ],
      "plane_d": -924.1172485351562,
      "bbox_min": [
        -287.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -309.5,
        830.0,
        249.99998474121094
      ],
      "bbox_max": [
        -100.0,
        1210.361328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -289.5,
        850.556396484375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -309.5,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289904594421387,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 262.5,
      "bbox_min": [
        -306.134521484375,
        1058.0174560546875,
        250.0
      ],
      "bbox_max": [
        -297.97650146484375,
        1069.4404296875,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5592275261878967,
        0.8290141820907593,
        0.0
      ],
      "plane_d": -706.376220703125,
      "bbox_min": [
        -306.134521484375,
        1058.0174560546875,
        250.0
      ],
      "bbox_max": [
        -297.97650146484375,
        1069.4404296875,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5592275261878967,
        -0.829014241695404,
        0.0
      ],
      "plane_d": 719.4810791015625,
      "bbox_min": [
        -298.80548095703125,
        1068.8812255859375,
        250.0
      ],
      "bbox_max": [
        -297.97650146484375,
        1069.4404296875,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1101.0794677734375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        942.0,
        260.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        -160.0,
        942.0,
        250.00001525878906
      ],
      "bbox_max": [
        -150.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        -150.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        916.7801513671875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        899.459716796875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -150.0,
        840.0,
        250.00001525878906
      ],
      "bbox_max": [
        -110.0,
        840.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1107.953857421875,
      "bbox_min": [
        -309.5,
        1101.0775146484375,
        250.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1210.361328125,
        540.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        250.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -248.7819061279297,
        1101.0794677734375,
        300.0
      ],
      "bbox_max": [
        -216.40597534179688,
        1115.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1130.4095458984375,
      "bbox_min": [
        -309.5,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -309.5,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 432.0,
      "bbox_min": [
        -309.5,
        1130.4095458984375,
        432.0
      ],
      "bbox_max": [
        -250.66021728515625,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -279.5001220703125,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1210.361328125,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -279.5001220703125,
        1158.2647705078125,
        60.00611877441406
      ],
      "bbox_max": [
        -249.42201232910156,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -261.18597412109375,
        1178.6614990234375,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -274.502197265625,
        820.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1210.361328125,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -274.502197265625,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -274.502197265625,
        1097.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -274.502197265625,
        1115.0986328125,
        60.00611877441406
      ],
      "bbox_max": [
        -97.95298767089844,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -274.502197265625,
        1115.0986328125,
        60.00611877441406
      ],
      "bbox_max": [
        -171.99990844726562,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        -249.50003051757812,
        1115.0986328125,
        75.26748657226562
      ],
      "bbox_max": [
        -171.99990844726562,
        1171.3902587890625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455362200737,
        0.8380873203277588,
        0.0
      ],
      "plane_d": -1057.02294921875,
      "bbox_min": [
        -249.50003051757812,
        1115.0986328125,
        75.26748657226562
      ],
      "bbox_max": [
        -199.3573760986328,
        1158.40478515625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455362200737,
        0.8380873203277588,
        0.0
      ],
      "plane_d": -1064.52294921875,
      "bbox_min": [
        -249.50003051757812,
        1121.6031494140625,
        75.26748657226562
      ],
      "bbox_max": [
        -203.4488983154297,
        1158.40478515625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        120.0
      ],
      "bbox_max": [
        -239.5,
        1158.40478515625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999993145465851,
        -0.8660258054733276,
        0.0
      ],
      "plane_d": 1107.9541015625,
      "bbox_min": [
        -239.49996948242188,
        1141.0794677734375,
        250.0
      ],
      "bbox_max": [
        -186.9999542236328,
        1171.3902587890625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        60.00611877441406
      ],
      "bbox_max": [
        -219.50009155273438,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.0738525390625,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        80.0
      ],
      "bbox_max": [
        -249.49725341796875,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        80.0
      ],
      "bbox_max": [
        -249.49725341796875,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -274.502197265625,
        1178.6611328125,
        80.0
      ],
      "bbox_max": [
        -252.5245361328125,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -274.502197265625,
        1178.6611328125,
        120.0
      ],
      "bbox_max": [
        -252.5245361328125,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -262.07373046875,
        1178.6611328125,
        120.0
      ],
      "bbox_max": [
        -261.1859130859375,
        1180.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -261.18621826171875,
        1158.4000244140625,
        120.0
      ],
      "bbox_max": [
        -249.49725341796875,
        1178.661376953125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -139.4999237060547,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -97.95298767089844,
        1210.361328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996509552002,
        0.7072148323059082
      ],
      "plane_d": 419.9613037109375,
      "bbox_min": [
        -144.5,
        1097.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1178.39990234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -214.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1097.7781982421875,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -214.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1097.7781982421875,
        155.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -94.53842163085938,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        890.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -59.897216796875,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -94.53842163085938,
        820.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        890.0,
        144.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -59.897216796875,
        820.0,
        140.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        -94.53842163085938,
        890.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        890.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": 719.5504150390625,
      "bbox_min": [
        -214.5,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -121.4059829711914,
        1097.7781982421875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -160.0,
        830.0,
        155.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -160.0,
        899.4596557617188,
        155.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1003.3821411132812,
        155.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        1003.3821411132812,
        155.0
      ],
      "bbox_max": [
        -160.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -150.0,
        899.4596557617188,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        -150.0,
        916.7801513671875,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -110.0,
        980.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        980.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1000.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703097715159e-06,
        1.0,
        -0.0
      ],
      "plane_d": -839.807861328125,
      "bbox_min": [
        -65.55984497070312,
        830.0,
        155.0
      ],
      "bbox_max": [
        -50.0,
        839.8079223632812,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        -65.55984497070312,
        830.0,
        175.0
      ],
      "bbox_max": [
        -50.0,
        839.8079223632812,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -50.0,
        830.0,
        144.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1889248639345169,
        0.9819916486740112,
        0.0
      ],
      "plane_d": -834.130615234375,
      "bbox_min": [
        -50.0,
        830.0,
        155.0
      ],
      "bbox_max": [
        0.0,
        849.4273681640625,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        -50.0,
        830.0,
        175.0
      ],
      "bbox_max": [
        0.0,
        849.4273681640625,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        890.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19508984684944153,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 882.6535034179688,
      "bbox_min": [
        -50.0,
        890.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        102.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 79.99999237060547,
      "bbox_min": [
        -50.0,
        860.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        82.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        1.9584635424507724e-07,
        903.6550903320312,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19508984684944153,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 882.6535034179688,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        82.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        80.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11794932931661606,
        0.0,
        0.9930195808410645
      ],
      "plane_d": -75.53013610839844,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        -28.56973648071289,
        893.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488604426384,
        0.03555978462100029,
        0.9956733584403992
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        -28.56973648071289,
        875.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19508984684944153,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -882.6535034179688,
      "bbox_min": [
        -50.0,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        903.6550903320312,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488604426384,
        0.03555978462100029,
        0.9956733584403992
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        76.20401763916016
      ],
      "bbox_max": [
        2.384185791015625e-07,
        899.9456176757812,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        76.20401763916016
      ],
      "bbox_max": [
        0.0,
        899.9456176757812,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11794932931661606,
        0.0,
        0.9930195808410645
      ],
      "plane_d": -75.53013610839844,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        77.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        898.3732299804688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -28.569734573364258,
        864.2627563476562,
        77.33370208740234
      ],
      "bbox_max": [
        2.384185791015625e-07,
        869.9456176757812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        60.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        75.89246368408203
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        869.9456176757812,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15402752161026,
        -0.06380032747983932,
        0.9860045313835144
      ],
      "plane_d": -35.59947204589844,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        869.9456176757812,
        92.26585388183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        860.0,
        82.0
      ],
      "bbox_max": [
        1.639127589214695e-07,
        869.9456176757812,
        92.26585388183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        92.26585388183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -50.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 123.99999237060547,
      "bbox_min": [
        -50.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        124.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        890.0,
        124.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19508984684944153,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 882.6535034179688,
      "bbox_min": [
        -50.0,
        890.0,
        124.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        124.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        126.0
      ],
      "bbox_max": [
        0.0,
        1030.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 49.0,
      "bbox_min": [
        -50.0,
        1010.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1030.0,
        144.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1025.0,
      "bbox_min": [
        -50.0,
        1010.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1030.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        -50.0,
        1030.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1030.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1015.0,
      "bbox_min": [
        -50.0,
        1010.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1025.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        -50.0,
        1010.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1010.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -134.0,
      "bbox_min": [
        -50.0,
        1015.0,
        128.0
      ],
      "bbox_max": [
        -49.0,
        1025.0,
        134.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 128.0,
      "bbox_min": [
        -50.0,
        1015.0,
        128.0
      ],
      "bbox_max": [
        -49.0,
        1025.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1239.0,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -355.0,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5944213867188,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1254.538818359375,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -990.4848022460938,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -829.333984375,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        -0.0
      ],
      "plane_d": -204.16278076171875,
      "bbox_min": [
        -341.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1005.792236328125,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1239.2314453125,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -240.40463256835938,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -793.0921630859375,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -308.5355224609375,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -295.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        83.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -83.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        83.0
      ],
      "bbox_max": [
        -312.0,
        1238.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1212.4000244140625,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        83.0
      ],
      "bbox_max": [
        -312.0,
        1238.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1238.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        83.0
      ],
      "bbox_max": [
        -312.0,
        1238.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        83.0
      ],
      "bbox_max": [
        -312.0,
        1238.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        83.0
      ],
      "bbox_max": [
        -338.0,
        1238.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        85.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -340.0,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        118.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1230.0,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        95.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        98.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -98.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        98.0
      ],
      "bbox_max": [
        -312.0,
        1228.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1212.4000244140625,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        98.0
      ],
      "bbox_max": [
        -312.0,
        1228.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1228.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        98.0
      ],
      "bbox_max": [
        -312.0,
        1228.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        98.0
      ],
      "bbox_max": [
        -312.0,
        1228.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -338.0,
        1212.4000244140625,
        98.0
      ],
      "bbox_max": [
        -338.0,
        1228.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        85.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1230.0,
      "bbox_min": [
        -335.0,
        1230.0,
        85.0
      ],
      "bbox_max": [
        -315.0,
        1230.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -340.0,
        1235.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -340.0,
        1210.361328125,
        75.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        75.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -116.40591430664062,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -116.40591430664062,
        1219.021728515625,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -144.5,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -116.40591430664062,
        1219.021728515625,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -144.5,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -116.40591430664062,
        1219.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -214.5,
        1219.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -237.59400939941406,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -121.40599822998047,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -237.59400939941406,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -121.40599822998047,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -144.5,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -121.40599822998047,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -633.3114013671875,
        945.08935546875,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 111.97991943359375,
      "bbox_min": [
        -633.3114013671875,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -1046.42041015625,
      "bbox_min": [
        -551.0469970703125,
        1105.0,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -504.5,
        1105.0,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -446.6790466308594,
        1105.0,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1219.021728515625,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -446.6790466308594,
        1105.0,
        75.01204681396484
      ],
      "bbox_max": [
        -399.4999694824219,
        1158.6741943359375,
        131.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648216128349304,
        -0.0
      ],
      "plane_d": -758.728759765625,
      "bbox_min": [
        -446.6790466308594,
        1115.0,
        75.01204681396484
      ],
      "bbox_max": [
        -420.7500305175781,
        1136.647216796875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        0.518405556678772,
        -0.0
      ],
      "plane_d": -218.97769165039062,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        -0.518405556678772,
        0.0
      ],
      "plane_d": 942.250732421875,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.1944580078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -425.51434326171875,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020702481269836,
        0.8648269176483154,
        -0.0
      ],
      "plane_d": -751.238525390625,
      "bbox_min": [
        -430.0,
        1115.6875,
        95.0
      ],
      "bbox_max": [
        -425.51434326171875,
        1118.2916259765625,
        103.15575408935547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020702481269836,
        0.8648269176483154,
        -0.0
      ],
      "plane_d": -751.238525390625,
      "bbox_min": [
        -425.51434326171875,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -424.5,
        1115.6875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.871756911277771,
        -0.4899386465549469,
        0.0
      ],
      "plane_d": 925.495849609375,
      "bbox_min": [
        -435.0,
        1115.0,
        120.0
      ],
      "bbox_max": [
        -407.18524169921875,
        1150.3536376953125,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5110283493995667,
        0.8595638275146484,
        -0.0
      ],
      "plane_d": -776.1936645507812,
      "bbox_min": [
        -407.63079833984375,
        1145.0887451171875,
        120.0
      ],
      "bbox_max": [
        -407.18524169921875,
        1145.3536376953125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661852478981018,
        0.4997231066226959,
        0.0
      ],
      "plane_d": -924.920166015625,
      "bbox_min": [
        -434.5,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1219.021728515625,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -399.5028076171875,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1210.4000244140625,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -399.5,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        -369.4775085449219,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -399.5,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -387.95294189453125,
        1178.4073486328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -387.81402587890625,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -374.483154296875,
        1201.738525390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        -0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -387.81402587890625,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -374.483154296875,
        1201.738525390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.81402587890625,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -387.80487060546875,
        1178.6614990234375,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -374.497802734375,
        1219.021728515625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661441206932068,
        0.4997943937778473,
        0.0
      ],
      "plane_d": -934.9912109375,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0647583007812,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        125.006103515625
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -504.5,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -411.4059753417969,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -411.4059753417969,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -551.0469970703125,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -492.9654846191406,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -516.034423828125,
        1219.021728515625,
        60.02784729003906
      ],
      "bbox_max": [
        -492.9654846191406,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -633.3114013671875,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -504.5,
        1239.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        -633.3114013671875,
        1098.025634765625,
        214.0
      ],
      "bbox_max": [
        -604.3262329101562,
        1239.0,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -562.593994140625,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -539.5,
        1178.39990234375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8683005571365356,
        0.49603843688964844,
        -0.0
      ],
      "plane_d": -35.4638671875,
      "bbox_min": [
        -604.1851806640625,
        945.08935546875,
        60.0
      ],
      "bbox_max": [
        -434.5,
        1097.7781982421875,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9273704886436462,
        0.374144583940506,
        -0.0
      ],
      "plane_d": 116.008056640625,
      "bbox_min": [
        -604.1851806640625,
        945.08935546875,
        60.0
      ],
      "bbox_max": [
        -513.0787963867188,
        1097.7781982421875,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        -604.1851806640625,
        945.08935546875,
        214.0
      ],
      "bbox_max": [
        -513.0787963867188,
        1097.7781982421875,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 719.6735229492188,
      "bbox_min": [
        -527.593994140625,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -434.5,
        1097.7781982421875,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355374217033386,
        0.7071067690849304
      ],
      "plane_d": 22.608856201171875,
      "bbox_min": [
        -527.593994140625,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -504.5,
        1097.7781982421875,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        450.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        480.0,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        480.0,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        530.4696044921875,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1185.6285400390625,
        80.0
      ],
      "bbox_max": [
        680.0,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        80.0
      ],
      "bbox_max": [
        680.0,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        80.0
      ],
      "bbox_max": [
        680.0,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        664.30078125,
        1372.96533203125,
        80.0
      ],
      "bbox_max": [
        680.0,
        1384.3714599609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        535.7269287109375,
        1362.5953369140625,
        80.0
      ],
      "bbox_max": [
        565.69921875,
        1384.3714599609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        542.8024291992188,
        1384.3714599609375,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        542.8024291992188,
        1384.3714599609375,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        542.8024291992188,
        1384.3714599609375,
        78.0
      ],
      "bbox_max": [
        680.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        575.0869140625,
        1420.0,
        80.0
      ],
      "bbox_max": [
        680.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        542.8024291992188,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        680.0,
        1400.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        480.0,
        1285.0,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        480.0,
        1317.360595703125,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        500.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        554.3788452148438,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1378.914306640625,
        78.0
      ],
      "bbox_max": [
        480.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        505.25732421875,
        1285.0,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        450.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        530.4696044921875,
        1415.0,
        330.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        450.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        530.4696044921875,
        1378.914306640625,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        480.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        530.4696044921875,
        1378.914306640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1317.360595703125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        500.0,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        500.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        510.5146179199219,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        480.0,
        1140.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1378.914306640625,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        450.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        450.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        450.0,
        1310.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        450.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        450.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1000.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1000.0,
        330.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        450.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        680.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        680.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        680.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        680.0,
        1352.5953369140625,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        680.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        680.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1040.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        680.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1040.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        2035.0,
        640.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        120.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        180.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        180.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        180.0,
        820.0,
        75.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        183.3708953857422,
        820.0,
        120.0
      ],
      "bbox_max": [
        190.0,
        829.921142578125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        180.0,
        820.0,
        130.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        183.3708953857422,
        820.0,
        130.0
      ],
      "bbox_max": [
        190.0,
        829.921142578125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        183.3708953857422,
        820.0,
        140.0
      ],
      "bbox_max": [
        190.0,
        829.921142578125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        120.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509030878543854,
        0.0
      ],
      "plane_d": -174.94122314453125,
      "bbox_min": [
        120.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        120.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        120.0,
        1490.0,
        214.0
      ],
      "bbox_max": [
        120.01652526855469,
        1500.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        120.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1342.320556640625,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        129.99996948242188,
        824.054443359375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 993.290771484375,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": -809.821533203125,
      "bbox_min": [
        151.7926025390625,
        1297.05908203125,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        460.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314696550369263,
        0.0
      ],
      "plane_d": -1320.8570556640625,
      "bbox_min": [
        190.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555697083473206,
        0.8314700126647949,
        0.0
      ],
      "plane_d": -1212.971435546875,
      "bbox_min": [
        190.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314701318740845,
        0.5555695295333862,
        0.0
      ],
      "plane_d": -674.9655151367188,
      "bbox_min": [
        190.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1759.507568359375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        190.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1759.507568359375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        221.37026977539062,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1759.507568359375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903832912445,
        0.9807853102684021,
        0.0
      ],
      "plane_d": -1569.7364501953125,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1759.507568359375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555697083473206,
        0.8314700722694397,
        0.0
      ],
      "plane_d": -1183.548095703125,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1675.537109375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698934555054,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -645.5426635742188,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        315.64971923828125,
        1634.350341796875,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903832912445,
        0.0
      ],
      "plane_d": -37.63140869140625,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        274.462890625,
        1572.7098388671875,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        252.04348754882812,
        1460.0,
        140.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        252.04348754882812,
        1460.0,
        140.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        274.462890625,
        1572.7098388671875,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 250.0,
      "bbox_min": [
        242.1457977294922,
        1460.0,
        120.0
      ],
      "bbox_max": [
        250.0,
        1500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        242.1457977294922,
        1460.0,
        120.0
      ],
      "bbox_max": [
        250.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        260.0379333496094,
        1551.121337890625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        231.15762329101562,
        1507.89892578125,
        120.0
      ],
      "bbox_max": [
        315.64971923828125,
        1634.350341796875,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        260.0379333496094,
        1551.121337890625,
        120.0
      ],
      "bbox_max": [
        315.64971923828125,
        1634.350341796875,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9812625646591187,
        0.19267582893371582,
        0.0
      ],
      "plane_d": -43.698089599609375,
      "bbox_min": [
        260.0379333496094,
        1551.121337890625,
        120.0
      ],
      "bbox_max": [
        265.0430908203125,
        1576.6116943359375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        301.8798522949219,
        1660.537109375,
        120.0
      ],
      "bbox_max": [
        450.0,
        1759.507568359375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1835126131772995,
        -0.9830173850059509,
        0.0
      ],
      "plane_d": 1637.69970703125,
      "bbox_min": [
        430.2540283203125,
        1746.313720703125,
        120.0
      ],
      "bbox_max": [
        450.0,
        1750.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        221.37026977539062,
        1460.0,
        120.0
      ],
      "bbox_max": [
        230.14447021484375,
        1502.9405517578125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        190.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        246.7465362548828,
        1584.1904296875,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1460.0,
        130.0
      ],
      "bbox_max": [
        203.68621826171875,
        1519.745849609375,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        190.0,
        1499.262939453125,
        120.0
      ],
      "bbox_max": [
        294.4364929199219,
        1655.5635986328125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -129.99998474121094,
      "bbox_min": [
        190.0,
        1499.262939453125,
        120.0
      ],
      "bbox_max": [
        228.0021514892578,
        1611.173583984375,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8314694166183472,
        -0.5555704832077026,
        0.0
      ],
      "plane_d": 705.543701171875,
      "bbox_min": [
        217.94412231445312,
        1596.1207275390625,
        120.0
      ],
      "bbox_max": [
        228.0021514892578,
        1611.173583984375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        190.0,
        1592.0345458984375,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19659994542598724,
        -0.980483889579773,
        0.0
      ],
      "plane_d": 1696.0107421875,
      "bbox_min": [
        190.0,
        1592.0345458984375,
        60.0
      ],
      "bbox_max": [
        450.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        190.0,
        1592.0345458984375,
        60.0
      ],
      "bbox_max": [
        450.0,
        1820.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        60.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555703639984131,
        -0.8314696550369263,
        0.0
      ],
      "plane_d": 1310.85693359375,
      "bbox_min": [
        190.0,
        1592.0345458984375,
        120.0
      ],
      "bbox_max": [
        450.0,
        1795.46044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        202.13682556152344,
        1711.61767578125,
        120.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1592.0345458984375,
        120.0
      ],
      "bbox_max": [
        450.0,
        1770.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5555702447891235,
        -0.8314695954322815,
        0.0
      ],
      "plane_d": 1243.5469970703125,
      "bbox_min": [
        190.0,
        1611.173583984375,
        120.0
      ],
      "bbox_max": [
        430.2540588378906,
        1746.313720703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        120.0
      ],
      "bbox_max": [
        202.13682556152344,
        1711.61767578125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314694166183472,
        -0.5555704832077026,
        0.0
      ],
      "plane_d": 705.543701171875,
      "bbox_min": [
        228.0021514892578,
        1611.173583984375,
        120.0
      ],
      "bbox_max": [
        430.2540588378906,
        1746.313720703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1835126131772995,
        -0.9830173850059509,
        0.0
      ],
      "plane_d": 1637.69970703125,
      "bbox_min": [
        353.87933349609375,
        1732.055908203125,
        120.0
      ],
      "bbox_max": [
        430.2540588378906,
        1746.313720703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        130.0
      ],
      "bbox_max": [
        202.13682556152344,
        1711.61767578125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1345.0,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1348.347412109375,
      "bbox_min": [
        190.0,
        1335.6220703125,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 250.0,
      "bbox_min": [
        190.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        250.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        270.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1310.0,
        130.0
      ],
      "bbox_max": [
        200.0,
        1460.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        920.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        920.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        920.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        120.0
      ],
      "bbox_max": [
        241.5006103515625,
        906.997314453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9804636240005493,
        0.19670069217681885,
        0.0
      ],
      "plane_d": 48.41522216796875,
      "bbox_min": [
        226.98284912109375,
        885.2699584960938,
        120.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        241.5006103515625,
        906.997314453125,
        120.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        195.3977813720703,
        820.0,
        210.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        210.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        280.0
      ],
      "bbox_max": [
        254.03262329101562,
        920.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        195.3977813720703,
        820.0,
        350.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        350.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        195.3977813720703,
        820.0,
        280.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        280.0
      ],
      "bbox_max": [
        241.07882690429688,
        881.3681640625,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        280.0
      ],
      "bbox_max": [
        244.08700561523438,
        920.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        190.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 250.0,
      "bbox_min": [
        190.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        250.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        250.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        250.0,
        1280.0,
        75.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        250.0,
        1309.64111328125,
        75.0
      ],
      "bbox_max": [
        250.6217041015625,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        340.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        250.0,
        949.7266235351562,
        100.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        440.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        250.0,
        949.7266235351562,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        250.0,
        949.7266235351562,
        120.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        250.0,
        949.7266235351562,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        920.0,
        75.0
      ],
      "bbox_max": [
        250.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        215.2666778564453,
        1297.05908203125,
        75.0
      ],
      "bbox_max": [
        250.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        244.08700561523438,
        920.0,
        120.0
      ],
      "bbox_max": [
        250.0,
        949.7266235351562,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9804636240005493,
        0.19670069217681885,
        0.0
      ],
      "plane_d": 48.41522216796875,
      "bbox_min": [
        233.9503936767578,
        920.0,
        130.0
      ],
      "bbox_max": [
        250.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        244.08700561523438,
        920.0,
        130.0
      ],
      "bbox_max": [
        250.0,
        949.7266235351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        210.0,
        920.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        210.0,
        920.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        244.08700561523438,
        920.0,
        140.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        244.08700561523438,
        920.0,
        140.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        244.08700561523438,
        920.0,
        160.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        244.08700561523438,
        920.0,
        350.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        210.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        210.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        210.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        340.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        440.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        385.0,
        1240.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        260.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        385.0,
        1240.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        260.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        385.0,
        980.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        0.0,
        1490.0,
        211.52786254882812
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1509.4034423828125,
        211.52786254882812
      ],
      "bbox_max": [
        92.0,
        1513.9443359375,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 89.99999237060547,
      "bbox_min": [
        35.0,
        1509.4034423828125,
        211.52786254882812
      ],
      "bbox_max": [
        92.0,
        1513.9443359375,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1259.0675048828125,
      "bbox_min": [
        90.0,
        1513.444091796875,
        211.52786254882812
      ],
      "bbox_max": [
        92.0,
        1513.944091796875,
        212.52786254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        35.0,
        1509.403564453125,
        211.52786254882812
      ],
      "bbox_max": [
        35.0,
        1513.9443359375,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        16.0,
        1490.0,
        214.0
      ],
      "bbox_max": [
        93.0,
        1511.5380859375,
        219.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9943788051605225,
        0.09470274299383163,
        -0.04735137149691582
      ],
      "plane_d": -97.40176391601562,
      "bbox_min": [
        34.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        90.0,
        1506.634521484375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9943787455558777,
        0.09470273554325104,
        -0.04735136777162552
      ],
      "plane_d": -42.71092987060547,
      "bbox_min": [
        89.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        90.0,
        1506.634521484375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 89.99999237060547,
      "bbox_min": [
        90.0,
        1504.5,
        217.0
      ],
      "bbox_max": [
        90.0,
        1506.634521484375,
        218.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945054650306702,
        0.10468478500843048,
        0.0
      ],
      "plane_d": -122.69056701660156,
      "bbox_min": [
        34.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        35.0,
        1506.634521484375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        35.0,
        1504.5,
        217.0
      ],
      "bbox_max": [
        35.0,
        1506.634521484375,
        218.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 89.99999237060547,
      "bbox_min": [
        35.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        92.0,
        1511.5380859375,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218876600265503,
        -0.8530142903327942
      ],
      "plane_d": 970.2840576171875,
      "bbox_min": [
        90.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        92.0,
        1509.4034423828125,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        35.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        37.0,
        1511.5380859375,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        37.0,
        1509.403564453125,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        10.0,
        1430.0,
        230.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        0.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        1240.0,
        175.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        155.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        110.0,
        949.7265625,
        175.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -702.5145263671875,
      "bbox_min": [
        0.0,
        839.9456176757812,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        175.0
      ],
      "bbox_max": [
        84.7259750366211,
        901.519287109375,
        175.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8381732702255249,
        0.5454040765762329,
        0.0
      ],
      "plane_d": -430.18701171875,
      "bbox_min": [
        0.0,
        844.9071655273438,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9825752973556519,
        0.18586482107639313,
        0.0
      ],
      "plane_d": -77.78153228759766,
      "bbox_min": [
        0.0,
        844.9071655273438,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        98.74483489990234,
        940.49951171875,
        175.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1889248639345169,
        0.9819916486740112,
        0.0
      ],
      "plane_d": -834.130615234375,
      "bbox_min": [
        0.0,
        844.9071655273438,
        155.0
      ],
      "bbox_max": [
        9.500479698181152,
        851.2551879882812,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        844.9071655273438,
        175.0
      ],
      "bbox_max": [
        9.500479698181152,
        851.2551879882812,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        82.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        82.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        0.0,
        1040.0,
        80.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        80.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        80.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        79.34313201904297,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555700659751892,
        0.0
      ],
      "plane_d": 489.2572021484375,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.19509047269821167,
        0.0
      ],
      "plane_d": 136.2433624267578,
      "bbox_min": [
        0.0,
        903.6550903320312,
        80.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        0.0,
        903.6550903320312,
        80.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        1.6391277313232422e-07,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.049578726291656494,
        0.1196933388710022,
        0.9915722608566284
      ],
      "plane_d": -183.64974975585938,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06570588052272797,
        0.06570590287446976,
        0.9956733584403992
      ],
      "plane_d": -134.10910034179688,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.16403737664222717,
        0.9864540696144104
      ],
      "plane_d": -223.22462463378906,
      "bbox_min": [
        0.0,
        903.6550903320312,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        75.05838012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.045137323439121246,
        0.10897087305784225,
        0.9930195808410645
      ],
      "plane_d": -173.246337890625,
      "bbox_min": [
        0.0,
        903.6550903320312,
        60.0
      ],
      "bbox_max": [
        79.34313201904297,
        1000.0,
        75.05838012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555700659751892,
        0.0
      ],
      "plane_d": -489.2572021484375,
      "bbox_min": [
        0.0,
        903.6550903320312,
        60.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        75.05838012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509047269821167,
        0.0
      ],
      "plane_d": -136.2433624267578,
      "bbox_min": [
        0.0,
        903.6550903320312,
        60.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        75.05838012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        0.0,
        903.6550903320312,
        60.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        75.05838012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        869.9456176757812,
        67.0
      ],
      "bbox_max": [
        79.34313201904297,
        946.42431640625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488455414772,
        0.03555978089570999,
        0.995673418045044
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        0.0,
        869.9456176757812,
        72.0
      ],
      "bbox_max": [
        48.99494934082031,
        922.21826171875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        0.0,
        898.7388305664062,
        72.0
      ],
      "bbox_max": [
        48.99494934082031,
        922.21826171875,
        76.30537414550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        0.0,
        903.6550903320312,
        72.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        75.89246368408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        1.9584635424507724e-07,
        869.9456176757812,
        77.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        870.4802856445312,
        60.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        870.4802856445312,
        60.0
      ],
      "bbox_max": [
        79.34313201904297,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        0.0,
        870.4802856445312,
        60.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        2.6880502700805664,
        870.4802856445312,
        79.9343032836914
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        0.0,
        820.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 124.0,
      "bbox_min": [
        0.0,
        820.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        126.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        0.195090189576149,
        0.0
      ],
      "plane_d": -77.39594268798828,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -692.5145263671875,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.555570662021637,
        0.0
      ],
      "plane_d": -430.41064453125,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        0.0,
        1040.0,
        124.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        124.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        124.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.19509047269821167,
        0.0
      ],
      "plane_d": 136.2433624267578,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555700659751892,
        0.0
      ],
      "plane_d": 489.2572021484375,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        51.626747131347656,
        957.9048461914062,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        0.0,
        903.6550903320312,
        124.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        88.2238540649414,
        989.1572875976562,
        124.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0694173201918602,
        -0.16758783161640167,
        0.9834102392196655
      ],
      "plane_d": 52.008216857910156,
      "bbox_min": [
        113.2238540649414,
        989.1572875976562,
        124.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        0.0,
        820.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        124.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        104.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        0.0,
        1040.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15402749180793762,
        -0.06380031257867813,
        0.9860045313835144
      ],
      "plane_d": -35.5994873046875,
      "bbox_min": [
        9.452665328979492,
        841.8258666992188,
        102.0
      ],
      "bbox_max": [
        70.2081527709961,
        879.7918701171875,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        9.452665328979492,
        841.8258666992188,
        102.0
      ],
      "bbox_max": [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555700659751892,
        0.0
      ],
      "plane_d": 489.2572021484375,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.19509047269821167,
        0.0
      ],
      "plane_d": 136.2433624267578,
      "bbox_min": [
        0.0,
        903.6550903320312,
        102.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555707216262817,
        -0.8314693570137024,
        0.0
      ],
      "plane_d": 751.3614501953125,
      "bbox_min": [
        0.0,
        903.6550903320312,
        102.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14221441745758057,
        -0.14221446216106415,
        0.9795662760734558
      ],
      "plane_d": 33.228851318359375,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        40.736900329589844,
        895.4871826171875,
        102.0
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        9.452666282653809,
        841.8258666992188,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        84.09091186523438,
        1210.0,
        102.0
      ],
      "bbox_max": [
        90.0,
        1240.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32059624791145325,
        -1.0191480726007285e-07,
        -0.9472160339355469
      ],
      "plane_d": 67.76249694824219,
      "bbox_min": [
        25.0,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        25.0,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        90.0,
        1210.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        25.000017166137695,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        25.000017166137695,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        90.1213607788086
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        30.90899085998535,
        888.92041015625,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        30.90899085998535,
        888.92041015625,
        82.0
      ],
      "bbox_max": [
        79.34313201904297,
        946.42431640625,
        98.39308166503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        30.90899085998535,
        888.92041015625,
        82.0
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        88.12139892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15402749180793762,
        -0.06380031257867813,
        0.9860045313835144
      ],
      "plane_d": -35.5994873046875,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1050.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        867.943359375,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        0.0,
        867.943359375,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        0.0,
        867.943359375,
        92.26585388183594
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        868.2676391601562,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        82.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        82.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        0.0,
        868.2676391601562,
        82.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        3.8616164488303184e-08,
        868.2676391601562,
        92.26585388183594
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      "bbox_max": [
        60.18052291870117,
        900.8079833984375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14221441745758057,
        -0.14221446216106415,
        0.9795662760734558
      ],
      "plane_d": 33.228851318359375,
      "bbox_min": [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      "bbox_max": [
        58.09315490722656,
        900.8079833984375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "bbox_max": [
        48.70002746582031,
        900.8079833984375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      "bbox_max": [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        0.0,
        820.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.10742999613285065,
        -0.10743003338575363,
        0.9883914589881897
      ],
      "plane_d": -0.7341842651367188,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        901.0050659179688,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        122.47760772705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        980.9871215820312,
        104.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        122.47760772705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        0.195090189576149,
        0.0
      ],
      "plane_d": -77.39594268798828,
      "bbox_min": [
        116.21810150146484,
        980.9871215820312,
        120.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        122.47760772705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        901.0050659179688,
        104.0
      ],
      "bbox_max": [
        79.34313201904297,
        1050.0,
        115.95610809326172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        115.95610809326172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        0.0,
        1040.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        115.95610809326172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        0.0,
        1040.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1040.0,
        114.86918640136719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07021608203649521,
        -0.1695162057876587,
        0.983022928237915
      ],
      "plane_d": 53.9408073425293,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0694173201918602,
        -0.16758783161640167,
        0.9834102392196655
      ],
      "plane_d": 52.008216857910156,
      "bbox_min": [
        0.0,
        901.0050659179688,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        0.0,
        901.0050659179688,
        104.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        967.471923828125,
        119.21685028076172
      ],
      "bbox_max": [
        120.0,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        0.195090189576149,
        0.0
      ],
      "plane_d": -77.39594268798828,
      "bbox_min": [
        113.52976989746094,
        967.471923828125,
        120.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        0.0,
        901.0050659179688,
        104.0
      ],
      "bbox_max": [
        79.34313201904297,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1040.0,
        114.86918640136719
      ],
      "bbox_max": [
        10.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        114.86918640136719
      ],
      "bbox_max": [
        10.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        79.34313201904297,
        934.9437866210938,
        114.0
      ],
      "bbox_max": [
        117.84325408935547,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        79.34313201904297,
        946.42431640625,
        114.0
      ],
      "bbox_max": [
        91.6667251586914,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        123.8823471069336
      ],
      "bbox_max": [
        91.6667251586914,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807852506637573,
        0.19509023427963257,
        2.494266198027617e-07
      ],
      "plane_d": -77.39603424072266,
      "bbox_min": [
        107.05951690673828,
        934.9437866210938,
        114.0
      ],
      "bbox_max": [
        117.84325408935547,
        989.1572875976562,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807852506637573,
        0.19509023427963257,
        2.494266198027617e-07
      ],
      "plane_d": -77.39603424072266,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        117.71638488769531,
        1000.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        79.34313201904297,
        946.42431640625,
        114.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        15.056183815002441,
        842.9404907226562,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807852506637573,
        0.19509023427963257,
        2.494266198027617e-07
      ],
      "plane_d": -77.39603424072266,
      "bbox_min": [
        0.0,
        839.9456176757812,
        126.0
      ],
      "bbox_max": [
        120.0,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        0.0,
        839.9456176757812,
        126.0
      ],
      "bbox_max": [
        107.05952453613281,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.5555705428123474,
        0.0
      ],
      "plane_d": -430.4105224609375,
      "bbox_min": [
        0.0,
        839.9456176757812,
        126.0
      ],
      "bbox_max": [
        107.05952453613281,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        126.0
      ],
      "bbox_max": [
        15.056182861328125,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        10.0,
        1040.0,
        126.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        144.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}